/** UI strings: [Russian, English]. Placeholders use {name}. */
export const messages = {
  // common
  'common.cancel': ['Отмена', 'Cancel'],
  'common.stepperHint': [
    'Клик — шаг (Shift ×10). Зажмите и тяните вверх или вниз',
    'Click to step (Shift ×10). Hold and drag up or down',
  ],
  'common.confirm': ['Подтвердить', 'Confirm'],
  'common.copied': ['Скопировано', 'Copied'],
  'common.create': ['Создать', 'Create'],
  'common.delete': ['Удалить', 'Delete'],
  'renders.deleteSelected': ['Удалить выбранные ({n})', 'Delete selected ({n})'],
  'renders.deleteAll': ['Удалить все', 'Delete all'],
  'renders.selectAll': ['Выбрать все', 'Select all'],
  'renders.deleteTitle': ['Удалить генерацию?', 'Delete this render?'],
  'renders.deleteSelectedTitle': [
    'Удалить выбранные генерации ({n})?',
    'Delete {n} selected renders?',
  ],
  'renders.deleteAllTitle': ['Удалить все генерации?', 'Delete all renders?'],
  'renders.deleteFilteredTitle': [
    'Удалить все генерации по выбранным фильтрам?',
    'Delete all renders matching the filters?',
  ],
  'renders.deleteText': [
    'Файлы удалятся навсегда. Использованные генерации в лимите тарифа не вернутся.',
    'Files are deleted for good. Renders already used from your plan are not refunded.',
  ],
  'renders.deleted': ['Удалено: {n}', 'Deleted: {n}'],
  'renders.skippedRunning': ['Ещё в работе, не удалены: {n}', 'Still rendering, not deleted: {n}'],
  'batch.delete': ['Удалить запуск', 'Delete run'],
  'batch.deleteTitle': [
    'Удалить запуск и все его генерации?',
    'Delete this run and all its renders?',
  ],
  'batch.deleteText': [
    'Удалятся все изображения запуска и ZIP-архив. Использованные генерации в лимите тарифа не вернутся.',
    'All images of the run and its ZIP archive are deleted. Renders already used from your plan are not refunded.',
  ],
  'automation.deleteWithRenders': [
    'Удалить и все сгенерированные баннеры',
    'Also delete every banner it generated',
  ],
  'err.batchRunning': [
    'Запуск ещё идёт — удалить можно после завершения.',
    'The run is still in progress — delete it once it finishes.',
  ],
  'err.renderRunning': [
    'Генерация ещё в работе — удалить можно после завершения.',
    'The render is still in progress — delete it once it finishes.',
  ],
  'audit.renders.deleted': ['Удалены генерации:', 'Renders deleted:'],
  'common.download': ['Скачать', 'Download'],
  'common.edit': ['Редактировать', 'Edit'],
  'common.error': ['Ошибка', 'Error'],
  'common.height': ['Высота', 'Height'],
  'common.width': ['Ширина', 'Width'],
  'common.import': ['Импорт', 'Import'],
  'nav.admin': ['Админка', 'Admin'],
  'billing.testMode': ['Тестовый режим суперадмина', 'Superadmin test mode'],
  'billing.testModeHint': [
    'Тариф этого пространства меняется сразу, без оплаты — чтобы проверить ограничения.',
    'Switches this workspace’s plan instantly without payment — to check the limits.',
  ],
  'billing.manual': ['вручную', 'manual'],
  'admin.title': ['Админка', 'Admin'],
  'admin.description': [
    'Все пользователи и пространства платформы. Видно только суперадминам.',
    'All users and workspaces on the platform. Visible to superadmins only.',
  ],
  'admin.overview': ['Обзор', 'Overview'],
  'admin.users': ['Пользователи', 'Users'],
  'admin.usersHint': ['+{n7} за 7 дней · +{n30} за 30 дней', '+{n7} in 7 days · +{n30} in 30 days'],
  'admin.active7': ['Входили за 7 дней', 'Signed in, 7 days'],
  'admin.blockedN': ['Заблокировано: {n}', 'Blocked: {n}'],
  'admin.renders30': ['Генераций за 30 дней', 'Renders, 30 days'],
  'admin.rendersHint': ['Сегодня {today} · ошибок {failed}', 'Today {today} · failed {failed}'],
  'admin.mrr': ['MRR (подписки)', 'MRR (subscriptions)'],
  'admin.paying': ['Платящих пространств: {n}', 'Paying workspaces: {n}'],
  'admin.workspacesByPlan': ['Пространства по тарифам · {n}', 'Workspaces by plan · {n}'],
  'admin.ai30': ['AI за 30 дней', 'AI, 30 days'],
  'admin.aiRequests': ['запросов', 'requests'],
  'admin.aiCost': ['расход на модель', 'model cost'],
  'admin.search': ['Поиск по email или названию', 'Search by email or name'],
  'admin.user': ['Пользователь', 'User'],
  'admin.workspaces': ['Пространства', 'Workspaces'],
  'admin.workspace': ['Пространство', 'Workspace'],
  'admin.signedUp': ['Регистрация', 'Signed up'],
  'admin.lastLogin': ['Последний вход', 'Last sign-in'],
  'admin.sessions': ['активных сессий: {n}', 'active sessions: {n}'],
  'admin.blocked': ['заблокирован', 'blocked'],
  'admin.block': ['Заблокировать', 'Block'],
  'admin.unblock': ['Разблокировать', 'Unblock'],
  'admin.blockTitle': ['Заблокировать {email}?', 'Block {email}?'],
  'admin.blockText': [
    'Пользователь выйдет со всех устройств и не сможет войти, пока вы его не разблокируете. Его пространства и API-ключи продолжат работать.',
    'The user is signed out everywhere and can’t sign in until unblocked. Their workspaces and API keys keep working.',
  ],
  'admin.blockedDone': ['Пользователь заблокирован', 'User blocked'],
  'admin.unblockedDone': ['Пользователь разблокирован', 'User unblocked'],
  'admin.signOut': ['Выйти со всех устройств', 'Sign out everywhere'],
  'admin.signedOutDone': ['Сессии завершены', 'Sessions ended'],
  'admin.delete': ['Удалить', 'Delete'],
  'admin.deleteTitle': ['Удалить {email}?', 'Delete {email}?'],
  'admin.deleteText': [
    'Аккаунт удаляется безвозвратно вместе с пространствами, где пользователь единственный участник: шаблоны, файлы, рендеры. Если он владеет общим пространством или у него платная подписка, удаление будет отклонено.',
    'The account is deleted for good, along with workspaces where they are the only member: templates, files and renders. Refused while they own a shared workspace or have a paid subscription.',
  ],
  'admin.deletedDone': ['Пользователь удалён', 'User deleted'],
  'admin.plan': ['Тариф', 'Plan'],
  'admin.planSet': ['«{name}» теперь на тарифе {plan}', '“{name}” is now on {plan}'],
  'admin.manual': ['вручную', 'manual'],
  'admin.templates': ['Шаблоны', 'Templates'],
  'admin.renders30short': ['Генерации 30д', 'Renders 30d'],
  'admin.storage': ['Файлы', 'Storage'],
  'admin.lastRender': ['Последняя генерация', 'Last render'],
  'admin.members': ['участников: {n}', 'members: {n}'],
  'common.back': ['Назад', 'Back'],
  'common.next': ['Далее', 'Next'],
  'legal.privacy': ['Политика конфиденциальности', 'Privacy Policy'],
  'legal.terms': ['Условия использования', 'Terms of Service'],
  'legal.privacyLower': ['политикой конфиденциальности', 'Privacy Policy'],
  'legal.termsLower': ['условиями использования', 'Terms of Service'],
  'legal.and': ['и', 'and'],
  'legal.consentPrefix': ['Регистрируясь, вы соглашаетесь с', 'By signing up, you agree to the'],
  'legal.updated': ['Обновлено {date}', 'Last updated {date}'],
  'legal.home': ['На главную', 'Back to home'],
  'help.title': ['Помощь и документы', 'Help & legal'],
  'help.support': ['Поддержка', 'Support'],
  'help.apiDocs': ['Документация API', 'API reference'],
  'help.apiDocsHint': ['Эндпоинты, параметры, примеры', 'Endpoints, parameters, examples'],
  'help.termsHint': ['Правила использования сервиса', 'Rules for using the service'],
  'help.privacyHint': ['Какие данные мы храним и зачем', 'What data we keep and why'],
  'preview.final': ['Чистовой рендер без водяного знака', 'Final render without watermark'],
  'preview.watermarkHint': [
    'Бесплатно: превью с водяным знаком не тратит лимит тарифа.',
    "Free: a watermarked preview doesn't use your plan.",
  ],
  'preview.finalHint': ['Спишет 1 генерацию из лимита тарифа.', 'Uses 1 render from your plan.'],
  'billing.fPreviews': ['Бесплатные превью с водяным знаком', 'Free watermarked previews'],
  'showcase.badge': ['Редактор', 'Editor'],
  'showcase.title': [
    'Редактор, который сам держит макет',
    'An editor that keeps the layout in shape',
  ],
  'showcase.subtitle': [
    'Не просто холст с координатами: стеки как во Figma, умная адаптация под любой размер и точные отступы. Переключите размер — это настоящий рендер.',
    'Not just a canvas with coordinates: Figma-like stacks, smart resizing to any size and precise spacing. Switch the size — this is a real render.',
  ],
  'showcase.render': ['Сгенерировать', 'Generate'],
  'showcase.layers': ['Слои', 'Layers'],
  'showcase.clickHint': ['Кликните по слою или смените размер', 'Click a layer or switch the size'],
  'showcase.layer': ['Слой', 'Layer'],
  'showcase.apiField': [
    'Имя слоя = поле в API и колонка таблицы',
    'Layer name = API field and table column',
  ],
  'showcase.stack': ['Стек (автолейаут)', 'Stack (auto layout)'],
  'showcase.resize': ['Смена размера', 'Resizing'],
  'showcase.resizeText': [
    'Слои адаптируются по своим привязкам — один шаблон на все площадки.',
    'Layers adapt by their rules — one template for every platform.',
  ],
  'showcase.altHint': ['Alt — отступы до соседей', 'Alt — distances to neighbours'],
  'showcase.p1Title': ['Стеки как во Figma', 'Figma-like stacks'],
  'showcase.p1Text': [
    'Длинный текст из API раздвигает соседей, а не наезжает на них.',
    'Long text from the API pushes neighbours instead of overlapping them.',
  ],
  'showcase.p2Title': ['Один шаблон — все размеры', 'One template, every size'],
  'showcase.p2Text': [
    'Пост, сторис и баннер из одного макета с адаптацией слоёв.',
    'Post, story and banner from one design, with layers adapted.',
  ],
  'showcase.p3Title': ['Точные отступы', 'Precise spacing'],
  'showcase.p3Text': [
    'Привязки, направляющие и расстояния до соседей по Alt.',
    'Snapping, guides and distances to neighbours with Alt.',
  ],
  'showcase.p4Title': ['Готово к автоматизации', 'Ready for automation'],
  'showcase.p4Text': [
    'Каждый слой сразу доступен в API, таблицах и ссылках.',
    'Every layer is instantly available in the API, tables and links.',
  ],
  'motionShowcase.badge': ['Анимация', 'Animation'],
  'motionShowcase.title': [
    'Статичный баннер — в анимацию одним кликом',
    'Static banner to animation in one click',
  ],
  'motionShowcase.subtitle': [
    'Нажмите «Оживить»: заголовок, фото, цена и кнопка сами получат своё движение. Без таймлайна и ключевых кадров.',
    'Press Animate: the headline, photo, price and button each get their own motion. No timeline, no keyframes.',
  ],
  'motionShowcase.static': ['Статика', 'Static'],
  'motionShowcase.animated': ['Анимация', 'Animated'],
  'motionShowcase.formats': ['MP4 · WebM · GIF', 'MP4 · WebM · GIF'],
  'motionShowcase.hint': [
    'Это живой рендер: переключайте стили',
    'This is a live render: switch the styles',
  ],
  'motionShowcase.p1Title': ['Один клик', 'One click'],
  'motionShowcase.p1Text': [
    'Сервис сам понимает, где заголовок, фото, цена и кнопка, и ставит каждому слою своё появление по порядку чтения.',
    'It works out which layer is the headline, photo, price or button and gives each its own entrance in reading order.',
  ],
  'motionShowcase.p2Title': ['Стили под задачу', 'A style for every job'],
  'motionShowcase.p2Text': [
    'Плавный, энергичный, распродажа, кинетика, элегантный и другие. Результат можно доработать вручную.',
    'Smooth, energetic, sale, kinetic, elegant and more. Fine-tune the result by hand if you like.',
  ],
  'motionShowcase.p3Title': ['Сотни анимированных креативов', 'Hundreds of animated creatives'],
  'motionShowcase.p3Text': [
    'Тот же шаблон из таблицы, фида или API отдаёт MP4, WebM и GIF во всех размерах, включая сторис и Reels.',
    'The same template fed from a sheet, a feed or the API renders MP4, WebM and GIF in every size, Stories and Reels included.',
  ],
  'previewMode.title': ['Режим превью', 'Preview mode'],
  'previewMode.text': [
    'Все генерации пространства — через API, автоматизации, ссылки и редактор — идут с водяным знаком и не тратят лимит. Удобно, чтобы настроить интеграцию; выключите, когда всё готово.',
    'Every render in the workspace — API, automations, links and the editor — gets a watermark and doesn’t use your quota. Handy while setting up an integration; turn it off when ready.',
  ],
  'previewMode.on': ['Режим превью включён', 'Preview mode is on'],
  'previewMode.off': ['Режим превью выключен', 'Preview mode is off'],
  'previewMode.banner': [
    'Режим превью: все генерации с водяным знаком и не тратят лимит.',
    'Preview mode: all renders are watermarked and don’t use your quota.',
  ],
  'previewMode.manage': ['Выключить', 'Turn off'],
  'linked.masterChip': ['Набор: {n} разм.', 'Set: {n} sizes'],
  'linked.sizeChip': ['Размер набора «{name}»', 'Size of “{name}”'],
  'linked.changedN': ['изменено: {n}', 'changed: {n}'],
  'linked.setTitle': ['Связанные размеры', 'Linked sizes'],
  'linked.addSize': ['Добавить размер', 'Add a size'],
  'linked.addSizeHint': [
    'Тот же дизайн в другом размере. Правки оригинала переносятся во все размеры, а ручные правки размера сохраняются',
    'The same design in another size. Edits of the original reach every size; hand edits of a size are kept',
  ],
  'linked.addSizeTileHint': [
    'Сторис, пост, баннер — правки переносятся',
    'Story, post, banner: edits carry over',
  ],
  'linked.resetAll': ['Сбросить все изменения этого размера', 'Reset all changes of this size'],
  'linked.unlink': ['Отвязать от оригинала', 'Unlink from the original'],
  'linked.masterHint': [
    'Изменения этого шаблона автоматически переносятся во все размеры. То, что поменяли вручную в размере, сохраняется.',
    'Changes to this template flow into every size. What was changed by hand in a size is kept.',
  ],
  'linked.sizeHint': [
    'Правки оригинала приходят сюда автоматически. Слои, изменённые здесь, отмечены точкой и не перезаписываются.',
    'Edits of the original arrive here automatically. Layers changed here are marked with a dot and not overwritten.',
  ],
  'linked.layerChanged': [
    'Изменено в этом размере — правки оригинала не перезапишут',
    'Changed in this size — edits of the original won’t overwrite it',
  ],
  'linked.resetLayer': ['Как в оригинале', 'Reset'],
  'linked.changesTitle': ['Изменено в этом размере', 'Changed in this size'],
  'linked.changesHint': [
    'Что этот размер изменил относительно оригинала, и сброс',
    'What this size changed from the original, and how to reset it',
  ],
  'linked.selectLayer': ['Выбрать слой', 'Select the layer'],
  'linked.resetLayerHint': [
    'Вернуть слой как в оригинале',
    'Make the layer as in the original again',
  ],
  'linked.resetAdded': ['Убрать', 'Remove'],
  'linked.resetRemoved': ['Вернуть', 'Restore'],
  'linked.changeAdded': ['есть только в этом размере', 'only in this size'],
  'linked.changeRemoved': ['удалён в этом размере', 'deleted in this size'],
  'linked.propPosition': ['положение', 'position'],
  'linked.propSize': ['размер', 'size'],
  'linked.propRotation': ['поворот', 'rotation'],
  'linked.propLayout': ['раскладка', 'layout'],
  'linked.propText': ['текст', 'text'],
  'linked.propFont': ['шрифт', 'font'],
  'linked.propColor': ['цвет', 'colour'],
  'linked.propImage': ['картинка', 'image'],
  'linked.propVisibility': ['видимость', 'visibility'],
  'linked.propMotion': ['анимация', 'animation'],
  'linked.propOther': ['свойства', 'properties'],
  'linked.option': ['Связать с оригиналом', 'Link to the original'],
  'linked.optionHint': [
    'Изменения оригинала будут сами приходить в этот размер, а ваши правки в нём — сохраняться.',
    'Changes to the original flow into this size automatically; your edits in it are kept.',
  ],
  'linked.optionPaid': [
    'Связанные размеры — на тарифах Pro и Business: правите один шаблон, обновляются все размеры.',
    'Linked sizes are on Pro and Business: edit one template, every size updates.',
  ],
  'linked.badgeSize': ['размер набора', 'linked size'],
  'linked.badgeMaster': ['набор · {n}', 'set · {n}'],
  'billing.fLinked': ['Связанные размеры', 'Linked sizes'],
  'quality.title': ['Проверка качества', 'Quality check'],
  'quality.found': ['{n} из {total} баннеров с проблемами', '{n} of {total} banners have issues'],
  'quality.clean': [
    'Проверка качества: проблем не найдено ({total})',
    'Quality check: no issues found ({total})',
  ],
  'quality.checking': [
    'Проверяем качество по мере генерации…',
    'Checking quality as images are rendered…',
  ],
  'quality.hint': [
    'Обрезанный или сильно уменьшенный текст, незагруженные и размытые картинки, слои за пределами холста.',
    'Cut-off or heavily shrunk text, missing or blurry images, layers outside the canvas.',
  ],
  'quality.showIssues': ['Показать только с проблемами', 'Show only with issues'],
  'quality.showAll': ['Показать все', 'Show all'],
  'quality.markerTitle': ['Проблем: {n}', 'Issues: {n}'],
  'issue.text_overflow': ['текст не помещается и обрезан', 'text doesn’t fit and is cut off'],
  'issue.text_shrunk': [
    'текст уменьшен с {from} до {to} px, чтобы поместиться',
    'text shrunk from {from} to {to} px to fit',
  ],
  'issue.image_missing': ['картинка не загрузилась', 'image failed to load'],
  'issue.image_lowres': [
    'картинка {width}×{height} растянута в {upscale}× — будет размытой',
    '{width}×{height} image stretched {upscale}× — it will look blurry',
  ],
  'issue.offcanvas': ['слой за пределами холста', 'layer is outside the canvas'],
  'linked.original': ['оригинал', 'original'],
  'linked.setHeader': ['Набор «{name}»', 'Set “{name}”'],
  'linked.setCount': ['{n} разм.', '{n} sizes'],
  'linked.setHint': [
    'правки оригинала переходят во все размеры',
    'edits of the original flow into every size',
  ],
  'linked.filterAll': ['Все', 'All'],
  'linked.filterSets': ['Наборы', 'Sets'],
  'linked.filterSingles': ['Отдельные', 'Single'],
  'linked.backToAll': ['Все шаблоны', 'All templates'],
  'linked.allSizes': ['Все размеры', 'All sizes'],
  'linked.allSizesHint': [
    'Показать все размеры набора рядом на одном холсте. Правки оригинала сразу видны во всех размерах',
    'Show every size of the set side by side on one canvas. Edits to the original show up in every size at once',
  ],
  'linked.openSize': ['Нажмите, чтобы редактировать этот размер', 'Click to edit this size'],
  'linked.fitAll': ['Показать все размеры', 'Fit all sizes'],
  'linked.fitCurrent': ['Только открытый размер', 'Open size only'],
  'editor.paddingX': ['Слева и справа', 'Left and right'],
  'editor.paddingY': ['Сверху и снизу', 'Top and bottom'],
  'editor.paddingSides': ['Отдельно для каждой стороны', 'Each side separately'],
  'editor.paddingAxes': ['По горизонтали и вертикали', 'Horizontal and vertical'],
  'editor.pad_top': ['Сверху', 'Top'],
  'editor.pad_right': ['Справа', 'Right'],
  'editor.pad_bottom': ['Снизу', 'Bottom'],
  'editor.pad_left': ['Слева', 'Left'],
  'billing.status.active': ['активна', 'active'],
  'billing.status.trialing': ['пробный период', 'trial'],
  'billing.status.past_due': ['оплата не прошла', 'payment failed'],
  'billing.status.unpaid': ['не оплачена', 'unpaid'],
  'billing.status.canceled': ['отменена', 'cancelled'],
  'billing.status.expired': ['закончилась', 'ended'],
  'billing.card': ['Карта {brand} •••• {last4}', '{brand} card •••• {last4}'],
  'billing.graceTitle': ['Оплата не прошла', 'Payment failed'],
  'billing.graceText': [
    'Обновите способ оплаты — иначе после {date} пространство перейдёт с тарифа {plan} на Free.',
    'Update the payment method — otherwise after {date} the workspace moves from {plan} to Free.',
  ],
  'billing.unpaidTitle': ['Подписка приостановлена', 'Subscription suspended'],
  'billing.unpaidText': [
    'Мы не получили оплату, поэтому пространство работает на тарифе Free. Обновите карту — тариф вернётся сразу после оплаты.',
    'We didn’t receive the payment, so the workspace is on the Free plan. Update the card — the plan comes back right after the payment.',
  ],
  'billing.updateCard': ['Обновить способ оплаты', 'Update payment method'],
  'billing.history': ['История платежей', 'Payment history'],
  'billing.invoice': ['Счёт', 'Invoice'],
  'billing.reason.initial': ['Оформление подписки', 'Subscription'],
  'billing.reason.renewal': ['Продление', 'Renewal'],
  'billing.reason.update': ['Смена тарифа', 'Plan change'],
  'billing.graceBanner': [
    'Оплата не прошла — тариф работает до {date}:',
    'Payment failed — the plan works until {date}:',
  ],
  'billing.graceBannerLink': ['Обновить карту', 'Update card'],
  'admin.prices': ['Цены', 'Prices'],
  'admin.pricesHint': [
    'Цены тарифов в каждой валюте. Посетители видят валюту своей страны, а списание идёт в {currency}.',
    'Plan prices in each currency. Visitors see the currency of their country; payments are charged in {currency}.',
  ],
  'admin.currencyOn': ['Показывать', 'Offer'],
  'admin.perMonth': ['за месяц', 'per month'],
  'admin.perYear': ['за год', 'per year'],
  'admin.pricesSaved': ['Цены сохранены', 'Prices saved'],
  'admin.pricesReset': ['Цены по умолчанию', 'Default prices'],
  'admin.chargeCurrency': ['валюта оплаты', 'payment currency'],
  'billing.chargedMonth': ['Списание: {amount} в месяц', 'Charged {amount} per month'],
  'billing.chargedYear': ['Списание: {amount} в год', 'Charged {amount} per year'],
  'billing.billedYearly': ['{amount} при оплате за год', '{amount} billed yearly'],
  // errors
  'err.network': [
    'Нет связи с сервером. Проверьте интернет и попробуйте ещё раз.',
    'Can’t reach the server. Check your connection and try again.',
  ],
  'err.seePlans': ['Тарифы', 'See plans'],
  'err.internal': [
    'Что-то пошло не так на нашей стороне. Попробуйте ещё раз через минуту.',
    'Something went wrong on our side. Try again in a minute.',
  ],
  'err.validation': ['Проверьте заполненные поля.', 'Check the highlighted fields.'],
  'err.notFound': [
    'Не найдено — возможно, это уже удалили.',
    'Not found — it may have been deleted.',
  ],
  'err.forbidden': [
    'Недостаточно прав для этого действия.',
    'You don’t have permission to do this.',
  ],
  'err.tooLarge': ['Файл слишком большой.', 'The file is too large.'],
  'err.rateLimited': [
    'Слишком много запросов. Попробуйте через {seconds} с.',
    'Too many requests. Try again in {seconds} s.',
  ],
  'err.signIn': [
    'Сессия закончилась — войдите ещё раз.',
    'Your session has ended — please sign in again.',
  ],
  'err.notMember': [
    'Вы не участник этого пространства.',
    'You are not a member of this workspace.',
  ],
  'err.roleRequired': ['Нужна роль «{role}» или выше.', 'This needs the “{role}” role or higher.'],
  'err.templateLimit': [
    'На вашем тарифе можно до {limit} шаблонов. Перейдите на тариф выше, чтобы создать больше.',
    'Your plan allows up to {limit} templates. Upgrade to create more.',
  ],
  'err.membersLimit': [
    'На вашем тарифе можно до {limit} участников. Перейдите на тариф выше, чтобы пригласить больше.',
    'Your plan allows up to {limit} members. Upgrade to invite more people.',
  ],
  'err.automationsLimit': [
    'На вашем тарифе можно до {limit} автоматизаций. Перейдите на тариф выше, чтобы добавить ещё.',
    'Your plan allows up to {limit} automations. Upgrade to add more.',
  ],
  'err.customSizesLimit': [
    'На тарифе {plan} можно сохранить до {limit} своих размеров.',
    'The {plan} plan allows up to {limit} custom sizes.',
  ],
  'err.customSizesPlan': [
    'Свои размеры недоступны на тарифе {plan}. Перейдите на тариф выше, чтобы сохранять их.',
    'Custom sizes aren’t available on the {plan} plan. Upgrade to save them.',
  ],
  'err.rendersLimit': [
    'Месячный лимит генераций исчерпан ({used} из {limit} на тарифе {plan}). Перейдите на тариф выше, чтобы продолжить.',
    'You’ve used this month’s renders ({used} of {limit} on the {plan} plan). Upgrade to continue.',
  ],
  'err.aiLimit': [
    'Месячный лимит AI-запросов исчерпан ({used} из {limit} на тарифе {plan}).',
    'You’ve used this month’s AI requests ({used} of {limit} on the {plan} plan).',
  ],
  'err.storageLimit': [
    'Хранилище заполнено (лимит {mb} МБ). Удалите ненужные файлы или перейдите на тариф выше.',
    'Storage is full ({mb} MB limit). Delete unused files or upgrade.',
  ],
  'err.batchLimit': [
    'За один запуск на тарифе {plan} — до {limit} изображений (запрошено {requested}).',
    'The {plan} plan renders up to {limit} images per run ({requested} requested).',
  ],
  'err.scaleLimit': [
    'Масштаб {scale}× недоступен на тарифе {plan} (максимум {max}×).',
    'Scale {scale}× isn’t available on the {plan} plan (max {max}×).',
  ],
  'err.scaleTooLarge': [
    'Шаблон «{name}» можно увеличить максимум в {max}x: картинка — не больше {side} px по стороне и {mpx} Мп.',
    'Template “{name}” can be scaled up to {max}x at most: images stay within {side} px per side and {mpx} Mpx.',
  ],
  'err.outputTooLarge': [
    'Картинка получилась бы {width}×{height} px, а максимум — {max} px по стороне. Уменьшите масштаб.',
    'The image would be {width}×{height} px; the maximum is {max} px per side. Use a smaller scale.',
  ],
  'err.linkedSizesPlan': [
    'Связанные размеры доступны на тарифе Pro и выше.',
    'Linked sizes are available on the Pro plan and above.',
  ],
  'err.customFontsPlan': [
    'Свои шрифты доступны на тарифе Pro и выше.',
    'Custom fonts are available on the Pro plan and above.',
  ],
  'err.integrationsPlan': [
    'Google Drive и S3 доступны на платных тарифах.',
    'Google Drive and S3 are available on paid plans.',
  ],
  'err.schedulePlan': [
    'Запуск по расписанию доступен на тарифе Pro и выше.',
    'Scheduled runs are available on the Pro plan and above.',
  ],
  'err.signedUrlsPlan': [
    'Подписанные ссылки на картинки доступны на платных тарифах.',
    'Signed image links are available on paid plans.',
  ],
  'err.templateInvalid': [
    'Шаблон повреждён и не может быть сохранён. Обновите страницу и попробуйте снова.',
    'The template is damaged and can’t be saved. Reload the page and try again.',
  ],
  'err.sizeRange': [
    'Ширина и высота — целые числа от {min} до {max} px.',
    'Width and height must be whole numbers from {min} to {max} px.',
  ],
  'err.templateConflict': [
    'Шаблон изменили в другой вкладке или коллега. Обновите страницу, чтобы получить последнюю версию.',
    'This template was changed in another tab or by a teammate. Reload to get the latest version.',
  ],
  'err.notLinkedSize': [
    'Этот шаблон не связан с основным.',
    'This template isn’t linked to a master.',
  ],
  'err.layerInvalid': ['Слой «{layer}»: {detail}', 'Layer “{layer}”: {detail}'],
  'err.batchEmpty': [
    'Нечего генерировать: нет ни одной строки.',
    'Nothing to render: there are no rows.',
  ],
  'err.zipNotReady': [
    'Архив ещё готовится — подождите немного.',
    'The ZIP is still being prepared — give it a moment.',
  ],
  'err.fileTooLarge': [
    'Файл слишком большой: максимум {mb} МБ.',
    'The file is too large: {mb} MB max.',
  ],
  'err.imageType': [
    'Поддерживаются картинки PNG, JPG, WEBP, GIF, AVIF и SVG, видео MP4, MOV и WEBM и музыка MP3, M4A, WAV, OGG и FLAC.',
    'Supported: PNG, JPG, WEBP, GIF, AVIF and SVG images, MP4, MOV and WEBM videos and MP3, M4A, WAV, OGG and FLAC audio.',
  ],
  'err.imageDownload': [
    'Не удалось скачать картинку по ссылке (HTTP {status}).',
    'Couldn’t download the image from the link (HTTP {status}).',
  ],
  'err.urlUnreachable': [
    'Ссылка недоступна. Проверьте адрес — он должен быть публичным.',
    'The link can’t be reached. Check the address — it must be public.',
  ],
  'err.noFile': ['Выберите файл.', 'Choose a file.'],
  'err.fontType': [
    'Загрузите шрифт в формате TTF, OTF, WOFF или WOFF2.',
    'Upload a TTF, OTF, WOFF or WOFF2 font.',
  ],
  'err.fontFamilyRequired': ['Укажите название шрифта.', 'Enter the font name.'],
  'err.csvParse': ['Не удалось прочитать CSV: {detail}', 'Couldn’t read the CSV: {detail}'],
  'err.jsonInvalid': ['По ссылке не JSON.', 'The link doesn’t return JSON.'],
  'err.jsonShape': [
    'JSON должен быть списком объектов (или {"rows": [...]}).',
    'JSON must be a list of objects (or {"rows": [...]}).',
  ],
  'err.sheetLink': [
    'Это не похоже на ссылку на Google Таблицу.',
    'This doesn’t look like a Google Sheets link.',
  ],
  'err.sheetPrivate': [
    'Таблица закрыта. Откройте доступ «Всем, у кого есть ссылка» или подключите аккаунт Google.',
    'The sheet is private. Share it with “Anyone with the link” or connect a Google account.',
  ],
  'err.sourceAccessDenied': [
    'Нет доступа к данным (HTTP {status}).',
    'Access to the data was denied (HTTP {status}).',
  ],
  'err.sourceHttp': [
    'Источник данных ответил ошибкой (HTTP {status}).',
    'The data source returned an error (HTTP {status}).',
  ],
  'err.sourceEmpty': ['В источнике данных нет строк.', 'The data source has no rows.'],
  'err.noHeaderRow': ['В файле нет строки с заголовками колонок.', 'The file has no header row.'],
  'err.apiSource': [
    'Эта автоматизация получает строки через API — запустите её запросом POST /v1/automations/{id}/runs.',
    'This automation gets its rows through the API — run it with POST /v1/automations/{id}/runs.',
  ],
  'err.apiRowsRequired': [
    'Передайте строки («rows») для запуска.',
    'Pass the rows (“rows”) to run it.',
  ],
  'err.templatesMissing': [
    'Некоторые выбранные шаблоны не найдены — выберите их заново.',
    'Some selected templates no longer exist — pick them again.',
  ],
  'err.templatesGone': [
    'Выбранных шаблонов больше нет — выберите другие.',
    'The selected templates no longer exist — pick others.',
  ],
  'err.scheduleApi': [
    'Автоматизацию с данными из API нельзя запускать по расписанию.',
    'Automations with API data can’t run on a schedule.',
  ],
  'err.cronInvalid': ['Расписание задано неверно.', 'The schedule is invalid.'],
  'err.endpointInvalid': ['Адрес сервера: {detail}', 'Endpoint: {detail}'],
  'err.bucketWrite': [
    'Не удалось записать в бакет: {detail}',
    'Couldn’t write to the bucket: {detail}',
  ],
  'err.signupsDisabled': [
    'Регистрация на этом сервере закрыта.',
    'Sign-ups are closed on this server.',
  ],
  'err.emailTaken': [
    'Аккаунт с этим email уже есть — войдите.',
    'An account with this email already exists — sign in instead.',
  ],
  'err.badCredentials': ['Неверный email или пароль.', 'Wrong email or password.'],
  'err.accountBlocked': [
    'Аккаунт заблокирован. Напишите в поддержку.',
    'This account is blocked. Contact support.',
  ],
  'err.resetInvalid': [
    'Ссылка для сброса пароля недействительна или устарела — запросите новую.',
    'This reset link is invalid or has expired — request a new one.',
  ],
  'err.wrongPassword': ['Текущий пароль указан неверно.', 'The current password is wrong.'],
  'err.googleDisabled': [
    'Google не подключён на этом сервере.',
    'Google isn’t set up on this server.',
  ],
  'err.googleError': ['Google вернул ошибку: {detail}', 'Google returned an error: {detail}'],
  'err.googleNoRefresh': [
    'Google не выдал постоянный доступ. Удалите доступ приложения в настройках аккаунта Google и подключите снова.',
    'Google didn’t grant lasting access. Remove the app’s access in your Google account and connect again.',
  ],
  'err.googleNoEmail': [
    'У аккаунта Google нет подтверждённого email.',
    'Your Google account has no verified email.',
  ],
  'err.googleOtherAccount': [
    'Этот email привязан к другому аккаунту Google.',
    'This email is linked to another Google account.',
  ],
  'err.ownerOnlyTransfer': [
    'Передать права владельца может только владелец.',
    'Only the owner can transfer ownership.',
  ],
  'err.lastOwner': [
    'В пространстве должен остаться хотя бы один владелец.',
    'A workspace needs at least one owner.',
  ],
  'err.ownerOnlyRemoveOwner': [
    'Удалить владельца может только владелец.',
    'Only an owner can remove an owner.',
  ],
  'err.inviteOwner': [
    'Пригласите как администратора, а права владельца передайте потом.',
    'Invite them as an admin and transfer ownership later.',
  ],
  'err.alreadyMember': ['Этот человек уже в пространстве.', 'This person is already a member.'],
  'err.invitationInvalid': [
    'Приглашение недействительно или устарело.',
    'This invitation is invalid or has expired.',
  ],
  'err.invitationOtherEmail': [
    'Приглашение отправлено на {email}. Войдите с этим email, чтобы принять его.',
    'This invitation was sent to {email}. Sign in with that email to accept it.',
  ],
  'err.adminOnlyRemove': [
    'Удалять участников могут только администраторы.',
    'Only admins can remove members.',
  ],
  'err.onlyWorkspace': [
    'Нельзя удалить единственное пространство.',
    'You can’t delete your only workspace.',
  ],
  'err.cancelBeforeDelete': [
    'Сначала отмените подписку, потом удалите пространство.',
    'Cancel the subscription before deleting the workspace.',
  ],
  'err.blockSelf': ['Нельзя заблокировать себя.', 'You can’t block yourself.'],
  'err.deleteSelf': ['Нельзя удалить себя.', 'You can’t delete yourself.'],
  'err.deleteSuperadmin': ['Нельзя удалить суперадмина.', 'You can’t delete a superadmin.'],
  'err.paymentsDisabled': [
    'Оплата на этом сервере не подключена.',
    'Payments aren’t set up on this server.',
  ],
  'err.paymentProvider': [
    'Платёжный сервис ответил ошибкой — попробуйте ещё раз.',
    'The payment service returned an error — try again.',
  ],
  'err.planNotForSale': ['Этот тариф пока нельзя оформить.', 'This plan can’t be purchased yet.'],
  'err.noSubscription': [
    'У пространства пока нет подписки.',
    'This workspace has no subscription yet.',
  ],
  'err.portalUnavailable': [
    'Кабинет оплаты сейчас недоступен — попробуйте позже.',
    'The billing portal is unavailable right now — try later.',
  ],
  'err.cancelInPortal': [
    'Отменить подписку можно в кабинете оплаты.',
    'Cancel the subscription in the billing portal.',
  ],
  'err.planSwitchDisabled': [
    'Смена тарифа без оплаты отключена.',
    'Switching plans without payment is disabled.',
  ],
  'err.pricesChargeCurrency': [
    'Нужны цены в {currency}: в этой валюте идёт списание.',
    'Prices in {currency} are required: payments are charged in it.',
  ],
  'err.aiDisabled': [
    'AI-функции на этом сервере выключены.',
    'AI features are turned off on this server.',
  ],
  'err.aiBusy': [
    'AI сейчас перегружен — попробуйте через минуту.',
    'The AI is busy right now — try again in a minute.',
  ],
  'err.code.bad_request': [
    'Не получилось — проверьте данные и попробуйте ещё раз.',
    'That didn’t work — check the data and try again.',
  ],
  'err.code.validation_error': ['Проверьте заполненные поля.', 'Check the highlighted fields.'],
  'err.code.unauthorized': ['Войдите в аккаунт.', 'Please sign in.'],
  'err.code.forbidden': [
    'Недостаточно прав для этого действия.',
    'You don’t have permission to do this.',
  ],
  'err.code.not_found': [
    'Не найдено — возможно, это уже удалили.',
    'Not found — it may have been deleted.',
  ],
  'err.code.conflict': [
    'Конфликт с текущими данными — обновите страницу.',
    'This conflicts with the current data — reload the page.',
  ],
  'err.code.plan_limit': ['Недоступно на вашем тарифе.', 'Not available on your plan.'],
  'err.code.quota_exceeded': ['Лимит тарифа исчерпан.', 'You’ve reached your plan’s limit.'],
  'err.code.payment_required': ['Нужна оплата тарифа.', 'A paid plan is required.'],
  'err.code.rate_limited': [
    'Слишком много запросов — попробуйте через минуту.',
    'Too many requests — try again in a minute.',
  ],
  'err.code.payload_too_large': ['Файл слишком большой.', 'The file is too large.'],
  'err.code.unsupported_media_type': [
    'Этот тип файла не поддерживается.',
    'This file type isn’t supported.',
  ],
  'err.code.internal_error': [
    'Что-то пошло не так на нашей стороне. Попробуйте ещё раз через минуту.',
    'Something went wrong on our side. Try again in a minute.',
  ],
  'err.code.service_unavailable': [
    'Сервис временно недоступен — попробуйте позже.',
    'The service is temporarily unavailable — try later.',
  ],
  'err.field.required': ['Заполните поле «{field}»', 'Fill in “{field}”'],
  'err.field.choose': ['Выберите хотя бы одно: «{field}»', 'Choose at least one: “{field}”'],
  'err.field.minLength': [
    '«{field}»: минимальная длина — {n}',
    '“{field}”: at least {n} characters',
  ],
  'err.field.maxLength': [
    '«{field}»: максимальная длина — {n}',
    '“{field}”: at most {n} characters',
  ],
  'err.field.min': ['«{field}»: не меньше {n}', '“{field}”: at least {n}'],
  'err.field.max': ['«{field}»: не больше {n}', '“{field}”: at most {n}'],
  'err.field.email': ['Укажите правильный email', 'Enter a valid email'],
  'err.field.url': [
    '«{field}»: укажите полную ссылку, начиная с https://',
    '“{field}”: enter a full link starting with https://',
  ],
  'err.field.invalid': ['Проверьте поле «{field}»', 'Check “{field}”'],
  'field.name': ['Название', 'Name'],
  'field.templateIds': ['Шаблоны', 'Templates'],
  'field.dataSource.url': ['Ссылка на данные', 'Data link'],
  'field.dataSource.rows': ['Таблица', 'Table'],
  'field.dataSource.columns': ['Колонки таблицы', 'Table columns'],
  'field.dataSource.sheet': ['Лист таблицы', 'Sheet'],
  'field.dataSource.integrationId': ['Аккаунт Google', 'Google account'],
  'field.mapping.rules.layer': ['Слой в правиле', 'Layer in a rule'],
  'field.mapping.rules.column': ['Колонка в правиле', 'Column in a rule'],
  'field.mapping.rules.value': ['Значение в правиле', 'Value in a rule'],
  'field.output.formats': ['Форматы файлов', 'File formats'],
  'field.output.scale': ['Масштаб', 'Scale'],
  'field.output.quality': ['Качество', 'Quality'],
  'field.output.filenamePattern': ['Имена файлов', 'File names'],
  'field.destinations.url': ['URL вебхука', 'Webhook URL'],
  'field.destinations.folderName': ['Папка в Google Drive', 'Google Drive folder'],
  'field.destinations.integrationId': ['Аккаунт для выгрузки', 'Upload account'],
  'field.destinations.prefix': ['Папка в бакете', 'Bucket folder'],
  'field.schedule.cron': ['Расписание', 'Schedule'],
  'field.schedule.timezone': ['Часовой пояс', 'Time zone'],
  'field.email': ['Email', 'Email'],
  'field.password': ['Пароль', 'Password'],
  'field.newPassword': ['Новый пароль', 'New password'],
  'field.currentPassword': ['Текущий пароль', 'Current password'],
  'field.workspaceName': ['Название пространства', 'Workspace name'],
  'field.width': ['Ширина', 'Width'],
  'field.height': ['Высота', 'Height'],
  'field.brief': ['Описание', 'Brief'],
  'field.text': ['Текст', 'Text'],
  'field.url': ['Ссылка', 'Link'],
  'field.bucket': ['Бакет', 'Bucket'],
  'field.region': ['Регион', 'Region'],
  'field.endpoint': ['Адрес сервера (endpoint)', 'Endpoint'],
  'field.publicBaseUrl': ['Публичный адрес файлов', 'Public file URL'],
  'field.accessKeyId': ['Access Key ID', 'Access Key ID'],
  'field.secretAccessKey': ['Secret Access Key', 'Secret Access Key'],
  'field.defaultWebhookUrl': ['Вебхук по умолчанию', 'Default webhook'],
  'field.family': ['Название шрифта', 'Font name'],
  'field.tags': ['Теги', 'Tags'],
  'field.format': ['Формат', 'Format'],
  'field.scale': ['Масштаб', 'Scale'],
  'field.quality': ['Качество', 'Quality'],
  'field.modifications': ['Данные для слоёв', 'Layer data'],
  'common.more': ['Ещё', 'More'],
  'common.name': ['Название', 'Name'],
  'common.notFound': ['Не найдено', 'Not found'],
  'common.nothingFound': ['Ничего не найдено', 'Nothing found'],
  'common.open': ['Открыть', 'Open'],
  'common.openNewTab': ['Открыть в новой вкладке', 'Open in a new tab'],
  'common.save': ['Сохранить', 'Save'],
  'common.saved': ['Сохранено', 'Saved'],
  'common.search': ['Поиск', 'Search'],
  'common.uploading': ['Загрузка…', 'Uploading…'],

  // roles
  'role.owner': ['Владелец', 'Owner'],
  'role.admin': ['Администратор', 'Admin'],
  'role.editor': ['Редактор', 'Editor'],
  'role.viewer': ['Наблюдатель', 'Viewer'],

  // navigation
  'nav.templates': ['Шаблоны', 'Templates'],
  'nav.automations': ['Автоматизации', 'Automations'],
  'nav.renders': ['Генерации', 'Renders'],
  'nav.assets': ['Медиатека', 'Media library'],
  'nav.fonts': ['Шрифты', 'Fonts'],
  'nav.api': ['API и ключи', 'API & keys'],
  'nav.integrations': ['Интеграции', 'Integrations'],
  'nav.settings': ['Настройки', 'Settings'],
  'nav.billing': ['Тариф и оплата', 'Plan & billing'],
  'nav.developers': ['Разработчикам', 'Developers'],
  'nav.workspace': ['Пространство', 'Workspace'],
  'nav.workspaces': ['Рабочие пространства', 'Workspaces'],
  'nav.newWorkspace': ['Новое пространство', 'New workspace'],
  'nav.profile': ['Профиль', 'Profile'],
  'nav.logout': ['Выйти', 'Log out'],
  'nav.rendersThisMonth': ['Генерации за период', 'Renders this period'],
  'nav.upgrade': ['Повысить тариф', 'Upgrade'],

  // auth
  'auth.google': ['Продолжить с Google', 'Continue with Google'],
  'auth.or': ['или', 'or'],
  'auth.error.google_denied': ['Вход через Google отменён', 'Google sign-in was cancelled'],
  'auth.error.google_state': [
    'Сессия входа устарела, попробуйте ещё раз',
    'The sign-in session expired, try again',
  ],
  'auth.error.google_failed': ['Не удалось войти через Google', 'Could not sign in with Google'],
  'auth.error.google_unavailable': [
    'Вход через Google не настроен на сервере',
    'Sign in with Google is not configured on this server',
  ],
  'settings.setPassword': ['Задать пароль', 'Set a password'],
  'settings.googleNoPassword': [
    'Вы входите через Google. Задайте пароль, чтобы входить и по email.',
    'You sign in with Google. Set a password to also sign in with your email.',
  ],
  'auth.loginTitle': ['Вход в Bannermatic', 'Sign in to Bannermatic'],
  'auth.loginSubtitle': ['Рады видеть вас снова', 'Welcome back'],
  'auth.signupTitle': ['Создайте аккаунт', 'Create your account'],
  'auth.signupSubtitle': ['Бесплатный тариф — без карты', 'Free plan — no credit card'],
  'auth.email': ['Email', 'Email'],
  'auth.password': ['Пароль', 'Password'],
  'auth.passwordHint': ['Минимум 8 символов', 'At least 8 characters'],
  'auth.name': ['Имя', 'Name'],
  'auth.company': ['Компания или команда', 'Company or team'],
  'auth.companyHint': [
    'Название рабочего пространства, его можно изменить позже',
    'Workspace name — you can change it later',
  ],
  'auth.forgot': ['Забыли пароль?', 'Forgot password?'],
  'auth.loginButton': ['Войти', 'Sign in'],
  'auth.signupButton': ['Создать аккаунт', 'Create account'],
  'auth.noAccount': ['Нет аккаунта?', "Don't have an account?"],
  'auth.haveAccount': ['Уже есть аккаунт?', 'Already have an account?'],
  'auth.signupLink': ['Зарегистрироваться', 'Sign up'],
  'auth.loginLink': ['Войти', 'Sign in'],
  'auth.freePlanNote': ['50 генераций в месяц бесплатно', '50 free renders every month'],
  'auth.forgotTitle': ['Восстановление пароля', 'Reset your password'],
  'auth.forgotSubtitle': ['Пришлём ссылку для сброса на ваш email', "We'll email you a reset link"],
  'auth.forgotSent': [
    'Если такой аккаунт существует, письмо уже в пути. Проверьте почту.',
    'If the account exists, the email is on its way. Check your inbox.',
  ],
  'auth.sendLink': ['Отправить ссылку', 'Send link'],
  'auth.resetTitle': ['Новый пароль', 'Set a new password'],
  'auth.newPassword': ['Новый пароль', 'New password'],
  'auth.resetButton': ['Сохранить пароль', 'Save password'],
  'auth.resetDone': ['Пароль изменён, войдите заново', 'Password changed — please sign in'],

  'invite.title': ['Приглашение в команду', 'Team invitation'],
  'invite.text': [
    'Вас пригласили в пространство «{workspace}» с ролью {role}.',
    'You were invited to "{workspace}" as {role}.',
  ],
  'invite.accept': ['Принять приглашение', 'Accept invitation'],
  'invite.signup': ['Создать аккаунт для {email}', 'Create an account for {email}'],

  // templates
  'templates.description': [
    'Шаблоны баннеров с динамическими слоями для API и автоматизаций',
    'Banner templates with dynamic layers for the API and automations',
  ],
  'templates.new': ['Новый шаблон', 'New template'],
  'templates.newTitle': ['Новый шаблон', 'New template'],
  'templates.untitled': ['Без названия', 'Untitled'],
  'templates.createAndEdit': ['Создать и открыть редактор', 'Create and open editor'],
  'templates.customSize': ['Свой размер', 'Custom size'],
  'templates.groupSocial': ['Соцсети', 'Social media'],
  'templates.groupAds': ['Медийная реклама', 'Display ads'],
  'templates.groupWeb': ['Сайт и email', 'Web & email'],
  'templates.groupVideo': ['Видео', 'Video'],
  'templates.groupPrint': ['Печать', 'Print'],
  'templates.count': ['{n} шт.', '{n} total'],
  'templates.emptyTitle': ['Создайте первый шаблон', 'Create your first template'],
  'templates.emptyText': [
    'Соберите баннер в редакторе, дайте слоям понятные имена — и генерируйте сотни вариантов через API или таблицу.',
    'Design a banner, give layers clear names and generate hundreds of variants through the API or a spreadsheet.',
  ],
  'templates.duplicateAs': ['Копия в другом размере', 'Copy in another size'],
  'templates.duplicateAsHint': [
    'Слои адаптируются по своим привязкам — затем проверьте композицию.',
    'Layers adapt using their resize behaviour — then check the layout.',
  ],
  'templates.duplicated': ['Копия создана', 'Copy created'],
  'sizes.mine': ['Ваши размеры', 'Your sizes'],
  'sizes.standard': ['Стандартные', 'Standard'],
  'sizes.save': ['Сохранить размер', 'Save size'],
  'sizes.saved': ['Размер сохранён в рабочем пространстве', 'Size saved to the workspace'],
  'sizes.paid': [
    'Свои размеры для любых площадок — на тарифах от Starter',
    'Your own sizes for any platform — on Starter and above',
  ],
  'sizes.limit': [
    'На вашем тарифе — до {n} своих размеров',
    'Your plan allows up to {n} own sizes',
  ],
  'sizes.namePlaceholder': ['Название, напр. «Экран в лобби»', 'Name, e.g. “Lobby screen”'],
  'billing.fSizes': ['Своих размеров: до {n}', 'Up to {n} own sizes'],
  'billing.fSizesUnlimited': ['Безлимит своих размеров', 'Unlimited own sizes'],
  'templates.copyName': ['{name} (копия)', '{name} (copy)'],
  'duplicate.menu': ['Дублировать…', 'Duplicate…'],
  'duplicate.title': ['Дублировать шаблон', 'Duplicate template'],
  'duplicate.sameSize': ['Тот же размер {size}', 'Same size {size}'],
  'duplicate.otherSize': ['Другой размер + автолейаут', 'Other size + auto layout'],
  'templates.exportJson': ['Экспорт в JSON', 'Export JSON'],
  'templates.importTitle': ['Импорт шаблона', 'Import template'],
  'templates.importHint': [
    'SVG из Figma (Copy as SVG или Export → SVG), файлы .json из Bannermatic или экспорт Placid — можно несколько сразу',
    'SVG from Figma (Copy as SVG or Export → SVG), Bannermatic .json files or Placid exports, several at once',
  ],
  'templates.dropJson': [
    'Перетащите файлы или нажмите, чтобы выбрать',
    'Drop files or click to choose',
  ],
  'templates.figmaTitle': ['Как экспортировать из Figma', 'How to export from Figma'],
  'templates.figmaStep1': [
    'Выделите фрейм баннера (Frame, не группу).',
    'Select the banner frame (a Frame, not a group).',
  ],
  'templates.figmaStep2': [
    'Справа внизу в Export нажмите «+» и выберите формат SVG.',
    'In Export at the bottom right press “+” and choose SVG.',
  ],
  'templates.figmaStep3': [
    'Нажмите «…» рядом с SVG и снимите «Outline text» — тогда тексты останутся текстами.',
    'Press “…” next to SVG and uncheck “Outline text” so texts stay texts.',
  ],
  'templates.figmaStep4': [
    'Нажмите Export и перетащите файл .svg сюда.',
    'Press Export and drop the .svg file here.',
  ],
  'templates.figmaNote': [
    'Быстрее: ПКМ по фрейму → Copy/Paste as → Copy as SVG и Ctrl+V (⌘V) здесь, но тексты тогда придут кривыми. Шрифты, которых нет в «Шрифтах», заменятся похожими и подсветятся — загрузите их, чтобы было один в один.',
    'Quicker: right-click the frame → Copy/Paste as → Copy as SVG and Ctrl+V (⌘V) here, but texts then come as outlines. Fonts missing from Fonts are replaced by look-alikes and highlighted — upload them for an exact match.',
  ],
  'templates.svg.fontsReplaced': [
    'Нет шрифтов из макета, временно заменены: {fonts}. Такие тексты подсвечены в редакторе — загрузите шрифты, и они применятся одним кликом.',
    'Fonts of the design are missing and were replaced for now: {fonts}. These texts are highlighted in the editor — upload the fonts and apply them in one click.',
  ],
  'templates.svg.uploadFonts': ['Загрузить шрифты', 'Upload fonts'],
  'templates.svg.outlined': [
    'Тексты в этом SVG превращены в кривые — их нельзя редактировать. В Figma: Export → SVG → «…» → снимите «Outline text» и импортируйте снова. Или выделите такую картинку в редакторе → «Это текст?».',
    'Texts in this SVG are outlines and cannot be edited. In Figma: Export → SVG → “…” → uncheck “Outline text” and import again. Or select such a picture in the editor → “Is this text?”.',
  ],
  'editor.missingFontTitle': ['Шрифт «{font}» не загружен', 'Font “{font}” is not uploaded'],
  'editor.missingFontText': [
    'Текст показан шрифтом {used} — так он выйдет и в рендере. Загрузите шрифт на странице «Шрифты», и здесь появится кнопка «Применить».',
    'The text is drawn with {used}, and renders will use it too. Upload the font on the Fonts page and an “Apply” button appears here.',
  ],
  'editor.missingFontFound': [
    'Шрифт {font} уже есть в пространстве.',
    '{font} is in the workspace now.',
  ],
  'editor.missingFontApply': ['Применить {font}', 'Apply {font}'],
  'editor.missingFontUpload': ['Загрузить шрифт', 'Upload the font'],
  'editor.missingFontKeep': ['Оставить {used}', 'Keep {used}'],
  'editor.fontNotInWorkspace': [
    'Такого шрифта нет в пространстве. В редакторе он может отображаться из шрифтов вашего компьютера, но в генерации текст будет другим шрифтом. Загрузите файл шрифта или выберите другой.',
    'This font is not in the workspace. The editor may show it from the fonts on your computer, but renders will use another font. Upload the font file or pick another one.',
  ],
  'editor.textFromImageTitle': ['Это текст?', 'Is this text?'],
  'editor.textFromImageHint': [
    'Figma часто экспортирует тексты кривыми. Сделайте из этой картинки редактируемый текст на том же месте.',
    'Figma often exports texts as outlines. Turn this picture into editable text in the same place.',
  ],
  'editor.textFromImageManual': ['Заменить текстовым слоем', 'Replace with a text layer'],
  'editor.textFromImagePlaceholder': ['Текст', 'Text'],
  'templates.importButton': ['Импорт: Figma, JSON', 'Import: Figma, JSON'],
  'templates.importing': [
    'Импортирую… Картинки загружаются в медиатеку',
    'Importing… pictures go to the media library',
  ],
  'templates.importFormats': [
    'SVG из Figma · .json Bannermatic · экспорт Placid',
    'Figma SVG · Bannermatic .json · Placid export',
  ],

  'templates.svg.invalid': [
    'Не удалось прочитать SVG. Экспортируйте фрейм из Figma как SVG',
    'Could not read this SVG. Export the frame from Figma as SVG',
  ],
  'templates.svg.empty': ['В SVG не нашлось слоёв', 'No layers found in this SVG'],
  'templates.svg.tooMany': [
    'В SVG больше 500 слоёв — упростите макет',
    'This SVG has more than 500 layers — simplify the design',
  ],
  'templates.imported': ['Шаблон импортирован', 'Template imported'],
  'templates.deleteTitle': ['Удалить шаблон?', 'Delete template?'],
  'templates.deleteText': [
    'Шаблон «{name}» перестанет быть доступен в API и автоматизациях.',
    '"{name}" will no longer be available to the API and automations.',
  ],

  // editor
  'gallery.open': ['Библиотека шаблонов', 'Template library'],
  'gallery.title': ['Библиотека шаблонов', 'Template library'],
  'gallery.description': [
    'Готовые макеты на стеках: подставьте свои тексты и картинки или поменяйте размер — вёрстка подстроится.',
    'Ready-made layouts built with stacks: put in your texts and images or change the size — the layout adapts.',
  ],
  'gallery.all': ['Все', 'All'],
  'gallery.use': ['Использовать', 'Use'],
  'gallery.created': ['Шаблон создан', 'Template created'],
  'gallery.fromLibrary': [
    'Или начните с готового шаблона из библиотеки',
    'Or start from a ready-made template',
  ],
  'gallery.cat.sale': ['Распродажи', 'Sales'],
  'gallery.cat.ecommerce': ['Товары', 'Products'],
  'gallery.cat.event': ['События', 'Events'],
  'gallery.cat.social': ['Соцсети', 'Social'],
  'gallery.cat.food': ['Еда и кафе', 'Food & cafés'],
  'gallery.cat.realestate': ['Недвижимость', 'Real estate'],
  'gallery.cat.education': ['Обучение', 'Education'],
  'gallery.cat.hiring': ['Вакансии', 'Hiring'],
  'gallery.cat.travel': ['Путешествия', 'Travel'],
  'gallery.cat.fitness': ['Спорт', 'Fitness'],
  'gallery.cat.holiday': ['Праздники', 'Holidays'],
  'gallery.cat.ads': ['Веб-баннеры', 'Web banners'],
  'gallery.cat.beauty': ['Красота', 'Beauty'],
  'gallery.cat.auto': ['Авто', 'Cars'],
  'gallery.cat.tech': ['Технологии', 'Tech'],
  'gallery.cat.pets': ['Питомцы', 'Pets'],
  'ai.create': ['Создать с AI', 'Create with AI'],
  'ai.regenerate': ['Ещё варианты', 'More variants'],
  'ai.credits': [
    'AI-запросов: {used} из {limit} в этом месяце',
    'AI requests: {used} of {limit} this month',
  ],
  'ai.disabled': [
    'AI-генерация не настроена на сервере (GEMINI_API_KEY).',
    'AI generation is not configured on the server (GEMINI_API_KEY).',
  ],
  'aiVideo.title': ['Видео по описанию', 'Video from a description'],
  'aiVideo.placeholder': [
    'Например: запуск приложения Nova для монтажа, на 48% быстрее, тёмная тема',
    'e.g. Launch of Nova, a video editing app, 48% faster, dark look',
  ],
  'aiVideo.generate': ['Создать видео', 'Make videos'],
  'aiVideo.generating': ['AI режиссирует варианты…', 'AI is directing variants…'],
  'aiVideo.style_launch': ['Запуск продукта', 'Launch film'],
  'aiVideo.style_showreel': ['Шоурил', 'Showreel'],
  'aiVideo.style_manifesto': ['Манифест', 'Manifesto'],
  'aiVideo.style_data': ['История в цифрах', 'Data story'],
  'aiVideo.style_brand': ['Бренд-фильм', 'Brand film'],
  'director.title': ['AI-режиссёр', 'AI director'],
  'director.description': [
    'Опишите, что нужно и для чего. Агент сам соберёт ролик или баннер инструментами редактора: сцены, тексты и шрифты, фото, моушн-графику, текстовые эффекты, переходы, камеру и музыку. Потом всё правится как обычный шаблон.',
    'Describe what you need and what for. An agent composes the video or banner itself with the editor’s tools: scenes, texts and fonts, photos, motion graphics, text effects, transitions, camera and music. Then edit it like any template.',
  ],
  'director.video': ['Ролик', 'Video'],
  'director.banner': ['Баннер', 'Banner'],
  'director.placeholderVideo': [
    'Например: ролик-запуск приложения Nova для монтажа видео. Аудитория — блогеры. Главное: монтаж на 48% быстрее. Энергично, тёмный стиль с оранжевым, в конце «Скачать бесплатно».',
    'e.g. Launch video for Nova, a video editing app for creators. Key point: editing 48% faster. Energetic, dark with orange, ending with “Download free”.',
  ],
  'director.placeholderBanner': [
    'Например: баннер летней распродажи кроссовок RUNNER, скидка 30% до воскресенья, яркий и спортивный, кнопка «Купить».',
    'e.g. Summer sneaker sale banner for RUNNER, 30% off until Sunday, bright and sporty, a “Shop now” button.',
  ],
  'director.run': ['Создать', 'Create'],
  'director.again': ['Ещё вариант', 'Another take'],
  'director.open': ['Открыть в редакторе', 'Open in the editor'],
  'director.mockNote': [
    'Тестовый режим без ключа API: агент проигрывает заготовленный сценарий.',
    'Test mode without an API key: the agent plays a scripted composition.',
  ],
  'director.logHint': [
    'Здесь будет видно, как агент собирает работу: шаг за шагом.',
    'Here you will see the agent compose the piece, step by step.',
  ],
  'director.thinking': [
    'Агент продумывает идею и раскадровку…',
    'The agent is working out the idea and the storyboard…',
  ],
  'director.working': ['Агент работает · шаг {n}', 'The agent is working · turn {n}'],
  'director.fixed': [
    'Агент исправил ошибок по ходу: {n}',
    'Mistakes the agent fixed along the way: {n}',
  ],
  'director.previewHint': ['Здесь появится результат', 'The result appears here'],
  'director.tool_plan_style': ['Стиль', 'Style'],
  'director.tool_add_scene': ['Сцена', 'Scene'],
  'director.tool_add_text': ['Текст', 'Text'],
  'director.tool_add_shape': ['Фигура', 'Shape'],
  'director.tool_add_photo': ['Фото', 'Photo'],
  'director.tool_add_graphic': ['Графика', 'Graphics'],
  'director.tool_add_camera': ['Камера', 'Camera'],
  'director.tool_set_music': ['Музыка', 'Music'],
  'director.tool_finish': ['Готово', 'Done'],
  'director.tool_add_logo': ['Логотип', 'Logo'],
  'director.tool_update': ['Правка', 'Edit'],
  'director.tool_remove': ['Удаление', 'Removed'],
  'director.tool_update_scene': ['Сцена: правка', 'Scene edit'],
  'director.tool_review': ['Проверка', 'Review'],
  'director.reviewFound': ['замечаний: {n} — исправляю', '{n} issue(s) — fixing them'],
  'director.reviewClean': ['замечаний нет', 'no issues'],
  'director.brandDefault': ['Бренд: {name}', 'Brand: {name}'],
  'director.brandNone': ['Без бренда', 'No brand'],
  'director.brandHint': [
    'Цвета, шрифты и логотип бренд-кита: ролик останется связан с брендом',
    'Brand kit colours, fonts and logo: the result stays linked to the brand',
  ],
  'dictation.start': ['Диктовать', 'Dictate'],
  'dictation.stop': ['Остановить диктовку', 'Stop dictation'],
  'dictation.listening': ['Слушаю…', 'Listening…'],
  'dictation.lang': ['Язык диктовки', 'Dictation language'],
  'dictation.denied': [
    'Нет доступа к микрофону — разрешите его в браузере',
    'No microphone access — allow it in the browser',
  ],
  'dictation.failed': ['Не удалось распознать речь', 'Speech recognition failed'],
  'ai.copyVariants': ['AI-варианты текста', 'AI text variants'],
  'ai.copyHint': [
    'Клик — подставить вариант. Отменить — Ctrl+Z.',
    'Click to use a variant. Undo with Ctrl+Z.',
  ],
  'billing.fAi': ['AI-запросов в месяц: {n}', 'AI requests per month: {n}'],
  'billing.aiPeriod': ['AI-запросы в текущем периоде', 'AI requests in the current period'],
  'editor.dropImages': ['Отпустите, чтобы загрузить файлы', 'Drop files to upload'],
  'editor.saved': ['Сохранено', 'Saved'],
  'editor.unsaved': ['Есть изменения', 'Unsaved changes'],
  'editor.saving': ['Сохранение…', 'Saving…'],
  'editor.saveError': ['Ошибка сохранения', 'Save failed'],
  'editor.conflict': ['Конфликт версий', 'Version conflict'],
  'editor.conflictTitle': ['Шаблон изменён в другом месте', 'Template changed elsewhere'],
  'editor.conflictText': [
    'Кто-то сохранил шаблон, пока вы редактировали. Перезаписать своей версией? «Отмена» загрузит актуальную версию.',
    'Someone saved this template while you were editing. Overwrite with your version? "Cancel" reloads the latest version.',
  ],
  'editor.overwrite': ['Перезаписать', 'Overwrite'],
  'editor.undo': ['Отменить', 'Undo'],
  'editor.redo': ['Повторить', 'Redo'],
  'editor.zoomIn': ['Приблизить', 'Zoom in'],
  'editor.zoomOut': ['Отдалить', 'Zoom out'],
  'editor.zoomFit': ['По размеру экрана', 'Fit to screen'],
  'editor.zoom100': ['Масштаб 100%', 'Zoom to 100%'],
  'editor.selectAll': ['Выбрать все слои', 'Select all layers'],
  'editor.rename': ['Переименовать', 'Rename'],
  'editor.resize': ['Размер', 'Resize'],
  'editor.testRender': ['Сгенерировать', 'Generate'],
  'editor.readOnly': ['У вас доступ только для просмотра.', 'You have view-only access.'],
  'editor.tabElements': ['Элементы', 'Elements'],
  'editor.tabMedia': ['Медиа', 'Media'],
  'editor.tabLayers': ['Слои', 'Layers'],
  'editor.text': ['Текст', 'Text'],
  'editor.addHeading': ['Заголовок', 'Heading'],
  'editor.addSubheading': ['Подзаголовок', 'Subheading'],
  'editor.addBody': ['Основной текст', 'Body text'],
  'editor.presetHeading': ['Заголовок', 'Heading'],
  'editor.presetSubheading': ['Подзаголовок', 'Subheading'],
  'editor.presetBody': [
    'Основной текст. Двойной клик, чтобы изменить.',
    'Body text. Double-click to edit.',
  ],
  'editor.addBadge': ['Плашка −30%', 'Badge −30%'],
  'editor.shapes': ['Фигуры', 'Shapes'],
  'editor.shapeRectangle': ['Прямоугольник', 'Rectangle'],
  'editor.shapeRounded': ['Скруглённый', 'Rounded'],
  'editor.shapeEllipse': ['Эллипс', 'Ellipse'],
  'editor.shapeTriangle': ['Треугольник', 'Triangle'],
  'editor.shapeLine': ['Линия', 'Line'],
  'editor.shapeDiamond': ['Ромб', 'Diamond'],
  'editor.shapePolygon': ['Многоугольник', 'Polygon'],
  'editor.shapeStar': ['Звезда', 'Star'],
  'editor.shapeBurst': ['Взрыв', 'Burst'],
  'editor.shapeHeart': ['Сердце', 'Heart'],
  'editor.shapeArrow': ['Стрелка', 'Arrow'],
  'editor.shapeChevron': ['Шеврон', 'Chevron'],
  'editor.shapeCross': ['Плюс', 'Plus'],
  'editor.shapeBubble': ['Облачко', 'Speech bubble'],
  'editor.shapeRibbon': ['Лента', 'Ribbon'],
  'editor.shapeTag': ['Ценник', 'Price tag'],
  'editor.shapeParallelogram': ['Параллелограмм', 'Parallelogram'],
  'editor.shapeSemicircle': ['Полукруг', 'Semicircle'],
  'editor.shapeBlob': ['Клякса', 'Blob'],
  'editor.shapeIcon': ['Иконка', 'Icon'],
  'editor.shapePoints': ['Лучи', 'Points'],
  'editor.shapeSides': ['Стороны', 'Sides'],
  'editor.shapeInner': ['Глубина', 'Depth'],
  'editor.secTextStyles': ['Стили текста', 'Text styles'],
  'editor.secStickers': ['Стикеры и бейджи', 'Stickers & badges'],
  'editor.secIcons': ['Иконки', 'Icons'],
  'editor.secInfo': ['Контакты и инфо', 'Contacts & info'],
  'editor.secDecor': ['Рамки и декор', 'Frames & decor'],
  'editor.secOverlays': ['Фоны и затемнения', 'Backdrops & overlays'],
  'editor.iconSearch': ['Поиск: phone, gift, star…', 'Search: phone, gift, star…'],
  'editor.noIcons': ['Ничего не найдено', 'Nothing found'],
  'editor.showAllIcons': ['Показать все ({n})', 'Show all ({n})'],
  'editor.showLess': ['Свернуть', 'Show less'],
  'editor.elCta': ['Кнопка', 'Button'],
  'editor.txtCta': ['Купить сейчас', 'Shop now'],
  'editor.elKicker': ['Надзаголовок', 'Kicker'],
  'editor.txtKicker': ['Новинка сезона', 'New this season'],
  'editor.elHighlight': ['Маркер', 'Highlight'],
  'editor.txtHighlight': ['Только сегодня', 'Today only'],
  'editor.elOutline': ['Контур', 'Outline'],
  'editor.elNeon': ['Неон', 'Neon'],
  'editor.txtNeon': ['Открыто', 'Open now'],
  'editor.elScript': ['Рукописный', 'Handwritten'],
  'editor.txtScript': ['С любовью', 'With love'],
  'editor.elElegant': ['Элегантный', 'Elegant'],
  'editor.elPoster': ['Афиша', 'Poster'],
  'editor.elQuote': ['Цитата', 'Quote'],
  'editor.txtQuote': ['«Лучший кофе в городе!»', '“The best coffee in town!”'],
  'editor.elPrice': ['Цена со скидкой', 'Sale price'],
  'editor.elFineprint': ['Сноска', 'Fine print'],
  'editor.txtFineprint': ['*Предложение действует до 31 декабря', '*Offer valid until December 31'],
  'editor.elSale': ['Распродажа', 'Sale'],
  'editor.txtSale': ['SALE', 'SALE'],
  'editor.elDiscount': ['Скидка', 'Discount'],
  'editor.elNew': ['Новинка', 'New'],
  'editor.txtNew': ['NEW', 'NEW'],
  'editor.elRibbon': ['Лента', 'Ribbon'],
  'editor.txtRibbon': ['ХИТ ПРОДАЖ', 'BESTSELLER'],
  'editor.elTag': ['Ценник', 'Price tag'],
  'editor.elBubble': ['Реплика', 'Speech'],
  'editor.txtBubble': ['Вау!', 'Wow!'],
  'editor.elLove': ['Сердце', 'Heart'],
  'editor.elShipping': ['Доставка', 'Shipping'],
  'editor.txtShipping': ['Бесплатная доставка', 'Free shipping'],
  'editor.elRating': ['Рейтинг', 'Rating'],
  'editor.elTimer': ['Таймер', 'Countdown'],
  'editor.elPhone': ['Телефон', 'Phone'],
  'editor.elAddress': ['Адрес', 'Address'],
  'editor.txtAddress': ['ул. Центральная, 1', '1 Main Street'],
  'editor.elWebsite': ['Сайт', 'Website'],
  'editor.elDate': ['Дата', 'Date'],
  'editor.txtDate': ['12 мая · 19:00', 'May 12 · 7 PM'],
  'editor.elSocial': ['Соцсеть', 'Social'],
  'editor.elChecklist': ['Список', 'Checklist'],
  'editor.txtChecklist': ['Преимущество {n}', 'Benefit {n}'],
  'editor.elFrame': ['Рамка', 'Frame'],
  'editor.elDashedFrame': ['Пунктир', 'Dashed frame'],
  'editor.elRing': ['Кольцо', 'Ring'],
  'editor.elDivider': ['Акцент', 'Accent bar'],
  'editor.elDottedLine': ['Точки', 'Dotted line'],
  'editor.elCircles': ['Круги', 'Circles'],
  'editor.elBlob': ['Клякса', 'Blob'],
  'editor.elShadeBottom': ['Тень снизу', 'Shade bottom'],
  'editor.elShadeTop': ['Тень сверху', 'Shade top'],
  'editor.elShadeLeft': ['Тень слева', 'Shade left'],
  'editor.elVignette': ['Виньетка', 'Vignette'],
  'editor.elTint': ['Тонировка', 'Tint'],
  'editor.elDuotone': ['Дуотон', 'Duotone'],
  'editor.elHalfPanel': ['Половина', 'Half panel'],
  'editor.elDiagonal': ['Диагональ', 'Diagonal'],
  'editor.elArc': ['Дуга снизу', 'Bottom arc'],
  'editor.stockPhotos': ['Фото', 'Photos'],
  'editor.stockHint': [
    'Royalty-free фото: можно использовать в коммерческих баннерах без указания автора. Клик — вставить или заменить выделенную картинку.',
    'Royalty-free photos: use them in commercial banners, no attribution needed. Click to insert or to replace the selected image.',
  ],
  'editor.photoTag.all': ['Все', 'All'],
  'editor.photoTag.people': ['Люди', 'People'],
  'editor.photoTag.beauty': ['Красота', 'Beauty'],
  'editor.photoTag.food': ['Еда', 'Food'],
  'editor.photoTag.travel': ['Путешествия', 'Travel'],
  'editor.photoTag.home': ['Дом', 'Home'],
  'editor.photoTag.business': ['Бизнес', 'Business'],
  'editor.photoTag.sport': ['Спорт', 'Sport'],
  'editor.photoTag.holiday': ['Праздники', 'Holidays'],
  'editor.photoTag.auto': ['Авто', 'Cars'],
  'editor.photoTag.pets': ['Питомцы', 'Pets'],
  'editor.photoTag.nature': ['Природа', 'Nature'],
  'editor.dynamic': ['Динамические', 'Dynamic'],
  'editor.imagePlaceholder': ['Фото / логотип', 'Photo / logo'],
  'editor.qr': ['QR-код', 'QR code'],
  'editor.dynamicHint': [
    'Любой слой можно менять через API по его имени: текст, картинку, цвет, позицию.',
    'Every layer can be changed via the API by its name: text, image, color, position.',
  ],
  'editor.noLayers': [
    'Пока нет слоёв. Добавьте текст, фигуру или изображение.',
    'No layers yet. Add text, a shape or an image.',
  ],
  'editor.uploadImages': ['Загрузить фото или видео', 'Upload images or videos'],
  'editor.uploadNew': ['Загрузить новое', 'Upload new'],
  'editor.mediaHint': [
    'Клик — вставить на холст или заменить картинку выделенного слоя. Файлы можно просто перетащить на холст.',
    'Click to insert or to replace the selected image. You can also drop files onto the canvas.',
  ],
  'editor.noUploads': ['Загрузок пока нет', 'No uploads yet'],
  'editor.removeImage': ['Убрать изображение', 'Remove image'],
  'editor.placeholderImage': [
    'Плейсхолдер — картинку передадут через API',
    'Placeholder — the image comes from the API',
  ],
  'editor.replaceImage': ['Заменить фото или видео', 'Replace image or video'],
  'editor.dropToReplace': ['Отпустите, чтобы заменить', 'Drop to replace'],
  'editor.chooseImage': ['Выбрать фото или видео', 'Choose image or video'],
  'editor.imageUrl': ['или вставьте URL картинки', 'or paste an image URL'],
  'editor.template': ['Шаблон', 'Template'],
  'editor.canvasSize': ['Размер холста', 'Canvas size'],
  'editor.customSize': ['Свой размер', 'Custom size'],
  'editor.resizeHint': [
    'С адаптацией слои подстроятся под новый размер по своим привязкам. Отменить — Ctrl+Z.',
    'With adaptation on, layers follow their resize behaviour. Undo with Ctrl+Z.',
  ],
  'editor.background': ['Фон', 'Background'],
  'editor.transparentHint': [
    'Прозрачный фон сохранится в PNG и WEBP.',
    'Transparent background is kept in PNG and WEBP.',
  ],
  'editor.tips': ['Подсказки', 'Tips'],
  'editor.tipNames': [
    'Дайте слоям понятные имена (title, photo, price) — по ним данные подставляются через API и таблицы.',
    'Give layers clear names (title, photo, price) — data is mapped to them in the API and spreadsheets.',
  ],
  'editor.tipShortcuts': [
    'Ctrl+Z / Ctrl+Shift+Z, Ctrl+D — дубль, стрелки — сдвиг (Shift ×10), колесо + Ctrl — масштаб, пробел — перемещение холста, Alt — расстояния до соседей.',
    'Ctrl+Z / Ctrl+Shift+Z, Ctrl+D duplicate, arrows nudge (Shift ×10), Ctrl+wheel zoom, Space to pan, hold Alt to measure distances.',
  ],
  'editor.tipTools': [
    'Инструменты: R — прямоугольник, U — скруглённый, O — эллипс, L — линия, T — текст, H — заголовок (Shift+H — подзаголовок), B — плашка, I — фото, Q — QR. Протяните по холсту или кликните; V или Esc — выбор.',
    'Tools: R rectangle, U rounded, O ellipse, L line, T text, H heading (Shift+H subheading), B badge, I photo, Q QR. Drag on the canvas or click; V or Esc to select.',
  ],
  'editor.toolHint': [
    '{tool}: протяните по холсту или кликните · Esc — отмена',
    '{tool}: drag on the canvas or click · Esc to cancel',
  ],
  'editor.tipDrop': [
    'Перетащите изображения прямо на холст — они загрузятся в медиатеку.',
    'Drop images onto the canvas to upload them.',
  ],
  'editor.nameInvalid': [
    'Имя не может содержать . = & ? # / \\',
    'Name cannot contain . = & ? # / \\',
  ],
  'editor.nameTaken': ['Такое имя уже есть в шаблоне', 'This name is already used'],
  'editor.layerNameHint': [
    'Имя слоя — ключ в API и колонка в таблице',
    'Layer name is the API key and spreadsheet column',
  ],
  'editor.layerDescription': ['Описание для API (необязательно)', 'API description (optional)'],
  'editor.position': ['Положение и размер', 'Position & size'],
  'editor.constraints': ['Привязка при смене размера', 'Resize behaviour'],
  'editor.constraintsHint': [
    'Как слой подстраивается, когда меняется размер шаблона.',
    'How the layer adapts when the template size changes.',
  ],
  'editor.cH': ['По горизонтали', 'Horizontal'],
  'editor.cV': ['По вертикали', 'Vertical'],
  'editor.c.auto': ['Авто', 'Auto'],
  'editor.c.left': ['Слева', 'Left'],
  'editor.c.right': ['Справа', 'Right'],
  'editor.c.top': ['Сверху', 'Top'],
  'editor.c.bottom': ['Снизу', 'Bottom'],
  'editor.c.center': ['По центру', 'Center'],
  'editor.c.stretch': ['Растянуть', 'Stretch'],
  'editor.c.scale': ['Масштабировать', 'Scale'],
  'editor.c.proportional': ['пропорционально', 'proportional'],
  'editor.adaptLayers': ['Адаптировать слои', 'Adapt layers'],
  'editor.applySize': ['Применить размер', 'Apply size'],
  'resize.preview': ['Предпросмотр', 'Preview'],
  'resize.extremeWarning': [
    'Пропорции сильно меняются — проверьте композицию после копирования.',
    'The aspect ratio changes a lot — check the layout after copying.',
  ],
  'editor.stack': ['Стек', 'Stack'],
  'editor.stackExpand': ['Показать слои стека', 'Show the stack’s layers'],
  'editor.stackCollapse': ['Свернуть стек', 'Fold the stack'],
  'editor.groupStack': ['В стек', 'To stack'],
  'editor.ungroupStack': ['Разгруппировать', 'Ungroup'],
  'editor.stackLayout': ['Авто-раскладка', 'Auto layout'],
  'editor.dirVertical': ['Колонка', 'Column'],
  'editor.dirHorizontal': ['Строка', 'Row'],
  'editor.dirAuto': ['Авто', 'Auto'],
  'editor.dirFree': ['Нет', 'None'],
  'editor.dirFreeHint': [
    'Без авто-раскладки: слои лежат там, где вы их поставили (текст на кнопке), и двигаются вместе со стеком. Колонка или строка выстроит их автоматически.',
    'No auto layout: the layers stay where you put them (a text on a button) and move with the stack. A column or a row lines them up automatically.',
  ],
  'editor.dirAutoHint': [
    'Авто: строка, когда холст шире высоты в N раз и больше, иначе колонка. Так один макет подходит и для горизонтальных, и для вертикальных размеров.',
    'Auto: a row when the canvas is at least N times wider than tall, a column otherwise — one design for landscape and portrait sizes.',
  ],
  'editor.autoRowRatio': ['Строка от N : 1', 'Row from N : 1'],
  'editor.gap': ['Промежуток', 'Gap'],
  'editor.alignItems': ['Выравнивание', 'Align'],
  'editor.al.start': ['Начало', 'Start'],
  'editor.al.center': ['Центр', 'Center'],
  'editor.al.end': ['Конец', 'End'],
  'editor.al.stretch': ['Растянуть', 'Stretch'],
  'editor.distribution': ['Распределение', 'Distribute'],
  'editor.js.start': ['В начале', 'Start'],
  'editor.js.center': ['По центру', 'Center'],
  'editor.js.end': ['В конце', 'End'],
  'editor.js.space-between': ['Между', 'Between'],
  'editor.clip': ['Обрезать содержимое', 'Clip content'],
  'editor.inStack': ['В стеке «{name}»', 'In stack “{name}”'],
  'editor.selectStack': ['Выбрать стек', 'Select stack'],
  'editor.grow': ['Заполнять свободное место', 'Fill free space'],
  'editor.earlier': ['Раньше', 'Earlier'],
  'editor.later': ['Позже', 'Later'],
  'editor.stackHint': [
    'Слои внутри стека выстраиваются автоматически: длинный текст отодвигает следующие элементы.',
    'Layers inside a stack are laid out automatically: longer text pushes the next items along.',
  ],
  'editor.stackFeatText': [
    'Текст стал длиннее — соседние слои сами сдвигаются',
    'Longer text pushes the next layers along by itself',
  ],
  'editor.stackFeatGrow': [
    'Слой может занять свободное место: у слоя включите «Заполнять свободное место»',
    'A layer can take the free space: turn on “Fill free space” on the layer',
  ],
  'editor.stackFeatAuto': [
    '«Авто»: строка в широких размерах, колонка в высоких',
    '“Auto”: a row in wide sizes, a column in tall ones',
  ],
  'editor.groupHint': [
    'Ctrl+G — собрать выделенное в стек, Ctrl+Shift+G — разгруппировать.',
    'Ctrl+G stacks the selection, Ctrl+Shift+G ungroups.',
  ],
  'editor.copy': ['Копировать', 'Copy'],
  'editor.paste': ['Вставить', 'Paste'],
  'editor.alignToPage': ['Выровнять по странице', 'Align to page'],
  'editor.alignSelection': ['Выровнять', 'Align'],
  'editor.order': ['Порядок', 'Order'],
  'editor.setAsBackground': ['Сделать фоном', 'Set as background'],
  'editor.editText': ['Редактировать текст', 'Edit text'],
  'editor.moreActions': ['Ещё действия', 'More actions'],
  'editor.opacityShort': ['Прозр.', 'Opac.'],
  'editor.alignLeft': ['По левому краю', 'Align left'],
  'editor.alignHCenter': ['По центру', 'Align center'],
  'editor.alignRight': ['По правому краю', 'Align right'],
  'editor.alignTop': ['По верху', 'Align top'],
  'editor.alignVCenter': ['По середине', 'Align middle'],
  'editor.alignBottom': ['По низу', 'Align bottom'],
  'editor.justify': ['По ширине', 'Justify'],
  'editor.distributeH': ['Распределить по горизонтали', 'Distribute horizontally'],
  'editor.distributeV': ['Распределить по вертикали', 'Distribute vertically'],
  'editor.arrange': ['Слой', 'Layer'],
  'editor.bringFront': ['На передний план', 'Bring to front'],
  'editor.bringForward': ['Выше', 'Bring forward'],
  'editor.sendBackward': ['Ниже', 'Send backward'],
  'editor.sendBack': ['На задний план', 'Send to back'],
  'editor.lock': ['Закрепить', 'Lock'],
  'editor.unlock': ['Открепить', 'Unlock'],
  'editor.hide': ['Скрыть', 'Hide'],
  'editor.show': ['Показать', 'Show'],
  'editor.duplicate': ['Дублировать', 'Duplicate'],
  'editor.layersSelected': ['Выбрано слоёв: {n}', '{n} layers selected'],
  'editor.clearSelection': ['Снять выделение', 'Clear selection'],
  'editor.typography': ['Шрифт', 'Typography'],
  'editor.italic': ['Курсив', 'Italic'],
  'editor.lineHeight': ['Межстрочный интервал', 'Line height'],
  'editor.lineHeightShort': ['↕', '↕'],
  'editor.letterSpacing': ['Межбуквенный интервал', 'Letter spacing'],
  'editor.letterSpacingShort': ['↔', '↔'],
  'editor.transformNone': ['Как есть', 'As typed'],
  'editor.uppercase': ['ЗАГЛАВНЫЕ', 'UPPERCASE'],
  'editor.lowercase': ['строчные', 'lowercase'],
  'editor.capitalize': ['Каждое Слово', 'Capitalize'],
  'editor.dynamicText': ['Длинный текст', 'Long text'],
  'editor.autoFit': ['Уменьшать шрифт, чтобы текст влез', 'Shrink font to fit the box'],
  'editor.minFontSize': ['Мин. размер', 'Min size'],
  'editor.maxLines': ['Макс. строк', 'Max lines'],
  'editor.autoFitHint': [
    'Пригодится, когда текст приходит из API: короткий останется крупным, длинный аккуратно уменьшится. 0 строк — без ограничения.',
    'Useful for API text: short text stays big, long text shrinks. 0 lines = unlimited.',
  ],
  'editor.textBox': ['Плашка текста', 'Text box'],
  'editor.padding': ['Внутренние отступы', 'Padding'],
  'editor.radius': ['Скругление', 'Radius'],
  'editor.effects': ['Эффекты', 'Effects'],
  'editor.stroke': ['Обводка', 'Stroke'],
  'editor.shadow': ['Тень', 'Shadow'],
  'editor.blurShort': ['Blur', 'Blur'],
  'editor.image': ['Изображение или видео', 'Image or video'],
  'editor.fitCover': ['Заполнить', 'Cover'],
  'editor.fitContain': ['Вписать', 'Contain'],
  'editor.fitFill': ['Растянуть', 'Stretch'],
  'editor.focusX': ['Фокус X', 'Focus X'],
  'editor.focusY': ['Фокус Y', 'Focus Y'],
  'editor.videoClip': ['Видео', 'Video'],
  'editor.videoClipHint': [
    'Ролик {s} с играет в анимации и видеорендере; в картинках виден его первый кадр.',
    'A {s} s clip: it plays in animations and video renders; still images show its first frame.',
  ],
  'editor.videoLoop': ['Повторять по кругу', 'Loop'],
  'editor.videoSound': ['Со звуком', 'With sound'],
  'editor.videoVolume': ['Громкость', 'Volume'],
  'editor.videoTrim': ['Фрагмент клипа', 'Part of the clip'],
  'editor.videoRemove': ['Оставить только кадр', 'Keep only the still frame'],
  'editor.videoPlay': ['Просмотреть видео', 'Preview video'],
  'editor.videoPause': ['Остановить просмотр', 'Stop preview'],
  'editor.videoMute': ['Выключить звук', 'Mute'],
  'editor.videoUnmute': ['Включить звук', 'Unmute'],
  'err.videoUnreadable': [
    'Не получилось прочитать видео: загрузите MP4, MOV или WEBM.',
    'Could not read the video: upload an MP4, MOV or WEBM file.',
  ],
  'editor.imageApiHint': [
    'Через API передайте URL: {"photo": "https://…"}. Фото обрежется по фокусу.',
    'Pass a URL via the API: {"photo": "https://…"}. The photo is cropped around the focus point.',
  ],
  'editor.style': ['Оформление', 'Style'],
  'editor.border': ['Рамка', 'Border'],
  'editor.brightness': ['Яркость', 'Brightness'],
  'editor.blur': ['Размытие', 'Blur'],
  'editor.grayscale': ['Ч/Б', 'Grayscale'],
  'editor.flipX': ['Отразить по горизонтали', 'Flip horizontally'],
  'editor.flipY': ['Отразить по вертикали', 'Flip vertically'],
  'editor.shape': ['Фигура', 'Shape'],
  'editor.line': ['Линия', 'Line'],
  'editor.width': ['Толщина', 'Width'],
  'editor.strokeSolid': ['Сплошная', 'Solid'],
  'editor.strokeDashed': ['Штрих', 'Dashed'],
  'editor.strokeDotted': ['Точки', 'Dotted'],
  'editor.qrColor': ['Цвет', 'Color'],
  'editor.qrMargin': ['Поля', 'Margin'],
  'editor.qrLevel': ['Коррекция', 'Error level'],
  'editor.pickColor': ['Выбрать цвет', 'Pick color'],
  'editor.docColors': ['Цвета шаблона', 'Template colors'],
  'fold.autoFit': ['подгонка шрифта', 'font fit'],
  'fold.maxLines': ['до {n} строк', 'up to {n} lines'],
  'fold.words': ['слов: {n}', '{n} words'],
  'fold.numbers': ['цифры', 'numbers'],
  'accent.bar': ['Акцент', 'Accent'],
  'accent.bold': ['Жирнее', 'Bolder'],
  'accent.underline': ['Подчеркнуть', 'Underline'],
  'accent.marker': ['Маркер', 'Marker'],
  'accent.markerOn': ['Добавить маркер', 'Add a marker'],
  'accent.markerOff': ['Убрать маркер', 'Remove the marker'],
  'accent.remove': ['Убрать акцент', 'Remove the accent'],
  'accent.more': ['Свой цвет, маркер, размер…', 'Own colour, marker, size…'],
  'accent.textColor': ['Текст', 'Text'],
  'accent.size': ['Размер', 'Size'],
  'accent.wordTitle': ['Акцент «{word}»', 'Accent “{word}”'],
  'accent.dragHint': [
    'Перетащите, чтобы видеть всю композицию',
    'Drag it away to see the whole composition',
  ],
  'accent.title': ['Акценты в тексте', 'Accents in the text'],
  'accent.hint': [
    'Двойной клик по тексту, выделите слово и выберите цвет над ним — или добавьте слово здесь. Слово выделяется в любом тексте, где оно есть, и в данных из таблицы тоже.',
    'Double-click the text, select a word and pick a colour above it, or add the word here. The word is accented in any text that has it, data from a table included.',
  ],
  'accent.wordPlaceholder': ['Слово или фраза', 'A word or a phrase'],
  'accent.add': ['Добавить', 'Add'],
  'accent.dataTitle': ['Акцент из данных', 'Accent from the data'],
  'accent.numbers': ['Цифры и проценты акцентом', 'Numbers and percentages as accents'],
  'accent.dataHint': [
    'В таблице или API: **слово** в тексте ячейки, или колонка «{layer}.accent» со словом (несколько — через «;»), или «{layer}.accent_color» с цветом.',
    'In a table or the API: **word** in the cell’s text, or a “{layer}.accent” column with the word (several split by “;”), or “{layer}.accent_color” with a colour.',
  ],
  'editor.colorOpacity': ['Непрозрачность', 'Opacity'],
  'editor.fillNone': ['Нет', 'None'],
  'editor.fillSolid': ['Цвет', 'Solid'],
  'editor.fillLinear': ['Линейный', 'Linear'],
  'editor.fillRadial': ['Радиальный', 'Radial'],
  'editor.angle': ['Угол', 'Angle'],
  'editor.addStop': ['Добавить цвет', 'Add stop'],
  'editor.searchFonts': ['Найти шрифт', 'Search fonts'],
  'editor.manageFonts': ['Управление шрифтами и загрузка своих', 'Manage and upload fonts'],
  'editor.weight100': ['Thin', 'Thin'],
  'editor.weight200': ['ExtraLight', 'ExtraLight'],
  'editor.weight300': ['Light', 'Light'],
  'editor.weight400': ['Regular', 'Regular'],
  'editor.weight500': ['Medium', 'Medium'],
  'editor.weight600': ['SemiBold', 'SemiBold'],
  'editor.weight700': ['Bold', 'Bold'],
  'editor.weight800': ['ExtraBold', 'ExtraBold'],
  'editor.weight900': ['Black', 'Black'],

  'preview.title': ['Генерация', 'Generate'],
  'preview.description': [
    'Подставьте данные и посмотрите результат таким, каким его вернёт API.',
    'Fill in the data and see the result exactly as the API returns it.',
  ],
  'preview.formatImage': ['Картинка', 'Image'],
  'preview.formatVideo': ['Видео', 'Video'],
  'preview.deviceHint': [
    'Видео создаётся на этом компьютере. Не закрывайте вкладку, пока рендер не закончится.',
    'The video is made on this computer. Keep the tab open until it finishes.',
  ],
  'preview.noFields': ['В шаблоне нет слоёв для подстановки.', 'The template has no layers yet.'],
  'preview.render': ['Сгенерировать', 'Render'],
  'preview.rendering': ['Рендерим…', 'Rendering…'],
  'preview.empty': ['Здесь появится результат', 'The result will appear here'],
  'preview.openPdf': ['Открыть PDF', 'Open PDF'],

  'apiDialog.title': ['Генерация через API', 'Generate via API'],
  'apiDialog.description': [
    'Слои этого шаблона и готовые примеры запросов',
    'Layers of this template and ready-to-use request samples',
  ],
  'apiDialog.reference': ['Полная документация API', 'Full API reference'],
  'apiDialog.layer': ['Слой', 'Layer'],
  'apiDialog.type': ['Тип', 'Type'],
  'apiDialog.properties': ['Свойства', 'Properties'],
  'apiDialog.hint': [
    'Ключ API создаётся в разделе «API и ключи». Вместо объекта можно передать строку: "title": "Текст" или "photo": "https://…".',
    'Create an API key under "API & keys". Instead of an object you can pass a string: "title": "Text" or "photo": "https://…".',
  ],

  'resize.title': ['Копия в другом размере', 'Copy in another size'],
  'resize.description': [
    'Создадим копию шаблона и адаптируем слои под новый размер',
    'We create a copy and adapt the layers to the new size',
  ],
  'resize.preset': ['Готовые размеры', 'Presets'],
  'resize.choosePreset': ['Выберите размер…', 'Choose a size…'],
  'resize.hint': [
    'Шаблоны разных размеров с одинаковыми именами слоёв можно генерировать одним запуском автоматизации.',
    'Templates of different sizes with the same layer names can be generated in a single automation run.',
  ],
  'resize.limitHint': [
    'Шаблонов на вашем тарифе: до {n}.',
    'Your plan allows up to {n} templates.',
  ],
  'resize.createCopy': ['Создать копию', 'Create copy'],
  'resize.created': ['Копия создана', 'Copy created'],

  // automations
  'automations.description': [
    'Массовая генерация: таблица данных × шаблоны → готовые файлы в ZIP, Google Drive, S3 или вебхук',
    'Bulk generation: data × templates → files in a ZIP, Google Drive, S3 or a webhook',
  ],
  'automations.new': ['Новая автоматизация', 'New automation'],
  'automations.emptyTitle': ['Автоматизаций пока нет', 'No automations yet'],
  'automations.emptyText': [
    'Загрузите CSV или подключите Google Таблицу, выберите шаблоны — и получите сотни креативов одним кликом или по расписанию.',
    'Upload a CSV or connect a Google Sheet, pick templates and get hundreds of creatives in one click or on a schedule.',
  ],
  'automations.disabled': ['Выключена', 'Disabled'],
  'automations.neverRun': ['Ещё не запускалась', 'Never run'],
  'automations.runNow': ['Запустить', 'Run now'],
  'automations.howTitle': ['Как это работает', 'How it works'],
  'automations.how1': [
    'Выберите один или несколько шаблонов (например, квадрат, сторис и баннер 728×90).',
    'Pick one or more templates (e.g. square, story and a 728×90 banner).',
  ],
  'automations.how2': [
    'Подключите данные: CSV, Google Таблица, URL с JSON/CSV или строки через API.',
    'Connect data: CSV, Google Sheet, a JSON/CSV URL or rows via the API.',
  ],
  'automations.how3': [
    'Сопоставьте колонки со слоями — колонки с именами слоёв подставятся автоматически.',
    'Map columns to layers — columns named like layers are mapped automatically.',
  ],
  'automations.how4': [
    'Выберите форматы и куда отправить результат. Запускайте вручную, по расписанию или из API.',
    'Choose formats and destinations. Run manually, on a schedule or from the API.',
  ],
  'automations.source.table': ['Таблица / CSV', 'Table / CSV'],
  'automations.source.google_sheets': ['Google Таблица', 'Google Sheet'],
  'automations.source.url': ['URL (CSV/JSON/XML)', 'URL (CSV/JSON/XML)'],
  'automations.source.api': ['Строки через API', 'Rows via API'],

  'automation.namePlaceholder': [
    'Название автоматизации, например «Карточки товаров»',
    'Automation name, e.g. "Product cards"',
  ],
  'automation.enabled': ['Включена', 'Enabled'],
  'automation.fold': ['Свернуть', 'Fold'],
  'automation.unfold': ['Развернуть', 'Unfold'],
  'automation.pickTemplates': ['Выбрать шаблоны ({n})', 'Pick templates ({n})'],
  'automation.changeTemplates': ['Изменить выбор', 'Change selection'],
  'automation.searchTemplates': ['Поиск шаблона', 'Search templates'],
  'automation.pickDone': ['Готово — дальше данные', 'Done — on to the data'],
  'automation.sumTemplates': ['Выбрано: {n}', 'Picked: {n}'],
  'automation.sumNoTemplates': ['Шаблоны не выбраны', 'No templates picked'],
  'automation.sumRows': ['строк: {n}', '{n} rows'],
  'automation.sumAuto': ['по именам слоёв', 'by layer names'],
  'automation.sumRules': ['правил: {n}', '{n} rules'],
  'automation.sumWebhook': ['Вебхук', 'Webhook'],
  'automation.sumManual': ['Вручную или через API', 'Manually or via the API'],
  'automation.step1': ['Шаблоны', 'Templates'],
  'automation.step1Hint': [
    'Каждая строка данных будет отрисована в каждом выбранном шаблоне. Выберите набор — добавятся все его размеры.',
    'Every data row is rendered with every selected template. Pick a set to add all of its sizes.',
  ],
  'automation.noTemplates': ['Сначала создайте шаблон.', 'Create a template first.'],
  'automation.step2': ['Данные', 'Data'],
  'automation.step2Hint': [
    'Одна строка — один комплект креативов',
    'One row = one set of creatives',
  ],
  'automation.uploadCsv': ['Загрузить CSV', 'Upload CSV'],
  'automation.csvLoaded': ['Загружено строк: {n}', 'Loaded {n} rows'],
  'automation.columnsFromLayers': ['Колонки из слоёв', 'Columns from layers'],
  'automation.addColumn': ['Колонка', 'Column'],
  'automation.addRow': ['Строка', 'Row'],
  'automation.rowsCount': ['Строк: {n}', '{n} rows'],
  'automation.rowsHidden': [
    'Ещё {n} строк не показаны, но будут сгенерированы.',
    '{n} more rows are hidden but will be rendered.',
  ],
  'automation.tableHint': [
    'Колонка с именем слоя (title) подставит основное значение, колонка «слой.свойство» (title.color) — конкретное свойство. Пустая ячейка оставляет значение из шаблона.',
    'A column named like a layer (title) sets its main value; "layer.property" (title.color) sets a property. Empty cells keep the template value.',
  ],
  'automation.sheetUrl': ['Ссылка на Google Таблицу', 'Google Sheet link'],
  'automation.sheetHint': [
    'Публичная таблица («доступ по ссылке») работает без подключения аккаунта. Первая строка — заголовки.',
    'A sheet shared via link works without connecting an account. The first row must contain headers.',
  ],
  'automation.googleAccount': ['Аккаунт Google', 'Google account'],
  'automation.publicSheet': ['Публичная ссылка (без аккаунта)', 'Public link (no account)'],
  'automation.sheetName': ['Лист', 'Sheet'],
  'automation.firstSheet': ['первый лист', 'first sheet'],
  'automation.testSource': ['Проверить и показать данные', 'Test and preview data'],
  'automation.sourceOk': ['Получено строк: {n}, колонок: {c}', '{n} rows, {c} columns loaded'],
  'automation.urlHint': [
    'Данные загружаются при каждом запуске — удобно для фидов товаров',
    'Fetched on every run — great for product feeds',
  ],
  'automation.format': ['Формат', 'Format'],
  'automation.xmlHint': [
    'Фиды Google Merchant и Meta (RSS/Atom), YML для Rozetka и Prom или любой XML. Из каждого товара получаются колонки title, price, old_price, discount, currency, image, link, brand, category — назовите так слои, и они заполнятся сами.',
    'Google Merchant and Meta feeds (RSS/Atom), YML for Rozetka and Prom, or any XML. Each product gets the columns title, price, old_price, discount, currency, image, link, brand and category — name your layers like that and they fill in by themselves.',
  ],
  'automation.onlyChanged': ['Только новые и изменённые строки', 'Only new and changed rows'],
  'automation.onlyChangedHint': [
    'Запуск рендерит только то, что появилось или изменилось с прошлого раза (цена, фото, название). Изменили шаблон, сопоставление или формат — перерисуется всё. Удобно для ежедневного фида: не тратит генерации на те же баннеры.',
    'A run renders only what is new or changed since the last one (price, photo, name). Change the template, mapping or output and everything is rendered again. Ideal for a daily feed: no renders spent on the same banners.',
  ],
  'automation.keyColumn': ['Колонка-идентификатор', 'Key column'],
  'automation.keyColumnHint': [
    'По ней строка узнаётся от запуска к запуску — обычно id или артикул',
    'Recognises a row from run to run — usually id or SKU',
  ],
  'automation.keyWholeRow': ['— вся строка целиком —', '— the whole row —'],
  'automation.unchangedShort': ['без изменений: {n}', '{n} unchanged'],
  'batch.unchanged': ['Пропущено строк без изменений: {n}', '{n} unchanged rows skipped'],
  'batch.nothingChanged': [
    'С прошлого запуска ничего не изменилось ({n} строк) — генерации не потрачены.',
    'Nothing changed since the last run ({n} rows) — no renders used.',
  ],
  'err.xmlEntities': [
    'XML с объявлениями сущностей (<!ENTITY>) не поддерживается',
    'XML with entity declarations (<!ENTITY>) is not supported',
  ],
  'err.xmlParse': ['Не удалось прочитать XML: {detail}', 'Couldn’t read the XML: {detail}'],
  'err.feedEmpty': ['В XML-фиде не найдено товаров', 'No products found in the XML feed'],
  'automation.apiHint': [
    'Строки передаются в теле запроса при запуске — удобно для интеграции с CRM, 1С, n8n, Make, Zapier.',
    'Rows are sent in the request body — handy for CRMs, n8n, Make and Zapier.',
  ],
  'automation.step3': ['Сопоставление полей', 'Field mapping'],
  'automation.step3Hint': ['Что подставить в каждый слой', 'What goes into each layer'],
  'automation.autoMap': ['Автосопоставление по именам', 'Auto-map by name'],
  'automation.autoMapHint': [
    'Колонки, совпадающие с именами слоёв, подставляются сами',
    'Columns matching layer names are mapped automatically',
  ],
  'automation.selectTemplatesFirst': [
    'Выберите шаблоны, чтобы увидеть их слои.',
    'Select templates to see their layers.',
  ],
  'automation.templatesLoadFailed': [
    'Не удалось загрузить поля шаблонов.',
    'Could not load the template fields.',
  ],
  'automation.noFieldsInTemplates': [
    'В выбранных шаблонах нет слоёв для заполнения.',
    'The selected templates have no layers to fill.',
  ],
  'automation.value': ['Значение', 'Value'],
  'automation.sample': ['Пример (1-я строка)', 'Sample (row 1)'],
  'automation.inTemplates': ['в {n} из {total}', 'in {n} of {total}'],
  'automation.auto': ['Авто: колонка {column}', 'Auto: column {column}'],
  'automation.keepTemplate': ['Как в шаблоне', 'Keep template value'],
  'automation.column': ['Колонка', 'Column'],
  'automation.static': ['Фиксированное значение', 'Fixed value'],
  'automation.extraRules': ['Дополнительные правила', 'Extra rules'],
  'automation.extraRulesHint': [
    'Например, цвет плашки из колонки color или фиксированный цвет текста.',
    'E.g. badge color from a "color" column or a fixed text color.',
  ],
  'automation.addRule': ['Добавить правило', 'Add rule'],
  'automation.previewFirstRow': ['Превью первой строки', 'Preview first row'],
  'automation.livePreview': ['Живой предпросмотр', 'Live preview'],
  'automation.prevRow': ['Предыдущая строка', 'Previous row'],
  'automation.nextRow': ['Следующая строка', 'Next row'],
  'automation.rowN': ['строка {n} из {total}', 'row {n} of {total}'],
  'automation.livePreviewHint': [
    'Наведите на слой в таблице — он подсветится здесь. Клик по элементу на макете покажет его строку.',
    'Hover a layer in the table to outline it here. Click an element of the design to find its row.',
  ],
  'automation.livePreviewMedia': [
    'Картинки из медиатеки ({layers}) подставятся при генерации',
    'Pictures from the media library ({layers}) are put in when rendering',
  ],
  'automation.livePreviewFailed': [
    'Значение не подходит, слой останется как в шаблоне: {layers}',
    'Value not usable, the layer stays as in the template: {layers}',
  ],
  'automation.lockedLayer': [
    'Заблокирован в редакторе — автоматизация его не меняет',
    'Locked in the editor: the automation leaves it as designed',
  ],
  'automation.step4': ['Формат файлов', 'Output'],
  'automation.formats': ['Форматы', 'Formats'],
  'automation.scale': ['Масштаб', 'Scale'],
  'automation.scaleCapped': [
    'Большие шаблоны выйдут меньше: {list}. Картинка — не больше {side} px по стороне и {mpx} Мп.',
    'Large templates come out smaller: {list}. Images stay within {side} px per side and {mpx} Mpx.',
  ],
  'automation.scaleNotUsed': [
    'PDF векторный, видео — в размере шаблона: масштаб на них не влияет.',
    'PDF is vector and videos keep the template size: scale doesn’t apply.',
  ],
  'automation.quality': ['Качество JPG/WEBP', 'JPG/WEBP quality'],
  'automation.filename': ['Имя файла', 'File name'],
  'automation.filenameHint': [
    'Плейсхолдеры: {{template}}, {{index}}, {{date}}, {{format}}, {{row.колонка}}',
    'Placeholders: {{template}}, {{index}}, {{date}}, {{format}}, {{row.column}}',
  ],
  'automation.folders': ['Папки для файлов', 'Folders for the files'],
  'automation.foldersHint': [
    'Для ZIP, Google Drive и S3. Выберите по порядку, как раскладывать файлы: первая — внешняя папка. Без выбора все файлы лежат вместе.',
    'For the ZIP, Google Drive and S3. Pick in order how to sort the files: the first is the outer folder. Nothing picked: all files together.',
  ],
  'automation.folderExampleTemplate': ['Шаблон', 'Template'],
  'automation.folderBy.template': ['По шаблону', 'By template'],
  'automation.folderBy.size': ['По размеру', 'By size'],
  'automation.folderBy.format': ['По формату', 'By format'],
  'automation.folderBy.column': ['По колонке', 'By column'],
  'automation.step5': ['Куда отправить', 'Destinations'],
  'automation.step5Hint': ['Можно выбрать несколько', 'Choose one or more'],
  'automation.destZip': ['ZIP-архив для скачивания', 'ZIP archive to download'],
  'automation.connectGoogle': ['Подключить Google', 'Connect Google'],
  'automation.connectS3': ['Подключить S3', 'Connect S3'],
  'automation.folderName': ['Папка', 'Folder'],
  'automation.subfolderPerRun': ['Подпапка на каждый запуск', 'Subfolder per run'],
  'automation.step6': ['Расписание', 'Schedule'],
  'automation.step6Hint': [
    'Например, каждое утро забирать фид и обновлять креативы',
    'E.g. pull the feed every morning and refresh creatives',
  ],
  'automation.scheduleOn': ['Запускать по расписанию', 'Run on a schedule'],
  'automation.frequency': ['Периодичность', 'Frequency'],
  'automation.timezone': ['Часовой пояс', 'Time zone'],
  'automation.nextRuns': ['Ближайшие запуски', 'Next runs'],
  'automation.invalidCron': ['Некорректное cron-выражение', 'Invalid cron expression'],
  'automation.cron.hourly': ['Каждый час', 'Every hour'],
  'automation.cron.daily': ['Каждый день в 9:00', 'Daily at 9:00'],
  'automation.cron.weekly': ['По понедельникам в 9:00', 'Mondays at 9:00'],
  'automation.cron.monthly': ['1-го числа в 9:00', 'Monthly on the 1st at 9:00'],
  'automation.cron.custom': ['Своё выражение', 'Custom'],
  'automation.runs': ['История запусков', 'Run history'],
  'automation.estimate': ['Будет создано файлов: {n}', '{n} files will be generated'],
  'automation.estimateUnknown': [
    'Количество станет известно после загрузки данных',
    'The count is known once data is loaded',
  ],
  'automation.overLimit': [
    'больше лимита тарифа ({n} за запуск)',
    'over your plan limit ({n} per run)',
  ],
  'automation.saveAndRun': ['Сохранить и запустить', 'Save and run'],
  'automation.saved': ['Автоматизация сохранена', 'Automation saved'],
  'automation.deleteTitle': ['Удалить автоматизацию?', 'Delete automation?'],
  'automation.deleteText': [
    'История запусков и сгенерированные файлы останутся.',
    'Run history and generated files are kept.',
  ],

  'destination.zip': ['ZIP-архив', 'ZIP archive'],
  'destination.google_drive': ['Google Drive', 'Google Drive'],
  'destination.s3': ['Amazon S3 / совместимое хранилище', 'Amazon S3 / compatible'],
  'destination.webhook': ['Вебхук', 'Webhook'],

  // batches & renders
  'batch.title': ['Запуск', 'Run'],
  'batch.status.pending': ['Подготовка', 'Preparing'],
  'batch.status.processing': ['Генерация', 'Rendering'],
  'batch.status.done': ['Готово', 'Done'],
  'batch.status.partial': ['Частично', 'Partial'],
  'batch.status.failed': ['Ошибка', 'Failed'],
  'batch.trigger.manual': ['вручную', 'manual'],
  'batch.trigger.schedule': ['по расписанию', 'scheduled'],
  'batch.trigger.api': ['через API', 'via API'],
  'batch.total': ['всего', 'total'],
  'batch.done': ['готово', 'done'],
  'batch.failed': ['ошибок', 'failed'],
  'batch.finished': ['Завершён', 'Finished'],
  'batch.downloadZip': ['Скачать ZIP', 'Download ZIP'],
  'batch.deliveries': ['Доставка', 'Delivery'],
  'batch.files': ['файлов: {n}', '{n} files'],
  'batch.showingFirst': [
    'Показаны первые 200 файлов — все файлы есть в ZIP-архиве.',
    'Showing the first 200 files — all files are in the ZIP archive.',
  ],

  'renders.description': ['Все сгенерированные изображения и PDF', 'Every generated image and PDF'],
  'renders.tabRenders': ['Файлы', 'Files'],
  'renders.tabBatches': ['Пакеты', 'Batches'],
  'renders.allStatuses': ['Все статусы', 'All statuses'],
  'renders.allSources': ['Все источники', 'All sources'],
  'renders.file': ['Файл', 'File'],
  'renders.status': ['Статус', 'Status'],
  'renders.source': ['Источник', 'Source'],
  'renders.size': ['Размер', 'Size'],
  'renders.created': ['Создан', 'Created'],
  'renders.duration': ['Время', 'Duration'],
  'renders.modifications': ['Переданные данные', 'Modifications'],
  'renders.emptyTitle': ['Генераций пока нет', 'No renders yet'],
  'renders.emptyText': [
    'Запустите автоматизацию или отправьте запрос в API — результаты появятся здесь.',
    'Run an automation or call the API — results show up here.',
  ],
  'renders.noBatches': ['Пакетных запусков пока нет', 'No batches yet'],
  'renders.loadMore': ['Показать ещё', 'Load more'],
  'renders.sources.api': ['API', 'API'],
  'renders.sources.editor': ['Редактор', 'Editor'],
  'renders.sources.automation': ['Автоматизация', 'Automation'],
  'renders.sources.url': ['Подписанная ссылка', 'Signed URL'],
  'renders.statuses.queued': ['В очереди', 'Queued'],
  'renders.statuses.rendering': ['Рендерится', 'Rendering'],
  'renders.statuses.done': ['Готово', 'Done'],
  'renders.statuses.failed': ['Ошибка', 'Failed'],

  // assets & fonts
  'assets.description': [
    'Фото, логотипы и иконки для шаблонов',
    'Photos, logos and icons for your templates',
  ],
  'assets.storage': ['Хранилище: {used} из {limit}', 'Storage: {used} of {limit}'],
  'assets.drop': [
    'Перетащите фото или видео или нажмите для выбора (PNG, JPG, WEBP, SVG, GIF, MP4, MOV, WEBM)',
    'Drop images or videos or click to choose (PNG, JPG, WEBP, SVG, GIF, MP4, MOV, WEBM)',
  ],
  'assets.importUrl': ['Импорт по URL', 'Import from URL'],
  'assets.emptyTitle': ['Медиатека пуста', 'Your media library is empty'],
  'assets.emptyText': [
    'Загрузите логотипы и фото, чтобы использовать их в шаблонах.',
    'Upload logos and photos to use them in templates.',
  ],
  'assets.copyUrl': ['Копировать URL', 'Copy URL'],
  'assets.deleteTitle': ['Удалить файл?', 'Delete file?'],
  'assets.deleteText': [
    'Шаблоны, где он используется, покажут пустое место.',
    'Templates using it will show an empty area.',
  ],

  'fonts.description': [
    'Включайте нужные шрифты и загружайте фирменные — они будут доступны в редакторе и при генерации',
    'Enable the fonts you need and upload brand fonts — available in the editor and in renders',
  ],
  'fonts.custom': ['Свои шрифты', 'Custom fonts'],
  'fonts.builtin': ['Встроенные', 'Built-in'],
  'fonts.customBadge': ['свой', 'custom'],
  'fonts.customLocked': [
    'Свои шрифты — на тарифах Pro и Business',
    'Custom fonts on Pro and Business plans',
  ],
  'fonts.filterAll': ['Все', 'All'],
  'fonts.filterEnabled': ['Включённые', 'Enabled'],
  'fonts.filterCyrillic': ['С кириллицей', 'Cyrillic'],
  'fonts.sampleText': [
    'Съешь ещё этих мягких французских булок',
    'The quick brown fox jumps over the lazy dog',
  ],
  'fonts.cyrillic': ['Кириллица', 'Cyrillic'],
  'fonts.cyrShort': ['Кир', 'Cyr'],
  'fonts.sample': ['Текст для предпросмотра', 'Preview text'],
  'fonts.enabledCount': ['Включено {n} из {total}', '{n} of {total} enabled'],
  'fonts.disableHint': [
    'Отключённые шрифты скрываются из редактора, но уже созданные шаблоны продолжат рендериться корректно.',
    'Disabled fonts are hidden from the editor, existing templates keep rendering correctly.',
  ],
  'fonts.files': ['Загруженные файлы', 'Uploaded files'],
  'fonts.uploadTitle': ['Загрузить шрифт', 'Upload font'],
  'fonts.uploadHint': [
    'TTF, OTF, WOFF или WOFF2. Каждое начертание — отдельный файл с тем же семейством.',
    'TTF, OTF, WOFF or WOFF2. Upload each weight as a separate file with the same family.',
  ],
  'fonts.dropFont': ['Перетащите файл шрифта или нажмите', 'Drop a font file or click'],
  'fonts.family': ['Семейство', 'Family'],
  'fonts.familyHint': [
    'Оставьте пустым — возьмём из файла',
    'Leave empty to read it from the file',
  ],
  'fonts.weight': ['Насыщенность', 'Weight'],
  'fonts.style': ['Начертание', 'Style'],
  'fonts.auto': ['Определить автоматически', 'Detect automatically'],
  'fonts.upload': ['Загрузить', 'Upload'],
  'fonts.uploaded': ['Шрифт {family} {weight} загружен', 'Font {family} {weight} uploaded'],
  'fonts.deleteTitle': ['Удалить файл шрифта?', 'Delete font file?'],
  'fonts.deleteText': [
    'Шаблоны с этим начертанием будут использовать запасной шрифт.',
    'Templates using this weight will fall back to another font.',
  ],

  // API page
  'api.description': [
    'Подключите генерацию к своему сайту, CRM или скриптам',
    'Connect rendering to your site, CRM or scripts',
  ],
  'api.keys': ['API-ключи', 'API keys'],
  'api.keysHint': [
    'Ключ даёт доступ ко всем шаблонам пространства. Храните его на сервере.',
    'A key gives access to all templates in the workspace. Keep it on your server.',
  ],
  'api.createKey': ['Создать ключ', 'Create key'],
  'api.adminOnly': ['Управлять ключами могут администраторы.', 'Only admins can manage keys.'],
  'api.noKeys': ['Ключей пока нет', 'No keys yet'],
  'api.created': ['создан', 'created'],
  'api.lastUsed': ['использован', 'used'],
  'api.neverUsed': ['не использовался', 'never used'],
  'api.revoke': ['Отозвать', 'Revoke'],
  'api.revokeTitle': ['Отозвать ключ?', 'Revoke key?'],
  'api.revokeText': [
    'Запросы с ключом «{name}» сразу перестанут работать.',
    'Requests with "{name}" will stop working immediately.',
  ],
  'api.keyCreated': ['Ключ создан', 'Key created'],
  'api.copyNow': [
    'Скопируйте ключ сейчас — больше мы его не покажем.',
    "Copy the key now — we won't show it again.",
  ],
  'api.keyNameHint': ['Например, где он используется', 'E.g. where it is used'],
  'api.quickstart': ['Быстрый старт', 'Quickstart'],
  'api.reference': ['Документация', 'Reference'],
  'api.tabSingle': ['Одна картинка', 'Single image'],
  'api.tabBatch': ['Пакет', 'Batch'],
  'api.tabAsync': ['Асинхронно', 'Async'],
  'api.layersHelp': [
    'изменения по именам слоёв: строка — основное значение, объект — свойства, null — скрыть слой.',
    'changes by layer name: a string sets the main value, an object sets properties, null hides the layer.',
  ],
  'api.scaleHelp': ['2 для ретины.', '2 for retina.'],
  'api.webhookHelp': [
    'уведомим, когда файл готов (подпись HMAC).',
    'we notify you when the file is ready (HMAC signed).',
  ],
  'api.signedTitle': ['Подписанные ссылки на картинки', 'Signed image URLs'],
  'api.signedHint': [
    'Картинка генерируется при первом открытии ссылки и кэшируется. Подходит для email-рассылок, Open Graph и лендингов — без серверного кода.',
    'The image renders on first request and is cached. Ideal for emails, Open Graph and landing pages — no server code needed.',
  ],
  'api.generateUrl': ['Сгенерировать ссылку', 'Generate URL'],
  'api.urlAppearsHere': ['Ссылка и превью появятся здесь', 'The URL and preview appear here'],
  'api.signingSecret': ['Секрет подписи', 'Signing secret'],
  'api.signingSecretHint': [
    'Им подписываются ссылки и вебхуки. Подписывайте ссылки на своей стороне — пример ниже.',
    'Used to sign URLs and webhooks. Sign URLs on your side — see the example.',
  ],
  'api.reveal': ['Показать', 'Reveal'],
  'api.rotate': ['Сменить секрет', 'Rotate secret'],
  'api.rotateTitle': ['Сменить секрет?', 'Rotate secret?'],
  'api.rotateText': [
    'Все ранее выданные подписанные ссылки перестанут работать, вебхуки начнут подписываться новым секретом.',
    'All previously issued signed URLs stop working and webhooks will use the new secret.',
  ],

  // integrations
  'integrations.description': [
    'Откуда брать данные и куда складывать готовые файлы',
    'Where data comes from and where files go',
  ],
  'integrations.locked': [
    'Интеграции доступны на тарифах Starter и выше.',
    'Integrations are available on Starter and above.',
  ],
  'integrations.googleHint': [
    'Чтение Google Таблиц и выгрузка файлов в Google Drive',
    'Read Google Sheets and upload files to Google Drive',
  ],
  'integrations.googleNotConfigured': [
    'Google OAuth не настроен на сервере (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET). Публичные таблицы работают и без него.',
    'Google OAuth is not configured on the server (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET). Public sheets work without it.',
  ],
  'integrations.connectGoogle': ['Подключить аккаунт Google', 'Connect Google account'],
  'integrations.googleConnected': ['Google подключён', 'Google connected'],
  'integrations.googleReconnected': [
    'Этот аккаунт Google уже подключён — доступ обновлён',
    'This Google account was already connected — its access is renewed',
  ],
  'integrations.googleFailed': ['Не удалось подключить Google', 'Could not connect Google'],
  'integrations.s3Short': [
    'AWS, Cloudflare R2, MinIO, Backblaze B2, DigitalOcean Spaces…',
    'AWS, Cloudflare R2, MinIO, Wasabi, DigitalOcean…',
  ],
  'integrations.addBucket': ['Добавить бакет', 'Add bucket'],
  'integrations.s3Title': ['Подключение S3', 'Connect S3'],
  'integrations.s3Hint': [
    'Проверим доступ, записав служебный файл .bannermatic-check',
    'We verify access by writing a .bannermatic-check marker file',
  ],
  'integrations.endpointHint': ['Для не-AWS хранилищ', 'For non-AWS providers'],
  'integrations.publicBase': ['Публичный адрес (необязательно)', 'Public base URL (optional)'],
  'integrations.testAndSave': ['Проверить и сохранить', 'Test and save'],
  'integrations.connected': ['Подключено', 'Connected'],
  'integrations.webhooks': ['Вебхуки', 'Webhooks'],
  'integrations.webhooksHint': [
    'POST-уведомления о готовых рендерах и пакетах, подписанные HMAC-SHA256',
    'POST notifications about finished renders and batches, signed with HMAC-SHA256',
  ],
  'integrations.defaultWebhook': [
    'Вебхук по умолчанию для автоматизаций',
    'Default webhook for automations',
  ],
  'integrations.defaultWebhookHint': [
    'Получает batch.completed после каждого запуска',
    'Receives batch.completed after every run',
  ],
  'integrations.testWebhook': ['Тестовый вебхук', 'Test webhook'],
  'integrations.send': ['Отправить', 'Send'],
  'integrations.testSent': ['Тестовое событие поставлено в очередь', 'Test event queued'],
  'integrations.verifyTitle': ['Проверка подписи', 'Verify the signature'],
  'integrations.recentDeliveries': ['Последние доставки', 'Recent deliveries'],
  'integrations.removeTitle': ['Отключить интеграцию?', 'Remove integration?'],
  'integrations.removeText': [
    'Автоматизации, которые её используют, не смогут доставить файлы.',
    'Automations using it will fail to deliver files.',
  ],

  // settings & billing
  'settings.tabGeneral': ['Основное', 'General'],
  'settings.tabMembers': ['Команда', 'Team'],
  'settings.tabBilling': ['Тариф', 'Billing'],
  'settings.tabProfile': ['Профиль', 'Profile'],
  'settings.workspace': ['Рабочее пространство', 'Workspace'],
  'settings.dangerZone': ['Опасная зона', 'Danger zone'],
  'settings.deleteWorkspace': ['Удалить пространство', 'Delete workspace'],
  'settings.deleteWorkspaceText': [
    'Удалятся все шаблоны, файлы, ключи и история генераций. Действие необратимо.',
    'All templates, files, keys and render history will be deleted. This cannot be undone.',
  ],
  'settings.deleteWorkspaceConfirm': [
    'Точно удалить «{name}» со всеми данными?',
    'Really delete "{name}" with all its data?',
  ],
  'settings.lastWorkspace': [
    'Это ваше единственное пространство, поэтому удалить его нельзя.',
    'This is your only workspace, so it cannot be deleted.',
  ],
  'workspace.noneTitle': ['У вас нет рабочего пространства', 'You have no workspace yet'],
  'workspace.noneText': [
    'Создайте пространство, чтобы работать с шаблонами, или попросите коллег пригласить вас в своё.',
    'Create a workspace to work with templates, or ask your teammates to invite you to theirs.',
  ],
  'settings.invite': ['Пригласить в команду', 'Invite teammates'],
  'settings.inviteHint': [
    'Отправим письмо со ссылкой-приглашением.',
    'We will email an invitation link.',
  ],
  'settings.seats': ['Мест: {used} из {limit}.', 'Seats: {used} of {limit}.'],
  'settings.sendInvite': ['Пригласить', 'Invite'],
  'settings.invited': ['Приглашение отправлено', 'Invitation sent'],
  'settings.inviteLink': ['Ссылка', 'Link'],
  'settings.you': ['вы', 'you'],
  'settings.remove': ['Удалить из команды', 'Remove from team'],
  'settings.pendingInvites': ['Ожидают принятия', 'Pending invitations'],
  'settings.expires': ['до', 'expires'],
  'settings.rolesTitle': ['Роли', 'Roles'],
  'settings.roleOwner': [
    'всё, включая оплату и удаление пространства',
    'everything, including billing and deletion',
  ],
  'settings.roleAdmin': ['команда, API-ключи, интеграции', 'team, API keys, integrations'],
  'settings.roleEditor': [
    'шаблоны, медиа, шрифты, автоматизации и генерация',
    'templates, media, fonts, automations and rendering',
  ],
  'settings.roleViewer': ['просмотр шаблонов и результатов', 'view templates and results'],
  'settings.language': ['Язык интерфейса', 'Interface language'],
  'settings.changePassword': ['Сменить пароль', 'Change password'],
  'settings.currentPassword': ['Текущий пароль', 'Current password'],
  'settings.passwordChanged': ['Пароль изменён', 'Password changed'],

  'billing.currentPlan': ['Текущий тариф', 'Current plan'],
  'billing.renewsOn': ['Продление', 'Renews on'],
  'billing.endsOn': ['Действует до', 'Ends on'],
  'billing.manage': ['Управление подпиской', 'Manage subscription'],
  'billing.rendersPeriod': ['Генерации в текущем периоде', 'Renders this period'],
  'billing.storage': ['Хранилище', 'Storage'],
  'billing.plans': ['Тарифы', 'Plans'],
  'billing.monthly': ['Помесячно', 'Monthly'],
  'billing.yearly': ['Годовой (−{n}%)', 'Yearly (−{n}%)'],
  'billing.mo': ['мес', 'mo'],
  'billing.popular': ['Популярный', 'Popular'],
  'billing.current': ['Текущий тариф', 'Current plan'],
  'billing.choose': ['Выбрать', 'Choose'],
  'billing.thanks': [
    'Спасибо! Подписка активируется в течение минуты.',
    'Thank you! Your subscription activates within a minute.',
  ],
  'billing.switched': ['Тариф изменён', 'Plan changed'],
  'billing.devMode': [
    'Оплата не подключена: включён режим разработки — тариф переключается без оплаты. Для продакшена подключите Lemon Squeezy (LEMONSQUEEZY_API_KEY) или Stripe (STRIPE_SECRET_KEY).',
    'Payments are not configured: development mode lets you switch plans without paying. Connect Lemon Squeezy (LEMONSQUEEZY_API_KEY) or Stripe (STRIPE_SECRET_KEY) for production.',
  ],
  'billing.noStripe': [
    'Оплата не настроена на сервере. Обратитесь к администратору.',
    'Payments are not configured on this server. Contact your administrator.',
  ],
  'billing.fRenders': ['Генераций в месяц: {n}', '{n} renders / month'],
  'billing.fTemplates': ['Шаблонов: до {n}', 'Up to {n} templates'],
  'billing.fTemplatesUnlimited': ['Безлимит шаблонов', 'Unlimited templates'],
  'billing.fMembers': ['Участников: до {n}', 'Up to {n} members'],
  'billing.fMembersUnlimited': ['Безлимит участников', 'Unlimited members'],
  'billing.fAutomations': ['Автоматизаций: до {n}', 'Up to {n} automations'],
  'billing.fAutomationsUnlimited': ['Безлимит автоматизаций', 'Unlimited automations'],
  'billing.fBatch': ['Файлов за запуск: до {n}', 'Up to {n} files per run'],
  'billing.fFonts': ['Свои шрифты', 'Custom fonts'],
  'billing.fIntegrations': ['Google Drive, Sheets, S3', 'Google Drive, Sheets, S3'],
  'billing.fSigned': ['Подписанные ссылки на картинки', 'Signed image URLs'],
  'billing.fSchedule': ['Автоматизации по расписанию', 'Scheduled automations'],
  'billing.fNoWatermark': ['Без водяного знака', 'No watermark'],

  // landing
  'landing.navFeatures': ['Возможности', 'Features'],
  'landing.navSpreadsheets': ['Таблицы', 'Spreadsheets'],
  'landing.navPricing': ['Цены', 'Pricing'],
  'landing.navDocs': ['Документация API', 'API docs'],
  'landing.login': ['Войти', 'Sign in'],
  'landing.startFree': ['Начать бесплатно', 'Start for free'],
  'landing.openApp': ['Открыть приложение', 'Open app'],
  'landing.badge': ['Шаблоны · Таблицы · API', 'Templates · Spreadsheets · API'],
  'landing.title': [
    'Сотни баннеров по одному шаблону — за минуты',
    'Hundreds of banners from one template — in minutes',
  ],
  'landing.subtitle': [
    'Соберите шаблон в визуальном редакторе, а дальше подставляйте тексты, фото, цены и логотипы через API, Google Таблицы или CSV. На выходе — PNG, JPG, WEBP и PDF.',
    'Design a template in the visual editor, then feed texts, photos, prices and logos via the API, Google Sheets or CSV. Get PNG, JPG, WEBP and PDF.',
  ],
  'landing.ctaPrimary': ['Создать первый шаблон', 'Create your first template'],
  'landing.ctaSecondary': ['Посмотреть API', 'See the API'],
  'landing.noCard': [
    'Бесплатный тариф навсегда. Без привязки карты.',
    'Free forever plan. No credit card.',
  ],
  'landing.demoRows': ['строк: {n}', '{n} rows'],
  'landing.uc1': ['Карточки товаров для маркетплейсов', 'Marketplace product cards'],
  'landing.uc2': ['Медийная реклама во всех размерах', 'Display ads in every size'],
  'landing.uc3': ['Посты и сторис для соцсетей', 'Social posts & stories'],
  'landing.uc4': ['OG-картинки и email-баннеры', 'OG images & email banners'],
  'landing.demo1Title': ['Летняя распродажа', 'Summer sale'],
  'landing.demo1Subtitle': ['Скидки на всю коллекцию', 'Discounts on the whole collection'],
  'landing.demo2Title': ['Новая коллекция кроссовок для бега', 'New running sneakers collection'],
  'landing.demo2Subtitle': ['Лёгкие, быстрые, дышащие', 'Light, fast, breathable'],
  'landing.demo3Title': ['Black Friday', 'Black Friday'],
  'landing.demo3Subtitle': ['Только 3 дня — успейте', 'Only 3 days — hurry up'],
  'landing.demo4Title': ['Подарочные сертификаты', 'Gift cards'],
  'landing.demo4Subtitle': ['Идеальный подарок к праздникам', 'The perfect holiday gift'],
  'landing.demoFrom': ['от {price}', 'from {price}'],
  'landing.uc5': ['Сертификаты и прайсы в PDF', 'Certificates & price lists in PDF'],
  'landing.featuresTitle': [
    'Всё для потоковой генерации креативов',
    'Everything for creative automation',
  ],
  'landing.featuresSubtitle': [
    'Дизайнер делает шаблон один раз, а дальше креативы собираются сами — из API, таблиц и фидов.',
    'Designers build a template once, then creatives assemble themselves from the API, spreadsheets and feeds.',
  ],
  'landing.f1Title': ['Визуальный редактор', 'Visual editor'],
  'landing.f1Text': [
    'Слои, текст, фото, логотипы, фигуры, QR-коды, градиенты, тени, умные направляющие, автоподгонка длинного текста.',
    'Layers, text, photos, logos, shapes, QR codes, gradients, shadows, smart guides and auto-fitting text.',
  ],
  'landing.f2Title': ['REST API', 'REST API'],
  'landing.f2Text': [
    'Синхронные и асинхронные рендеры, пакеты до тысяч файлов, вебхуки с подписью, OpenAPI-документация.',
    'Sync and async renders, batches of thousands of files, signed webhooks and OpenAPI docs.',
  ],
  'landing.f3Title': ['Студия автоматизации', 'Automation studio'],
  'landing.f3Text': [
    'CSV, Google Таблицы, товарные фиды Google Merchant, Meta и YML (Rozetka, Prom) × несколько шаблонов → ZIP, Google Drive, S3 или вебхук. По расписанию — только изменившиеся товары.',
    'CSV, Google Sheets, Google Merchant, Meta and YML product feeds × multiple templates → ZIP, Google Drive, S3 or webhooks. On a schedule, only the products that changed.',
  ],
  'landing.f4Title': ['Ваши шрифты', 'Your fonts'],
  'landing.f4Text': [
    '40 популярных шрифтов с кириллицей уже внутри. Загрузите фирменные TTF/OTF/WOFF и отключите лишние.',
    '40 popular fonts with Cyrillic built in. Upload brand TTF/OTF/WOFF fonts and hide the rest.',
  ],
  'landing.f5Title': ['Картинки и видео', 'Images and video'],
  'landing.f5Text': [
    'PNG с прозрачностью, JPG, WEBP, векторный PDF для печати, ретина до 3x — и видео MP4, WebM, GIF для Reels, TikTok и Shorts.',
    'Transparent PNG, JPG, WEBP, vector PDF for print, retina up to 3x — and MP4, WebM and GIF videos for Reels, TikTok and Shorts.',
  ],
  'landing.f6Title': ['Точно как в редакторе', 'Pixel-perfect'],
  'landing.f6Text': [
    'Редактор и сервер рендерят одним и тем же движком — что видите, то и получите.',
    'The editor and the server use the same rendering engine — what you see is what you get.',
  ],
  'landing.howTitle': ['Как это работает', 'How it works'],
  'landing.step1Title': ['Соберите шаблон', 'Design a template'],
  'landing.step1Text': [
    'Расставьте слои в редакторе и назовите динамические: title, photo, price.',
    'Arrange layers in the editor and name the dynamic ones: title, photo, price.',
  ],
  'landing.step2Title': ['Подключите данные', 'Connect data'],
  'landing.step2Text': [
    'Отправьте JSON в API, загрузите CSV или дайте ссылку на Google Таблицу.',
    'Send JSON to the API, upload a CSV or link a Google Sheet.',
  ],
  'landing.step3Title': ['Получите файлы', 'Get the files'],
  'landing.step3Text': [
    'Готовые креативы приходят ссылками, ZIP-архивом, в Drive, S3 или на ваш вебхук.',
    'Files arrive as links, a ZIP, in Drive, S3 or on your webhook.',
  ],
  'landing.apiTitle': ['API, которое удобно встроить', 'An API that is easy to integrate'],
  'landing.apiText': [
    'Один запрос — одна картинка. Или тысяча в пакете. Работает из любого языка, n8n, Make и Zapier.',
    'One request, one image. Or a thousand in a batch. Works from any language, n8n, Make and Zapier.',
  ],
  'landing.api1': [
    'Меняйте текст, фото, цвета, позиции и видимость слоёв по их именам',
    'Change text, photos, colors, positions and visibility by layer name',
  ],
  'landing.api2': [
    'Ждите результат в ответе или получайте вебхук',
    'Wait for the result in the response or get a webhook',
  ],
  'landing.api3': [
    'Подписанные ссылки — картинка по URL без серверного кода',
    'Signed URLs — an image from a URL with no server code',
  ],
  'landing.api4': [
    'Лимиты, ключи, логи доставки — всё прозрачно',
    'Limits, keys and delivery logs — fully transparent',
  ],
  'landing.apiCalloutTitle': ['Движок автоматической генерации', 'Automated rendering engine'],
  'landing.apiCalloutText': [
    'Передавайте параметры слоёв через API, вебхуки или таблицы — быстрый параллельный рендеринг.',
    'Pass layer overrides via API, webhooks or spreadsheets — fast parallel image generation.',
  ],
  'landing.pricingTitle': ['Простые тарифы', 'Simple pricing'],
  'landing.pricingSubtitle': [
    'Платите за количество генераций. Редактор и API — на всех тарифах.',
    'Pay for the number of renders. The editor and API are on every plan.',
  ],
  'landing.tryPlan': ['Выбрать {plan}', 'Choose {plan}'],
  'landing.watermark': ['С водяным знаком', 'With watermark'],
  'landing.faqTitle': ['Вопросы и ответы', 'FAQ'],
  'landing.q1': [
    'Чем это отличается от обычного графического редактора?',
    'How is this different from a regular design tool?',
  ],
  'landing.a1': [
    'Обычный редактор — для ручного дизайна. Bannermatic — для потока: один шаблон превращается в сотни вариантов автоматически, через API, таблицы и расписание.',
    'A regular design tool is for manual work. Bannermatic is for volume: one template becomes hundreds of variants automatically via the API, spreadsheets and schedules.',
  ],
  'landing.q2': [
    'Можно ли менять положение элементов, а не только текст?',
    'Can I move elements, not just change text?',
  ],
  'landing.a2': [
    'Да. В запросе для любого слоя можно передать x, y, width, height, rotation и opacity, сменить цвет (color) или скрыть слой (hide: true или null), например: {"logo": {"x": 40, "y": 860, "width": 180}}. Слои внутри стека расставляет автолейаут — для них меняются размер, направление и отступ стека (direction, gap), а не координаты.',
    'Yes. For any layer you can pass x, y, width, height, rotation and opacity, change its color or hide it (hide: true or null), e.g. {"logo": {"x": 40, "y": 860, "width": 180}}. Layers inside a stack are placed by auto layout — there you change their size and the stack’s direction and gap, not coordinates.',
  ],
  'landing.q3': ['Что будет с длинным текстом?', 'What about long text?'],
  'landing.a3': [
    'Включите автоподгонку: шрифт уменьшится, чтобы текст поместился, или ограничьте число строк с многоточием.',
    'Enable auto-fit: the font shrinks to fit, or limit the number of lines with an ellipsis.',
  ],
  'landing.metaTitle': [
    'Bannermatic — Автоматическая генерация баннеров по шаблонам через API и Google Таблицы',
    'Bannermatic — Automated Banner & Image Generation via API & Spreadsheets',
  ],
  'landing.metaDescription': [
    'Визуальный редактор шаблонов и REST API для массовой генерации баннеров, карточек товаров для маркетплейсов, креативов для соцсетей и PDF из Google Таблиц, фидов и CSV.',
    'Visual template editor and REST API for bulk banner and image generation, marketplace product cards, social media creatives, and PDF from Google Sheets, feeds, and CSV.',
  ],
  'landing.q4': [
    'Поддерживается кириллица и свои шрифты?',
    'Are Cyrillic and custom fonts supported?',
  ],
  'landing.a4': [
    'Да, большинство встроенных шрифтов с кириллицей, а на платных тарифах можно загрузить свои TTF/OTF/WOFF.',
    'Yes, most built-in fonts include Cyrillic, and paid plans can upload their own TTF/OTF/WOFF.',
  ],
  'landing.q5': [
    'Как генерировать баннеры из Google Таблиц без знания кода?',
    'How to generate banners from Google Sheets without coding?',
  ],
  'landing.a5': [
    'Подключите Google Таблицу или загрузите CSV в Студии автоматизации. Колонки таблицы сопоставляются со слоями шаблона (title, price, photo), и Bannermatic собирает сотни готовых баннеров в ZIP-архив, Google Drive или S3.',
    'Connect a Google Sheet or upload a CSV in the Automation Studio. Columns map to template layers (title, price, photo), and Bannermatic outputs hundreds of finished banners to a ZIP archive, Google Drive, or S3.',
  ],
  'landing.q6': [
    'Подходит ли сервис для карточек товаров на маркетплейсах?',
    'Is Bannermatic suitable for marketplace product cards?',
  ],
  'landing.a6': [
    'Да, это один из главных сценариев. Вы можете массово накладывать скидочные плашки, характеристики, цены и логотипы брендов на фотографии товаров из вашего фида или каталога.',
    'Yes, this is one of our primary use cases. You can bulk apply discount badges, specifications, prices, and brand logos to product photos from your feed or catalog.',
  ],
  'landing.finalTitle': ['Хватит собирать баннеры руками', 'Stop making banners by hand'],
  'landing.finalText': [
    'Сделайте шаблон за 10 минут и отдайте рутину API.',
    'Build a template in 10 minutes and hand the routine to the API.',
  ],
  'landing.tablesBadge': [
    'Без строчки кода · Студия таблиц',
    'No-code workflow · Spreadsheet Studio',
  ],
  'landing.tablesTitle': ['Баннеры из таблиц без кода', 'Banners from spreadsheets without code'],
  'landing.tablesSubtitle': [
    'Подключите Google Таблицу или загрузите CSV. Колонки автоматически связываются со слоями шаблона, создавая сотни готовых баннеров в один клик.',
    'Connect a Google Sheet or upload a CSV. Columns map to template layers automatically, delivering hundreds of ready-to-use creatives in one click.',
  ],
  'landing.tablesPoint1Title': ['Импорт из Google Sheets и CSV', 'Google Sheets & CSV Import'],
  'landing.tablesPoint1Text': [
    'Подключите живую онлайн-таблицу или перетащите файл с товарами. Bannermatic мгновенно прочитает структуру данных.',
    'Link a live spreadsheet or drop your product feed. Bannermatic instantly parses your rows and columns.',
  ],
  'landing.tablesPoint2Title': ['Наглядное сопоставление колонок', 'Visual Column Mapping'],
  'landing.tablesPoint2Text': [
    'Укажите, какая колонка отвечает за заголовок, цену, скидку или фото товара. Умный помощник свяжет слои автоматически.',
    'Easily map spreadsheet columns to titles, prices, badges, and photos. Intelligent layer matching does the heavy lifting.',
  ],
  'landing.tablesPoint3Title': [
    'Пакетный рендер и удобный экспорт',
    'Batch Generation & Instant Export',
  ],
  'landing.tablesPoint3Text': [
    'Сотни баннеров собираются параллельно за секунды. Скачивайте один ZIP-архив или сохраняйте прямо в облако.',
    'Hundreds of variants rendered in parallel within seconds. Download a single ZIP archive or export directly to cloud storage.',
  ],
  'landing.tablesMascotBubble': ['Добавил таблицу — и погнали!', 'Just add a sheet and go!'],
  'landing.tablesCta': ['Открыть Студию автоматизации', 'Try Automation Studio'],
  'landing.tablesMockSync': ['Синхронизировано · 450 строк', 'Synced · 450 rows'],
  'landing.tablesMockBtn': ['Сгенерировать 450 баннеров', 'Generate 450 banners'],
  'landing.tablesMockColProduct': ['Товар', 'Product'],
  'landing.tablesMockColPrice': ['Цена', 'Price'],
  'landing.tablesMockColDiscount': ['Скидка', 'Discount'],
  'landing.tablesMockColPhoto': ['Фото', 'Photo'],
  'landing.tablesMockColStatus': ['Статус', 'Status'],
  'landing.tablesMockDone': ['Готово', 'Ready'],
  'automation.autoMapped': ['Сопоставлено колонок: {n}', 'Matched {n} column(s)'],
  'automation.autoMapNone': [
    'Новых совпадений колонок со слоями не найдено',
    'No new column matches found',
  ],
  'automation.matchColumns': ['Сопоставить колонки', 'Match columns'],
  'automation.mediaHint': [
    'В ячейках для картинок можно указывать файлы из медиатеки:',
    'Image cells can point to media library files:',
  ],
  'media.allFiles': ['Все файлы', 'All files'],
  'media.noFolder': ['Без папки', 'No folder'],
  'media.folders': ['Папки', 'Folders'],
  'media.newFolder': ['Новая папка', 'New folder'],
  'media.renameFolder': ['Переименовать папку', 'Rename folder'],
  'media.renameFile': ['Переименовать файл', 'Rename file'],
  'media.rename': ['Переименовать', 'Rename'],
  'media.moveTo': ['Переместить в папку', 'Move to folder'],
  'media.moved': ['Файл перемещён', 'File moved'],
  'media.folderPlaceholder': ['Например, Команды', 'e.g. Teams'],
  'media.foldersHint': [
    'Разложите логотипы и фоны по папкам — «Команды», «Лиги»… Файлы можно перетаскивать на папку.',
    'Sort logos and backgrounds into folders — “Teams”, “Leagues”… Drag files onto a folder to move them.',
  ],
  'media.dropInto': [
    'Перетащите файлы сюда, и они попадут в папку «{folder}»',
    'Drop files here and they go to “{folder}”',
  ],
  'media.search': ['Поиск по имени файла или папки', 'Search by file or folder name'],
  'media.nothingFound': ['Ничего не найдено', 'Nothing found'],
  'media.copyRef': ['Копировать ссылку для автоматизации', 'Copy reference for automations'],
  'media.refCopied': [
    'Скопировано — вставьте в ячейку таблицы или в API',
    'Copied — paste it into a table cell or the API',
  ],
  'media.refHint': [
    'В таблицах автоматизации и API картинку можно указать так:',
    'In automation tables and the API, point to a file like this:',
  ],
  'media.exampleFolder': ['Команды', 'Teams'],
  'media.exampleName': ['Арсенал', 'Arsenal'],
  'media.deleteFolderTitle': ['Удалить папку «{name}»?', 'Delete folder “{name}”?'],
  'media.deleteFolderText': [
    'Файлы из неё не удалятся — они переедут в «Без папки». Ссылки media:Папка/… перестанут находить эти файлы.',
    'Its files are kept and move to “No folder”. media:Folder/… references will stop finding them.',
  ],
  'media.allFolders': ['Все папки', 'All folders'],
  'media.pick': ['Выбрать из медиатеки', 'Pick from the media library'],
  'err.folderExists': ['Папка «{name}» уже есть', 'A folder named “{name}” already exists'],
  'err.nameRequired': ['Введите название', 'Enter a name'],
  'err.mediaNotFound': [
    'Слой «{layer}»: «{ref}» нет в медиатеке',
    'Layer “{layer}”: “{ref}” is not in the media library',
  ],
  'qr.style': ['Стиль QR-кода', 'QR style'],
  'qr.paid': [
    'Скруглённые точки, стиль углов, свой цвет и логотип в центре — на тарифах Pro и Business.',
    'Rounded dots, corner styles, a colour of their own and a logo in the centre are on Pro and Business.',
  ],
  'qr.upgrade': ['Сменить тариф', 'Upgrade'],
  'qr.dots': ['Точки', 'Dots'],
  'qr.eyes': ['Углы', 'Corners'],
  'qr.eyeColor': ['Цвет углов', 'Corner colour'],
  'qr.logo': ['Логотип в центре', 'Logo in the centre'],
  'qr.logoHint': ['Доступно на Pro и Business', 'Available on Pro and Business'],
  'qr.logoSize': ['Размер лого', 'Logo size'],
  'qr.logoNote': [
    'С логотипом код использует максимальную коррекцию ошибок (H) — проверьте сканирование на превью.',
    'With a logo the code uses the highest error correction (H) — check it scans on the preview.',
  ],
  'qr.dot.square': ['Квадраты', 'Square'],
  'qr.dot.rounded': ['Скруглённые', 'Rounded'],
  'qr.dot.dots': ['Круги', 'Dots'],
  'qr.eye.square': ['Квадрат', 'Square'],
  'qr.eye.rounded': ['Скруглённый', 'Rounded'],
  'qr.eye.circle': ['Круг', 'Circle'],
  'billing.fQrStyles': ['Стильные QR-коды с логотипом', 'Styled QR codes with a logo'],
  'retention.label': ['Хранится', 'Kept'],
  'retention.until': ['до {date}', 'until {date}'],
  'retention.keptUntil': ['Файлы хранятся до {date}', 'Files are kept until {date}'],
  'retention.batchExpired': [
    'Срок хранения файлов истёк — они удалены',
    'The retention period is over — files were deleted',
  ],
  'retention.renderExpired': [
    'Файл удалён по истечении срока хранения',
    'The file was deleted after the retention period',
  ],
  'google.spreadsheet': ['Таблица', 'Spreadsheet'],
  'google.chooseSpreadsheet': ['Выберите таблицу', 'Choose a spreadsheet'],
  'google.noSpreadsheets': [
    'Пока нет таблиц — выберите в Google Drive или вставьте ссылку',
    'No spreadsheets yet — choose one in Google Drive or paste a link',
  ],
  'google.listHint': [
    'Google показывает приложениям только таблицы, выбранные через «Google Drive» или уже использованные в автоматизациях.',
    'Google shows apps only the spreadsheets chosen via “Google Drive” or already used in automations.',
  ],
  'google.refresh': ['Обновить список', 'Refresh the list'],
  'google.fromDrive': ['Google Drive', 'Google Drive'],
  'google.orLink': ['…или ссылка на таблицу', '…or a spreadsheet link'],
  'google.linkedSheet': ['Таблица по ссылке', 'Linked spreadsheet'],
  'google.noAccess': [
    'Не удалось открыть таблицу этим аккаунтом Google — проверьте ссылку и доступ.',
    'This Google account can’t open the spreadsheet — check the link and sharing.',
  ],
  'google.noAccessPick': [
    'Bannermatic видит только таблицы, выбранные в Google Drive. Откройте эту таблицу там один раз — доступ будет только к ней.',
    'Bannermatic sees only the spreadsheets chosen in Google Drive. Open this one there once — access is to this file only.',
  ],
  'google.grantAccess': ['Дать доступ к этой таблице', 'Give access to this spreadsheet'],
  'common.loading': ['Загрузка…', 'Loading…'],
  'common.retry': ['Повторить', 'Retry'],
  'err.pickerOwnerOnly': [
    'Просматривать Google Drive может только тот, кто подключил аккаунт, или администратор',
    'Only the person who connected this Google account (or an admin) can browse its Drive',
  ],
  'err.pickerDisabled': [
    'Выбор из Google Drive не настроен на сервере',
    'Choosing from Google Drive is not configured on this server',
  ],
  'common.close': ['Закрыть', 'Close'],
  'common.menu': ['Меню', 'Menu'],
  'history.title': ['История версий', 'Version history'],
  'history.paid': [
    'История изменений шаблона с откатом к любой сохранённой версии — на тарифе Business.',
    'Template history with rollback to any saved version is on the Business plan.',
  ],
  'history.restore': ['Восстановить эту версию', 'Restore this version'],
  'history.restored': ['Восстановлена версия от {time}', 'Restored the version from {time}'],
  'history.empty': [
    'Версии появятся после первых правок шаблона.',
    'Versions appear after the first edits.',
  ],
  'history.current': ['Текущая', 'Current'],
  'history.restoreOf': ['Откат к версии {version}', 'Rolled back to version {version}'],
  'history.initial': ['Исходная версия', 'Original version'],
  'history.edited': ['Правки', 'Edits'],
  'history.hint': [
    'Правки одного человека за ~10 минут — одна версия. Хранится 180 дней, до 200 версий на шаблон.',
    'One person’s edits within ~10 minutes make one version. Kept for 180 days, up to 200 per template.',
  ],
  'comments.title': ['Комментарии', 'Comments'],
  'comments.paid': [
    'Комментарии к шаблонам для согласования с командой — на тарифе Business.',
    'Comments on templates for team review are on the Business plan.',
  ],
  'comments.empty': [
    'Пока нет комментариев. Выделите слой, чтобы привязать замечание к нему.',
    'No comments yet. Select a layer to pin a note to it.',
  ],
  'comments.resolve': ['Отметить решённым', 'Resolve'],
  'comments.reopen': ['Вернуть в работу', 'Reopen'],
  'comments.showResolved': ['Показать решённые ({n})', 'Show resolved ({n})'],
  'comments.hideResolved': ['Скрыть решённые', 'Hide resolved'],
  'comments.placeholder': [
    'Замечание или вопрос… (Ctrl+Enter — отправить)',
    'A note or question… (Ctrl+Enter to send)',
  ],
  'comments.pin': ['К слою «{layer}»', 'Pin to layer “{layer}”'],
  'comments.send': ['Отправить', 'Send'],
  'review.title': ['Согласование', 'Approval'],
  'review.status.draft': ['Черновик', 'Draft'],
  'review.status.in_review': ['На согласовании', 'In review'],
  'review.status.changes_requested': ['На доработке', 'Changes requested'],
  'review.status.approved': ['Утверждён', 'Approved'],
  'review.hint.approved': [
    'Утверждён {time}. Правки дизайна вернут шаблон в черновик.',
    'Approved {time}. Design edits make it a draft again.',
  ],
  'review.hint.inReview': [
    'Ждёт решения владельца или администратора.',
    'Waiting for an owner or admin to decide.',
  ],
  'review.hint.changes': [
    'Нужны правки — замечания в комментариях ниже. После правок отправьте снова.',
    'Changes requested — see the comments below, then send it again.',
  ],
  'review.hint.edited': ['Изменён после утверждения.', 'Changed since it was approved.'],
  'review.hint.editedRequired': [
    'Изменён после утверждения. API, автоматизации и ссылки рисуют утверждённую версию, пока не утвердят новую.',
    'Changed since it was approved. The API, automations and links keep drawing the approved version until the new one is approved.',
  ],
  'review.hint.draft': [
    'Когда макет готов, отправьте его на согласование.',
    'Send it for approval when the design is ready.',
  ],
  'review.hint.draftRequired': [
    'Ещё не утверждён: API, автоматизации и ссылки его не рендерят (превью работают).',
    'Not approved yet: the API, automations and links will not render it (previews work).',
  ],
  'review.notePlaceholder': [
    'Что поправить? Замечание попадёт в комментарии',
    'What should change? The note goes to the comments',
  ],
  'review.sendBack': ['Вернуть на доработку', 'Send back'],
  'review.approve': ['Утвердить', 'Approve'],
  'review.requestChanges': ['Нужны правки', 'Request changes'],
  'review.request': ['Отправить на согласование', 'Send for approval'],
  'review.done.request': ['Шаблон отправлен на согласование', 'Sent for approval'],
  'review.done.approve': ['Шаблон утверждён', 'Template approved'],
  'review.done.changes': ['Шаблон возвращён на доработку', 'Sent back for changes'],
  'approval.title': ['Требовать согласование шаблонов', 'Require template approval'],
  'approval.text': [
    'API, автоматизации и подписанные ссылки рендерят только утверждённую версию шаблона. Правки в редакторе не попадут в рассылки и фиды, пока их не утвердят. Превью и генерация в редакторе работают как раньше.',
    'The API, automations and signed links render only the approved version of each template. Edits do not reach campaigns and feeds until they are approved. Previews and generating in the editor work as before.',
  ],
  'approval.on': ['Согласование включено', 'Approval required'],
  'approval.off': ['Согласование выключено', 'Approval no longer required'],
  'audit.template.review_requested': ['На согласование отправлен шаблон', 'Sent for approval:'],
  'audit.template.approved': ['Утверждён шаблон', 'Template approved:'],
  'audit.template.changes_requested': ['На доработку возвращён шаблон', 'Sent back for changes:'],
  'err.templateNotApproved': [
    'Шаблон «{name}» ещё не утверждён. Утвердите его в редакторе или выключите обязательное согласование.',
    'Template “{name}” is not approved yet. Approve it in the editor or turn off required approval.',
  ],
  'err.reviewAlreadyApproved': ['Эта версия уже утверждена', 'This version is already approved'],
  'activity.tab': ['Журнал', 'Activity'],
  'activity.paid': [
    'Журнал действий — кто что изменил и запустил — на тарифе Business. События уже записываются: после перехода вы увидите и прошлые.',
    'The activity log — who changed and ran what — is on the Business plan. Events are already recorded: after upgrading you will see past ones too.',
  ],
  'activity.description': [
    'Кто что изменил и запустил. Хранится 365 дней.',
    'Who changed and ran what. Kept for 365 days.',
  ],
  'activity.allTypes': ['Все события', 'All events'],
  'activity.empty': ['Событий пока нет', 'No events yet'],
  'activity.more': ['Показать ещё', 'Show more'],
  'activity.times': ['×{n}', '×{n}'],
  'activity.apiKey': ['API-ключ', 'API key'],
  'activity.system': ['Система', 'System'],
  'activity.version': ['версия {n}', 'version {n}'],
  'activity.renders': ['файлов: {n}', '{n} files'],
  'activity.trigger.manual': ['вручную', 'manually'],
  'activity.trigger.schedule': ['по расписанию', 'on schedule'],
  'activity.trigger.api': ['через API', 'via API'],
  'activity.type.template': ['Шаблоны', 'Templates'],
  'activity.type.automation': ['Автоматизации', 'Automations'],
  'activity.type.member': ['Команда', 'Team'],
  'activity.type.api_key': ['API-ключи', 'API keys'],
  'activity.type.integration': ['Интеграции', 'Integrations'],
  'activity.type.asset': ['Медиатека', 'Media'],
  'activity.type.font': ['Шрифты', 'Fonts'],
  'audit.template.created': ['Создан шаблон', 'Template created:'],
  'audit.template.imported': ['Импортирован шаблон', 'Template imported:'],
  'audit.template.updated': ['Изменён шаблон', 'Template edited:'],
  'audit.template.deleted': ['Удалён шаблон', 'Template deleted:'],
  'audit.template.duplicated': ['Создана копия шаблона', 'Template copied:'],
  'audit.template.restored': ['Откат версии шаблона', 'Template rolled back:'],
  'audit.comment.added': ['Комментарий к шаблону', 'Comment on'],
  'audit.automation.created': ['Создана автоматизация', 'Automation created:'],
  'audit.automation.updated': ['Изменена автоматизация', 'Automation edited:'],
  'audit.automation.deleted': ['Удалена автоматизация', 'Automation deleted:'],
  'audit.automation.run': ['Запуск автоматизации', 'Automation run:'],
  'audit.batch.created': ['Пакетная генерация через API', 'Batch rendered via API'],
  'audit.member.invited': ['Приглашение отправлено', 'Invitation sent to'],
  'audit.member.joined': ['В команду вступил(а)', 'Joined the team:'],
  'audit.member.removed': ['Удалён из команды', 'Removed from the team:'],
  'audit.member.left': ['Покинул(а) команду', 'Left the team:'],
  'audit.member.role_changed': ['Изменена роль', 'Role changed for'],
  'audit.invitation.revoked': ['Отозвано приглашение', 'Invitation revoked'],
  'audit.api_key.created': ['Создан API-ключ', 'API key created:'],
  'audit.api_key.revoked': ['Отозван API-ключ', 'API key revoked'],
  'audit.integration.connected': ['Подключена интеграция', 'Integration connected:'],
  'audit.integration.updated': ['Переподключена интеграция', 'Integration reconnected:'],
  'audit.integration.deleted': ['Отключена интеграция', 'Integration removed:'],
  'audit.asset.uploaded': ['Загружены файлы в медиатеку, последний:', 'Media uploaded, latest:'],
  'audit.asset.deleted': ['Удалён файл', 'File deleted:'],
  'audit.folder.created': ['Создана папка', 'Folder created:'],
  'audit.folder.deleted': ['Удалена папка', 'Folder deleted:'],
  'audit.font.uploaded': ['Загружен шрифт', 'Font uploaded:'],
  'audit.font.deleted': ['Удалён шрифт', 'Font deleted'],
  'audit.motion_preset.created': ['Создан пресет анимации', 'Motion preset created:'],
  'audit.motion_preset.updated': ['Изменён пресет анимации', 'Motion preset edited:'],
  'audit.motion_preset.deleted': ['Удалён пресет анимации', 'Motion preset deleted:'],
  'audit.workspace.updated': ['Изменены настройки пространства', 'Workspace settings changed:'],
  'audit.signing_secret.rotated': ['Обновлён секрет подписи', 'Signing secret rotated'],
  'audit.plan.changed': ['Сменён тариф', 'Plan changed'],
  'err.businessFeature': ['Доступно на тарифе Business', 'Available on the Business plan'],
  'err.commentEmpty': ['Напишите комментарий', 'Write a comment'],
  'billing.fHistory': [
    'История версий, комментарии, согласование шаблонов, журнал действий',
    'Version history, comments, template approval, activity log',
  ],
  'brand.title': ['Бренд-кит', 'Brand kit'],
  'brand.description': [
    'Цвета, шрифты и логотипы бренда задаются один раз — шаблоны ссылаются на них.',
    'Brand colours, fonts and logos are set once — templates refer to them.',
  ],
  'brand.create': ['Создать бренд', 'Create a brand'],
  'brand.newName': ['Бренд {n}', 'Brand {n}'],
  'brand.paid': [
    'Бренд-кит — на тарифах Pro (один бренд) и Business (несколько брендов, переключение бренда клиента в автоматизациях и API).',
    'Brand kits are on Pro (one brand) and Business (several brands, switching the client’s brand in automations and the API).',
  ],
  'brand.emptyTitle': ['Брендов пока нет', 'No brands yet'],
  'brand.emptyText': [
    'Создайте бренд и задайте его цвета, шрифты и логотипы.',
    'Create a brand and set its colours, fonts and logos.',
  ],
  'brand.moreOnBusiness': [
    'Несколько брендов (для агентств и клиентов) — на тарифе Business.',
    'Several brands (for agencies and clients) are on the Business plan.',
  ],
  'brand.default': ['Основной', 'Default'],
  'brand.makeDefault': ['Сделать основным', 'Make default'],
  'brand.saved': ['Бренд сохранён — шаблоны обновятся', 'Brand saved — templates update'],
  'brand.colorsTitle': ['Цвета', 'Colours'],
  'brand.fontsTitle': ['Шрифты', 'Fonts'],
  'brand.logosTitle': ['Логотипы', 'Logos'],
  'brand.deleteTitle': ['Удалить бренд «{name}»?', 'Delete brand “{name}”?'],
  'brand.deleteText': [
    'Шаблоны, которые на него ссылаются, возьмут основной бренд или запасные значения.',
    'Templates referring to it use the default brand or their fallback values.',
  ],
  'brand.howTitle': ['Как это работает', 'How it works'],
  'brand.howText': [
    'В редакторе выберите цвет, шрифт или логотип из раздела бренда — слой запомнит ссылку на слот («Основной», «Заголовки», «Логотип»), а не значение. Измените бренд — обновятся все шаблоны. У всех брендов одинаковые слоты, поэтому один набор шаблонов работает для любого клиента: выберите бренд в автоматизации или передайте brand_id в API.',
    'In the editor pick a colour, font or logo from the brand section — the layer keeps a reference to the slot (“Primary”, “Headings”, “Logo”), not the value. Change the brand and every template updates. All brands share the same slots, so one set of templates works for any client: pick the brand in an automation or pass brand_id to the API.',
  ],
  'brand.colors': ['Цвета бренда «{name}»', 'Brand colours · {name}'],
  'brand.fonts': ['Шрифты бренда «{name}»', 'Brand fonts · {name}'],
  'brand.logos': ['Логотипы бренда «{name}»', 'Brand logos · {name}'],
  'brand.detach': [
    'Отвязать от бренда (оставить текущий цвет)',
    'Detach from the brand (keep the current colour)',
  ],
  'brand.useDefault': ['Основной бренд ({name})', 'Default brand ({name})'],
  'brand.templateHint': [
    'Бренд, с которым шаблон показывается и рендерится, если автоматизация или API не выбрали другой.',
    'The brand this template is shown and rendered with unless an automation or the API picks another.',
  ],
  'brand.editorHint': [
    'Цвета, шрифты и логотипы бренда можно задать один раз и использовать во всех шаблонах.',
    'Set brand colours, fonts and logos once and use them in every template.',
  ],
  'brand.automationLabel': ['Бренд', 'Brand'],
  'brand.automationHint': [
    'Цвета, шрифты и логотипы бренда для всех баннеров этого запуска.',
    'Brand colours, fonts and logos for every banner of the run.',
  ],
  'brand.templateBrand': ['Бренд каждого шаблона', 'Each template’s brand'],
  'brand.slot.primary': ['Основной', 'Primary'],
  'brand.slot.secondary': ['Дополнительный', 'Secondary'],
  'brand.slot.accent': ['Акцент', 'Accent'],
  'brand.slot.background': ['Фон', 'Background'],
  'brand.slot.text': ['Текст', 'Text'],
  'brand.slot.font-heading': ['Заголовки', 'Headings'],
  'brand.slot.font-body': ['Основной текст', 'Body text'],
  'brand.slot.logo': ['Логотип', 'Logo'],
  'brand.slot.logo-light': ['Светлый логотип', 'Light logo'],
  'brand.slot.logo-icon': ['Иконка', 'Icon'],
  'err.brandsPlan': [
    'Бренд-кит доступен на тарифах Pro и Business',
    'Brand kits are available on Pro and Business',
  ],
  'err.brandsLimit': [
    'На вашем тарифе брендов: не больше {limit}',
    'Your plan allows {limit} brand(s)',
  ],
  'err.brandInvalid': ['Проверьте значения бренда', 'Check the brand values'],
  'billing.fBrands': ['Бренд-кит', 'Brand kit'],
  'landing.brandDemoTitle': ['Новая коллекция', 'New collection'],
  'landing.brandDemoSub': ['Только до воскресенья', 'This weekend only'],
  'landing.brandsTitle': [
    'Один набор шаблонов — бренды всех клиентов',
    'One template set — every client’s brand',
  ],
  'landing.brandsSubtitle': [
    'Задайте цвета, шрифты и логотипы бренда один раз. Шаблоны ссылаются на бренд-кит: сменили фирменный цвет — обновились все баннеры. Переключайте бренд клиента в автоматизации или одним параметром API.',
    'Set brand colours, fonts and logos once. Templates refer to the brand kit: change the brand colour and every banner follows. Switch the client’s brand in an automation or with one API parameter.',
  ],
  'landing.brandsP1Title': ['Бренд-кит', 'Brand kit'],
  'landing.brandsP1Text': [
    'Цвета, шрифты, логотипы. На Pro — один бренд, на Business — сколько угодно и переключение на лету.',
    'Colours, fonts, logos. One brand on Pro, as many as you need on Business — switched on the fly.',
  ],
  'landing.brandsP2Title': ['История версий с откатом', 'Version history with rollback'],
  'landing.brandsP2Text': [
    'Каждая сессия правок сохраняется. Сломали шаблон перед запуском — вернули прошлую версию в один клик.',
    'Every editing session is saved. Broke a template before a launch? Restore the previous version in one click.',
  ],
  'landing.brandsP3Title': ['Комментарии и согласование', 'Comments and approvals'],
  'landing.brandsP3Text': [
    'Замечания прямо к слою шаблона, статусы «на согласовании» и «утверждён». API и рассылки рисуют только утверждённую версию — правки не уйдут в продакшен без одобрения.',
    'Notes right on a template layer, “in review” and “approved” statuses. The API and campaigns draw only the approved version — edits never reach production unapproved.',
  ],
  'landing.brandsP4Title': ['Журнал действий', 'Activity log'],
  'landing.brandsP4Text': [
    'Кто изменил шаблон, кто запустил рассылку и через какой API-ключ — видно всё.',
    'Who changed a template, who ran an automation and with which API key — it’s all there.',
  ],
  'landing.brandsDemoLabel': ['Один шаблон · три бренда', 'One template · three brands'],
  'landing.brandsDemoHint': [
    'Это живой рендер: тот же шаблон, разные бренд-киты — цвета, шрифты, акценты.',
    'This is a live render: the same template with different brand kits — colours, fonts, accents.',
  ],
  'landing.f7Title': ['Медиатека с папками', 'Media library with folders'],
  'landing.f7Text': [
    'Логотипы команд, фото товаров, фоны — по папкам и с поиском. В таблице просто пишите media:Команды/Арсенал — подставится нужный файл.',
    'Team logos, product photos, backgrounds — in folders, searchable. In a sheet just write media:Teams/Arsenal and the right file is used.',
  ],
  'landing.f8Title': ['QR-коды в фирменном стиле', 'On-brand QR codes'],
  'landing.f8Text': [
    'Скруглённые точки или круги, стиль и цвет углов, логотип в центре — и код всё равно считывается.',
    'Rounded dots or circles, styled coloured corners, a logo in the centre — and it still scans.',
  ],
  'landing.f9Title': ['Таблица подхватывается сама', 'Sheets map themselves'],
  'landing.f9Text': [
    'Загрузили CSV или выбрали Google Таблицу из списка — колонки сами сопоставятся со слоями: «Заголовок», «Home Logo», «Цена».',
    'Upload a CSV or pick a Google Sheet from the list — columns match the layers on their own: “Title”, “Home Logo”, “Price”.',
  ],
  'landing.q7': [
    'Можно ли вести несколько клиентов с разными брендами?',
    'Can I run several clients with different brands?',
  ],
  'landing.a7': [
    'Да. На тарифе Business создайте бренд-кит для каждого клиента — цвета, шрифты, логотипы. Шаблоны ссылаются на бренд, поэтому один и тот же набор работает для всех: выберите бренд в автоматизации или передайте brand_id в API.',
    'Yes. On Business create a brand kit per client — colours, fonts, logos. Templates refer to the brand, so one set works for everyone: pick the brand in an automation or pass brand_id to the API.',
  ],
  'landing.q8': ['Что если кто-то сломает шаблон?', 'What if someone breaks a template?'],
  'landing.a8': [
    'На тарифе Business каждая сессия правок попадает в историю версий: откройте её, посмотрите превью и восстановите нужную версию в один клик. Журнал действий покажет, кто и когда менял шаблон.',
    'On Business every editing session lands in the version history: open it, look at the preview and restore any version in one click. The activity log shows who changed the template and when.',
  ],
  'editor.tabBrand': ['Бренд', 'Brand'],
  'brandPanel.empty': [
    'Бренд-кит ещё не создан. Добавьте цвета, шрифты и логотипы — и применяйте их в один клик.',
    'No brand kit yet. Add colors, fonts and logos and apply them in one click.',
  ],
  'brandPanel.toSelection': ['к выделенным слоям ({n})', 'to the selected layers ({n})'],
  'brandPanel.toBackground': ['к фону холста', 'to the canvas background'],
  'brandPanel.linked': ['Привязано к бренду: {n}', 'Linked to the brand: {n}'],
  'brandPanel.nothingToLink': [
    'В шаблоне нет цветов и шрифтов, совпадающих с брендом',
    'No colors or fonts in this template match the brand',
  ],
  'brandPanel.edit': ['Редактировать бренд-кит', 'Edit brand kit'],
  'brandPanel.clickHint': [
    'Клик по цвету применяет его {target}. Значение связано с брендом и обновится вместе с ним.',
    'Click a color to apply it {target}. The value stays linked and updates with the brand.',
  ],
  'brandPanel.fontHint': [
    'Клик — применить к выделенному тексту или добавить новый текст этим шрифтом',
    'Click to apply to the selected text or add new text in this font',
  ],
  'brandPanel.logoHint': [
    'Клик — заменить выделенное изображение или добавить логотип',
    'Click to replace the selected image or add the logo',
  ],
  'brandPanel.linkAll': ['Привязать шаблон к бренду', 'Link template to the brand'],
  'brandPanel.linkAllHint': [
    'Найдёт в шаблоне цвета, шрифты и логотипы бренда и свяжет их — тогда другой бренд перекрасит баннер целиком.',
    "Finds the brand's colors, fonts and logos in the template and links them, so another brand restyles the whole banner.",
  ],
  'brandImport.open': ['Импорт', 'Import'],
  'brandImport.title': ['Импорт бренд-кита', 'Import a brand kit'],
  'brandImport.description': [
    'Соберём цвета, шрифты и логотипы с сайта или из файла Figma.',
    "We'll collect colors, fonts and logos from a website or a Figma file.",
  ],
  'brandImport.reviewHint': [
    'Проверьте, что мы нашли, и поправьте при необходимости.',
    'Review what we found and adjust if needed.',
  ],
  'brandImport.back': ['Назад', 'Back'],
  'brandImport.replace': ['Обновить бренд', 'Update brand'],
  'brandImport.create': ['Создать бренд', 'Create brand'],
  'brandImport.website': ['Сайт', 'Website'],
  'brandImport.siteLabel': ['Адрес сайта', 'Website address'],
  'brandImport.siteHint': [
    'Возьмём цвета из CSS, шрифты и логотип с главной страницы.',
    'We take colors from CSS, fonts and the logo from the home page.',
  ],
  'brandImport.find': ['Найти', 'Find'],
  'brandImport.figmaConnect': [
    'Подключите Figma, чтобы читать стили и переменные файла.',
    "Connect Figma to read the file's styles and variables.",
  ],
  'brandImport.figmaStep1': [
    'В Figma: Settings → Security → Personal access tokens → Generate new token (доступ на чтение файлов).',
    'In Figma: Settings → Security → Personal access tokens → Generate new token (file read access).',
  ],
  'brandImport.figmaStep2': [
    'Вставьте токен ниже — он хранится в зашифрованном виде.',
    'Paste the token below. It is stored encrypted.',
  ],
  'brandImport.connect': ['Подключить', 'Connect'],
  'brandImport.figmaLabel': ['Ссылка на файл Figma', 'Figma file link'],
  'brandImport.figmaHint': [
    'Лучше всего файл с дизайн-системой: стили цветов и текста, логотипы как компоненты.',
    'A design-system file works best: color and text styles, logos as components.',
  ],
  'brandImport.reading': ['Читаем источник…', 'Reading the source…'],
  'brandImport.name': ['Название бренда', 'Brand name'],
  'brandImport.saveTo': ['Сохранить как', 'Save as'],
  'brandImport.newBrand': ['Новый бренд', 'New brand'],
  'brandImport.replaceBrand': ['Заменить «{name}»', 'Replace “{name}”'],
  'brandImport.pickFor': ['Выберите цвет', 'Pick a color'],
  'brandImport.paletteHint': [
    'Найденная палитра — клик назначит цвет выбранному слоту',
    'Found palette: click to assign a color to the selected slot',
  ],
  'brandImport.fontMissing': [
    'Шрифта «{family}» нет в библиотеке — выберите похожий или загрузите файл шрифта.',
    "“{family}” isn't in the library: pick a similar font or upload the font file.",
  ],
  'brandImport.noLogos': [
    'Логотипы не найдены — их можно добавить позже.',
    'No logos found. You can add them later.',
  ],
  'brandImport.skipLogo': ['Не импортировать', "Don't import"],
  'brandImport.saved': ['Бренд-кит импортирован', 'Brand kit imported'],
  'integrations.figmaHint': [
    'Импорт бренд-кита из стилей и переменных файлов Figma.',
    'Import brand kits from Figma file styles and variables.',
  ],
  'err.siteHttp': ['Сайт ответил ошибкой HTTP {status}.', 'The site answered with HTTP {status}.'],
  'err.figmaLink': [
    'Это не похоже на ссылку на файл Figma.',
    "This doesn't look like a Figma file link.",
  ],
  'err.figmaToken': ['Вставьте токен Figma.', 'Paste a Figma token.'],
  'err.figmaNotFound': [
    'Файл Figma не найден — проверьте ссылку.',
    'Figma file not found. Check the link.',
  ],
  'err.figmaForbidden': [
    'Нет доступа: токен недействителен или у аккаунта нет доступа к файлу.',
    "No access: the token is invalid or the account can't open this file.",
  ],
  'err.figmaError': [
    'Figma вернула ошибку. Попробуйте ещё раз позже.',
    'Figma returned an error. Try again later.',
  ],
  'brandDs.onPage': ['На странице', 'On this page'],
  'brandDs.overview': ['Обзор', 'Overview'],
  'brandDs.typography': ['Типографика', 'Typography'],
  'brandDs.usage': ['В деле', 'In use'],
  'brandDs.tagline': [
    'Цвета, шрифты и логотипы бренда — в каждом баннере',
    'Brand colours, fonts and logos in every banner',
  ],
  'brandDs.colorsHint': [
    'Клик по образцу — выбрать цвет, или введите HEX. Шаблоны ссылаются на слот (токен), а не на значение, поэтому смена цвета перекрасит все баннеры.',
    'Click a swatch to pick a colour or type a HEX. Templates reference the slot (token), not the value, so changing a colour restyles every banner.',
  ],
  'brandDs.notSet': ['Не задан', 'Not set'],
  'brandDs.contrast': ['Контраст пар', 'Contrast pairs'],
  'brandDs.contrastHint': [
    'Читаемость текста по WCAG: AA — от 4.5, AAA — от 7, от 3 — только для крупного текста.',
    'Text legibility per WCAG: AA from 4.5, AAA from 7, 3+ for large text only.',
  ],
  'brandDs.pairSample': ['Распродажа −30%', 'Sale −30%'],
  'brandDs.largeOnly': ['крупный', 'large'],
  'brandDs.fail': ['плохо', 'fail'],
  'brandDs.typeHint': [
    'Шрифт заголовков и основного текста. Слои со шрифтом бренда сменят его вместе с бренд-китом.',
    'Heading and body fonts. Layers using a brand font switch with the brand kit.',
  ],
  'brandDs.sampleHeadline': ['Яркий баннер за пару секунд', 'A bold banner in seconds'],
  'brandDs.sampleBody': [
    'Шаблоны берут цвета, шрифты и логотипы из бренд-кита, поэтому каждая генерация выглядит фирменно.',
    'Templates take colours, fonts and logos from the brand kit, so every render looks on-brand.',
  ],
  'brandDs.logosHint': [
    'Основной логотип — для светлого фона, светлый — для тёмного (показан на основном цвете), иконка — для маленьких форматов.',
    'Main logo for light backgrounds, light logo for dark ones (shown on the primary colour), icon for small formats.',
  ],
  'brandDs.usageHint': [
    'Так шаблоны, привязанные к бренду, выглядят с этим бренд-китом. Предпросмотр сразу учитывает несохранённые правки.',
    'How brand-linked templates look with this kit. The preview reflects unsaved edits right away.',
  ],
  'brandDs.sampleCta': ['Купить', 'Shop now'],
  'brandDs.unsaved': ['Есть несохранённые изменения', 'You have unsaved changes'],
  'brandDs.discard': ['Отменить', 'Discard'],
  'keys.title': ['Горячие клавиши', 'Keyboard shortcuts'],
  'keys.description': [
    'Работают, когда фокус на холсте. Буквенные клавиши работают в любой раскладке.',
    'Active while the canvas has focus. Letter keys work with any keyboard layout.',
  ],
  'keys.general': ['Основное', 'General'],
  'keys.layers': ['Слои', 'Layers'],
  'keys.animation': ['Анимация', 'Animation'],
  'keys.playPause': ['Воспроизвести / пауза', 'Play / pause'],
  'keys.frameStep': ['На кадр назад / вперёд', 'Frame back / forward'],
  'keys.secondStep': ['На секунду назад / вперёд', 'Second back / forward'],
  'keys.toStartEnd': ['В начало / в конец', 'To start / end'],
  'keys.view': ['Вид', 'View'],
  'keys.tools': ['Инструменты', 'Tools'],
  'keys.save': ['Сохранить', 'Save'],
  'keys.cut': ['Вырезать', 'Cut'],
  'keys.selectAll': ['Выделить всё', 'Select all'],
  'keys.delete': ['Удалить', 'Delete'],
  'keys.deselect': ['Снять выделение / выйти из стека', 'Deselect / exit stack'],
  'keys.editText': ['Редактировать текст', 'Edit text'],
  'keys.dblclick': ['двойной клик', 'double-click'],
  'keys.cheatsheet': ['Эта шпаргалка', 'This cheat sheet'],
  'editor.panelLeft': ['панель слоёв', 'layers panel'],
  'editor.panelRight': ['панель свойств', 'properties panel'],
  'editor.panelBottom': ['таймлайн и раскадровку', 'timeline and storyboard'],
  'editor.panelShow': ['Показать {panel}', 'Show the {panel}'],
  'editor.panelHide': ['Свернуть {panel}', 'Hide the {panel}'],
  'editor.focus': [
    'Фокус на превью: свернуть все панели',
    'Focus on the preview: hide every panel',
  ],
  'editor.focusExit': ['Вернуть панели', 'Bring the panels back'],
  'editor.panels': ['Панели', 'Panels'],
  'editor.timelineResize': ['Потяните, чтобы изменить высоту', 'Drag to change the height'],
  'keys.nudge': ['Сдвинуть на 1 px', 'Nudge 1 px'],
  'keys.nudge10': ['Сдвинуть на 10 px', 'Nudge 10 px'],
  'keys.forward': ['Выше на один слой', 'Bring forward'],
  'keys.backward': ['Ниже на один слой', 'Send backward'],
  'keys.front': ['На передний план', 'Bring to front'],
  'keys.back': ['На задний план', 'Send to back'],
  'keys.hideShow': ['Скрыть / показать', 'Hide / show'],
  'keys.lockUnlock': ['Закрепить / открепить', 'Lock / unlock'],
  'keys.keepRatio': ['Сохранять пропорции', 'Keep proportions'],
  'keys.rotateStep': ['Поворот с шагом 15°', 'Rotate in 15° steps'],
  'keys.distances': ['Расстояния до соседей', 'Distances to neighbours'],
  'keys.drag': ['тянуть', 'drag'],
  'keys.rotate': ['вращать', 'rotate'],
  'keys.wheel': ['колесо', 'wheel'],
  'keys.zoomWheel': ['Масштаб к курсору', 'Zoom at pointer'],
  'keys.pan': ['Двигать холст', 'Pan the canvas'],
  'keys.select': ['Выделение', 'Select'],
  'keys.body': ['Основной текст', 'Body text'],
  'plan.from': ['Доступно с тарифа {plan}', 'Available from the {plan} plan'],
  'templates.placidFonts': [
    'Не удалось загрузить шрифты: {fonts}. Слои уже ссылаются на них — загрузите файлы шрифтов в разделе «Шрифты».',
    "Couldn't fetch fonts: {fonts}. Layers already use them; upload the font files under Fonts.",
  ],
  'templates.placidImages': [
    '{n} изображений остались ссылками на хранилище Placid — их не удалось скачать.',
    "{n} images still link to Placid storage: they couldn't be downloaded.",
  ],
  'templates.placidSkipped': [
    'Пропущены неподдерживаемые элементы: {types}',
    'Skipped unsupported elements: {types}',
  ],
  'templates.badJson': ['Файл не похож на JSON', "The file isn't valid JSON"],
  'err.placidFormat': [
    'Файл не похож на экспорт шаблона Placid',
    "The file doesn't look like a Placid template export",
  ],
  'consent.title': ['Мы используем cookies', 'We use cookies'],
  'consent.text': [
    'Необходимые cookies держат вас в аккаунте. С вашего согласия мы также включим Google Analytics, чтобы понимать, как улучшать сервис. Рекламных cookies нет.',
    'Essential cookies keep you signed in. With your consent we also use Google Analytics to learn how to improve the service. No advertising cookies.',
  ],
  'consent.accept': ['Принять все', 'Accept all'],
  'consent.essentialOnly': ['Только необходимые', 'Essential only'],
  'consent.customize': ['Настроить', 'Customize'],
  'consent.save': ['Сохранить выбор', 'Save choices'],
  'consent.settingsTitle': ['Настройки cookies', 'Cookie settings'],
  'consent.settingsText': [
    'Выберите, что разрешить. Изменить решение можно в любой момент — ссылка «Настройки cookies» есть внизу сайта и в профиле.',
    'Choose what to allow. You can change it any time via “Cookie settings” in the site footer or your profile.',
  ],
  'consent.essential': ['Необходимые', 'Essential'],
  'consent.essentialText': [
    'Сессия входа, защита от подделки запросов, язык и выбранное пространство. Без них сервис не работает.',
    "Sign-in session, request forgery protection, language and selected workspace. The service can't work without them.",
  ],
  'consent.always': ['Всегда включены', 'Always on'],
  'consent.analytics': ['Аналитика (Google Analytics)', 'Analytics (Google Analytics)'],
  'consent.analyticsText': [
    'Обезличенная статистика посещений: какие страницы открывают и откуда приходят. Cookies _ga хранятся до 2 лет, данные в Google — 14 месяцев.',
    'Pseudonymous visit statistics: which pages are opened and where visitors come from. _ga cookies last up to 2 years; Google keeps the data for 14 months.',
  ],
  'consent.more': ['Подробнее —', 'More in the'],
  'consent.link': ['Настройки cookies', 'Cookie settings'],
  'privacy.title': ['Конфиденциальность и данные', 'Privacy and data'],
  'privacy.text': [
    'Скачайте копию своих данных, измените выбор cookies или удалите аккаунт.',
    'Download a copy of your data, change cookie choices or delete your account.',
  ],
  'privacy.export': ['Скачать мои данные', 'Download my data'],
  'privacy.delete': ['Удалить аккаунт', 'Delete account'],
  'privacy.deleteTitle': ['Удалить аккаунт навсегда?', 'Delete your account for good?'],
  'privacy.deleteText': [
    'Аккаунт, ваши данные и пространства, которыми пользуетесь только вы (с шаблонами и файлами), будут удалены без возможности восстановления. Сначала можно скачать копию данных.',
    'Your account, your data and the workspaces only you use (with their templates and files) will be deleted permanently. You can download a copy of your data first.',
  ],
  'privacy.deleteConfirm': ['Удалить навсегда', 'Delete for good'],
  'privacy.blocked': [
    'Сначала нужно решить вопрос с пространствами:',
    'Settle these workspaces first:',
  ],
  'privacy.blocker.transferOwnership': [
    'вы единственный владелец, а там есть участники — назначьте другого владельца',
    "you're the only owner and it has members: make someone else an owner",
  ],
  'privacy.blocker.cancelSubscription': [
    'активная подписка — отмените её в разделе «Тариф и оплата»',
    'active subscription: cancel it under Plan & billing',
  ],
  'privacy.willDelete': ['Будут удалены пространства:', 'Workspaces to be deleted:'],
  'privacy.willLeave': ['Вы покинете пространства:', "You'll leave:"],
  'privacy.typeEmail': ['Введите {email} для подтверждения', 'Type {email} to confirm'],
  'err.confirmEmail': ['Введите свой email для подтверждения', 'Type your email to confirm'],
  'brandDs.sampleQuote': [
    'Запустили 300 баннеров к распродаже за вечер — и все в нашем стиле.',
    'We shipped 300 sale banners in one evening, every one on-brand.',
  ],
  'brandDs.sampleAuthor': ['Анна Коваль', 'Anna Koval'],
  'brandDs.sampleRole': ['Арт-директор', 'Art director'],
  'brandDs.sampleDate': ['24 мая', 'May 24'],
  'brandDs.samplePlace': ['Онлайн · 19:00', 'Online · 7 pm'],
  'brandDs.sampleNew': ['Новинка', 'New'],
  'preview.fake': ['Случайные данные', 'Random data'],
  'preview.fakeRun': ['Случайно + рендер', 'Shuffle & render'],
  'preview.fakeHint': [
    'Тексты подбираются по названию слоя (price, date, team, title…), фото — бесплатные снимки Unsplash через Lorem Picsum, логотипы — DiceBear.',
    'Texts are picked by layer name (price, date, team, title…); photos are free Unsplash shots via Lorem Picsum, logos come from DiceBear.',
  ],
  'gallery.cat.sport': ['Матчи и турниры', 'Matches & tournaments'],
  'fonts.cat.all': ['Все', 'All'],
  'fonts.cat.sans-serif': ['Гротески', 'Sans'],
  'fonts.cat.serif': ['С засечками', 'Serif'],
  'fonts.cat.display': ['Акцидентные', 'Display'],
  'fonts.cat.handwriting': ['Рукописные', 'Handwriting'],
  'fonts.cat.monospace': ['Моно', 'Mono'],
  'stock.myFiles': ['Мои файлы', 'My files'],
  'stock.photos': ['Фото Unsplash', 'Unsplash photos'],
  'stock.search': ['Поиск бесплатных фото (лучше на английском)', 'Search free photos'],
  'stock.more': ['Ещё фото', 'More photos'],
  'stock.error': [
    'Не удалось загрузить фото. Попробуйте позже.',
    "Couldn't load photos. Try again later.",
  ],
  'stock.credit': [
    'Бесплатные фото для коммерческого использования, автор указывается в описании слоя. Источник:',
    'Free photos for commercial use; the author is credited in the layer description. Source:',
  ],
  'stock.idea.coffee': ['coffee', 'coffee'],
  'stock.idea.city': ['city night', 'city night'],
  'stock.idea.sport': ['football stadium', 'football stadium'],
  'stock.idea.food': ['food flat lay', 'food flat lay'],
  'stock.idea.nature': ['mountains', 'mountains'],
  'stock.idea.people': ['smiling woman', 'smiling woman'],
  'err.stockOff': [
    'Поиск фото не настроен на сервере',
    "Photo search isn't configured on the server",
  ],
  'err.stockLimit': [
    'Достигнут лимит запросов Unsplash, попробуйте позже',
    'Unsplash rate limit reached, try again later',
  ],
  'err.stockError': [
    'Unsplash вернул ошибку, попробуйте позже',
    'Unsplash returned an error, try again later',
  ],
  // motion (animation)
  'motion.mode': ['Анимация', 'Animation'],
  'motion.modeHint': [
    'Анимировать шаблон для видео, GIF и анимированных баннеров',
    'Animate the template for videos, GIFs and animated banners',
  ],
  'motion.back': ['К дизайну', 'Back to design'],
  'motion.tabDesign': ['Дизайн', 'Design'],
  'motion.tabDesignHint': [
    'Текст, шрифт, цвета и размеры слоя — прямо в анимации. Двойной клик по тексту на сцене — править его на месте',
    'The layer’s text, font, colours and size — right in the animation. Double-click a text on the stage to type into it',
  ],
  'motion.tabMotion': ['Анимация', 'Animation'],
  'motion.sceneGraphics': ['Моушн-графика сцены', 'Scene motion graphics'],
  'motion.sceneGraphicsHint': [
    'Открыть в анимации и править текст и параметры',
    'Open in the animation to edit its text and settings',
  ],
  'motion.play': ['Воспроизвести', 'Play'],
  'motion.pause': ['Пауза', 'Pause'],
  'motion.animate': ['Оживить', 'Animate'],
  'motion.animateHint': [
    'Анимирует все слои в выбранном стиле. Ручные настройки слоёв будут заменены.',
    'Animates every layer in the chosen style. Manual layer settings are replaced.',
  ],
  'motion.style': ['Стиль движения', 'Motion style'],
  'motion.clear': ['Убрать анимацию', 'Remove animation'],
  'motion.empty': [
    'Шаблон пока статичный. Выберите стиль и нажмите «Оживить» или задайте движение каждому слою.',
    'The template is static so far. Pick a style and press Animate, or set up each layer yourself.',
  ],
  'motion.video': ['Видео', 'Video'],
  'motion.duration': ['Длительность', 'Duration'],
  'motion.fps': ['Кадров/с', 'FPS'],
  'motion.loops': ['Повторы баннера', 'Banner loops'],
  'motion.forever': ['Бесконечно', 'Forever'],
  'motion.scenes': ['Сцены', 'Scenes'],
  'motion.scenesHint': [
    'Сцены показываются по очереди, как кадры HTML5-баннера. Слои без сцены видны всё время.',
    'Scenes play one after another, like the frames of an HTML5 banner. Layers without a scene stay on screen.',
  ],
  'motion.addScene': ['Добавить сцену', 'Add scene'],
  'motion.sceneN': ['Сцена {n}', 'Scene {n}'],
  'motion.transition': ['Переход', 'Transition'],
  'motion.none': ['Нет', 'None'],
  'motion.enter': ['Появление', 'Enter'],
  'motion.emphasis': ['Акцент', 'Emphasis'],
  'motion.exit': ['Исчезновение', 'Exit'],
  'motion.delay': ['Задержка', 'Delay'],
  'motion.beforeEnd': ['До конца', 'Before end'],
  'motion.length': ['Длина', 'Length'],
  'motion.easing': ['Кривая', 'Easing'],
  'motion.easingDefault': ['Как в пресете', 'Preset default'],
  'motion.repeat': ['Повторы', 'Repeats'],
  'motion.repeatHint': ['0 — до конца сцены', '0 = until the scene ends'],
  'motion.gap': ['Пауза', 'Gap'],
  'motion.split': ['Текст по частям', 'Text pieces'],
  'motion.split_none': ['Целиком', 'Whole'],
  'motion.split_line': ['Строки', 'Lines'],
  'motion.split_word': ['Слова', 'Words'],
  'motion.split_char': ['Буквы', 'Letters'],
  'motion.stagger': ['Шаг', 'Stagger'],
  'motion.order': ['Порядок', 'Order'],
  'motion.order_start': ['С начала', 'From start'],
  'motion.order_end': ['С конца', 'From end'],
  'motion.order_center': ['Из центра', 'From center'],
  'motion.order_edges': ['С краёв', 'From edges'],
  'motion.order_random': ['Вразброс', 'Random'],
  'motion.scene': ['Сцена', 'Scene'],
  'motion.wholeVideo': ['Всё видео', 'Whole video'],
  'motion.layerHint': [
    'Выберите слой в списке или на таймлайне, чтобы настроить его движение.',
    'Select a layer in the list or on the timeline to set up its motion.',
  ],
  'motion.dir_up': ['Вверх', 'Up'],
  'motion.dir_down': ['Вниз', 'Down'],
  'motion.dir_left': ['Влево', 'Left'],
  'motion.dir_right': ['Вправо', 'Right'],
  'motion.sec': ['с', 's'],
  'motion.opener': ['Начало', 'Opener'],
  'motion.layerStyle': ['Движение слоёв', 'Layer motion'],
  'motion.noOpener': ['Без опенера', 'No opener'],
  'motion.pickHint': [
    'Опенер, движение слоёв, акценты и концовка дополняют друг друга: выбор сразу применяется.',
    'The opener, layer motion, accents and ending work together; a pick applies at once.',
  ],
  'motion.openerPickHint': [
    'Графика в начале ролика, поверх вашего дизайна. Наведите, чтобы проиграть.',
    'Graphics at the start of the video, over your design. Hover to play.',
  ],
  'motion.stylePickHint': [
    'Как появляются и живут слои вашего дизайна. Наведите, чтобы проиграть.',
    'How the layers of your design enter and move. Hover to play.',
  ],
  'motion.outro': ['Концовка', 'Ending'],
  'motion.noOutro': ['Без концовки', 'No ending'],
  'motion.outroPickHint': [
    'Чем заканчивается ролик: карточка с призывом, фокус на предложении, петля. Наведите, чтобы проиграть.',
    'How the video ends: an end card, a focus on the offer, a loop. Hover to play.',
  ],
  'motion.accents': ['Акценты', 'Accents'],
  'motion.accentsHint': [
    'Моменты в середине ролика, привязанные к элементам. Без нужного элемента акцент ничего не делает.',
    'Moments in the middle of the video, tied to elements. Without its element an accent does nothing.',
  ],
  'motion.customBadge': ['Ваш', 'Yours'],
  'motion.deletePresetTitle': ['Удалить пресет?', 'Delete the preset?'],
  'motion.deletePresetText': [
    'Пресет исчезнет из списков. Шаблоны, которые уже анимированы им, не изменятся: у них своя копия.',
    'The preset leaves the lists. Templates already animated with it stay as they are: they keep their own copy.',
  ],
  'motion.soundBarHint': [
    'Тяните, чтобы сдвинуть; края — обрезать начало и конец; с Shift — сдвинуть звук внутри отрезка; Alt — без привязки к долям',
    'Drag to move; edges trim the start and the end; with Shift the sound slides inside the part; Alt ignores the beat',
  ],
  'motion.splitSound': ['Разрезать', 'Cut'],
  'motion.splitSoundHint': ['Разрезать звук по плейхеду (S)', 'Cut the sound at the playhead (S)'],
  'motion.splitSoundOutside': [
    'Поставьте плейхед внутрь выбранного звука',
    'Put the playhead inside the picked sound',
  ],
  'motion.removeSound': ['Удалить звук', 'Remove the sound'],
  'motion.oneScene': ['одна', 'one'],
  'admin.settings': ['Настройки', 'Settings'],
  'admin.settingsSaved': ['Сохранено', 'Saved'],
  'backup.tab': ['Перенос сервера', 'Server move'],
  'backup.exportTitle': ['Скачать бэкап', 'Download a backup'],
  'backup.exportText': [
    'Один ZIP со всей базой (пользователи, пространства, шаблоны, автоматизации, интеграции, история) и всеми файлами. Загрузите его в админке нового сервера.',
    'One ZIP with the whole database (users, workspaces, templates, automations, integrations, history) and every file. Upload it in the admin panel of the new server.',
  ],
  'backup.includeFiles': [
    'С файлами (снимите, если оба сервера используют одно S3-хранилище)',
    'With files (untick when both servers use the same S3 storage)',
  ],
  'backup.download': ['Скачать бэкап', 'Download backup'],
  'backup.importTitle': ['Восстановить из бэкапа', 'Restore from a backup'],
  'backup.importText': [
    'Заменяет все данные этого сервера данными из бэкапа. Версия Bannermatic и ENCRYPTION_KEY должны совпадать со старым сервером. Аккаунты и сессии переезжают вместе с базой.',
    'Replaces all data on this server with the backup. The Bannermatic version and ENCRYPTION_KEY must match the old server. Accounts and sessions move with the database.',
  ],
  'backup.chooseFile': ['Выбрать ZIP', 'Choose the ZIP'],
  'backup.restore': ['Восстановить', 'Restore'],
  'backup.confirmTitle': ['Заменить все данные этого сервера?', 'Replace all data on this server?'],
  'backup.confirmText': [
    'Все пользователи, шаблоны и настройки здесь будут заменены данными из бэкапа. Отменить это нельзя.',
    'Every user, template and setting here is replaced by the backup. This can’t be undone.',
  ],
  'backup.keyHint': [
    'ENCRYPTION_KEY здесь другой: подключённые Google-аккаунты, S3 и другие секреты не откроются. Лучше скопируйте ENCRYPTION_KEY со старого сервера и перезапустите этот.',
    'ENCRYPTION_KEY differs here: connected Google accounts, S3 and other secrets won’t open. Better copy ENCRYPTION_KEY from the old server and restart this one.',
  ],
  'backup.ignoreKey': [
    'Всё равно восстановить (интеграции придётся подключить заново)',
    'Restore anyway (integrations will need connecting again)',
  ],
  'backup.restored': [
    'Восстановлено: пользователей {users}, файлов {files}. Если попросит войти — используйте аккаунт со старого сервера.',
    'Restored: {users} users, {files} files. If asked to sign in, use your account from the old server.',
  ],
  'err.backupInvalid': ['Это не бэкап Bannermatic.', 'This is not a Bannermatic backup.'],
  'err.backupVersion': [
    'Бэкап сделан другой версией Bannermatic. Сначала обновите оба сервера до одной версии.',
    'The backup comes from another version of Bannermatic. Update both servers to the same version first.',
  ],
  'err.backupKey': [
    'ENCRYPTION_KEY отличается от старого сервера.',
    'ENCRYPTION_KEY differs from the old server.',
  ],
  'admin.serverVideo': ['Рендер видео на сервере', 'Video rendering on the server'],
  'admin.serverVideoPlans': [
    'Тарифы, которым можно рендерить видео на сервере',
    'Plans that may render videos on the server',
  ],
  'admin.serverVideoPlansHint': [
    'Остальные тарифы делают видео только в браузере пользователя, даже если рендер на сервере включён.',
    'Other plans render videos in the user’s browser only, even with server rendering on.',
  ],
  'admin.serverVideoOffHint': [
    'Выключено для всех. Видео (MP4, WebM, GIF) рендерятся только на компьютере пользователя в редакторе. API и автоматизации с видеоформатами получают ошибку, картинки работают как обычно.',
    "Off for everyone. Videos (MP4, WebM, GIF) are rendered only on the user's computer in the editor. API calls and automations with video formats get an error; images work as usual.",
  ],
  'admin.serverVideoOnHint': [
    'Включено для всех. Видео рендерятся на ваших серверах: из редактора, API и автоматизаций. Один ролик 5 с 1080×1080 занимает около 20 vCPU·с.',
    'On for everyone. Videos are rendered on your servers from the editor, the API and automations. One 5 s 1080×1080 clip takes about 20 vCPU·s.',
  ],
  'browserRender.serverOffNoDevice': [
    'Видео сейчас рендерятся только на компьютере пользователя, а этот браузер так не умеет. Откройте редактор в Chrome или Edge на компьютере.',
    "Videos are rendered only on the user's computer for now, and this browser can't do it. Open the editor in Chrome or Edge on a computer.",
  ],
  'automation.serverVideoOff': [
    'Видеоформаты недоступны: рендер видео на сервере сейчас выключен. Видео можно сделать в редакторе кнопкой «Сгенерировать».',
    'Video formats are unavailable: video rendering on the server is off for now. Make videos in the editor with Generate.',
  ],
  'err.serverVideoOff': [
    'Рендер видео на сервере выключен. Сделайте видео в редакторе: «Сгенерировать» → на этом компьютере.',
    'Video rendering on the server is turned off. Make the video in the editor: Generate → on this computer.',
  ],
  'resize.videoFormats': ['Форматы для соцсетей', 'Social formats'],
  'motion.easingHint': [
    'Как меняется скорость движения: по горизонтали время, по вертикали путь. Наведите, чтобы увидеть.',
    'How the speed changes over the move: time runs across, distance goes up. Hover to see it move.',
  ],
  'video.galleryHint': [
    'Готовые рекламные ролики со сценами, переходами и монтажом. Наведите на карточку, чтобы посмотреть, выберите формат и замените фото и тексты на свои.',
    'Ready-made ad videos with scenes, transitions and editing. Hover a card to watch it, pick a format and swap in your photos and texts.',
  ],
  'video.hoverToPlay': ['Наведите, чтобы проиграть', 'Hover to play'],
  'video.cat.basic': ['Базовые структуры', 'Basic structures'],
  'video.cat.sale': ['Распродажи', 'Sales'],
  'video.cat.product': ['Товар', 'Product'],
  'video.cat.fashion': ['Мода', 'Fashion'],
  'video.cat.food': ['Еда', 'Food'],
  'video.cat.realestate': ['Недвижимость', 'Real estate'],
  'video.cat.travel': ['Путешествия', 'Travel'],
  'video.cat.fitness': ['Фитнес', 'Fitness'],
  'video.cat.event': ['События', 'Events'],
  'video.cat.tech': ['Приложения и IT', 'Apps and tech'],
  'video.cat.beauty': ['Красота', 'Beauty'],
  'video.cat.auto': ['Авто', 'Auto'],
  'video.cat.hiring': ['Вакансии', 'Hiring'],
  'video.cat.holiday': ['Праздники', 'Holidays'],
  'video.cat.social': ['Соцсети и отзывы', 'Social and reviews'],
  'video.cat.motion': ['Моушн-дизайн', 'Motion design'],
  'api.videoHelp': [
    'ролики и анимированные шаблоны (рендер дольше, удобнее с ?wait=false и webhook_url). В слой с фото можно передать ссылку на видео .mp4/.mov/.webm, обрезка: video_start, video_end (сек), video_speed, video_muted.',
    'videos and animated templates (renders take longer: use ?wait=false and webhook_url). An image layer accepts a .mp4/.mov/.webm link to play a clip; trim with video_start, video_end (s), video_speed, video_muted.',
  ],
  'api.motionStyleHelp': [
    'анимировать шаблон стилем (smooth, energetic, elegant, kinetic, sale…); без него используется анимация шаблона.',
    "animate the template with a style (smooth, energetic, elegant, kinetic, sale…); without it the template's own animation is used.",
  ],
  'api.soundHelp': [
    'музыка и озвучка ролика: ссылка на файл, null, чтобы убрать, или { url, volume, start, fade_out }.',
    "the video's music and voice-over: a file link, null to remove, or { url, volume, start, fade_out }.",
  ],
  'automation.videoFormatsHint': [
    'MP4, WEBM и GIF рендерят ролики и анимацию. Статичный шаблон получит плавную анимацию автоматически.',
    'MP4, WEBM and GIF render videos and animations. A still template gets a smooth animation automatically.',
  ],
  'motion.zoom': ['Масштаб таймлайна', 'Timeline zoom'],
  'motion.zoomIn': ['Приблизить', 'Zoom in'],
  'motion.zoomOut': ['Отдалить', 'Zoom out'],
  'motion.zoomFit': ['Весь ролик', 'Whole video'],
  'motion.zoomHint': [
    'Масштаб: Ctrl + колесо мыши. Сдвиг вбок: Shift + колесо',
    'Zoom: Ctrl + mouse wheel. Scroll sideways: Shift + wheel',
  ],
  'templates.filterBanners': ['Баннеры', 'Banners'],
  'templates.filterVideos': ['Ролики', 'Videos'],
  'templates.kindVideo': ['Ролик', 'Video'],
  'templates.kindAnimated': ['Анимация', 'Animated'],
  'templates.scenes': ['сцен: {n}', '{n} scenes'],
  'story.openHint': [
    'Клик: перейти к сцене. Двойной клик или карандаш: открыть её в дизайне',
    'Click: go to the scene. Double click or the pencil: open it in the design',
  ],
  'story.editDesign': ['Изменить дизайн сцены', 'Edit scene design'],
  'sound.micInsecure': [
    'Браузер даёт микрофон только сайтам на https или localhost. Откройте редактор по https-адресу.',
    'Browsers give the microphone only to https sites or localhost. Open the editor over https.',
  ],
  'sound.micMissing': [
    'Микрофон не найден. Подключите его и попробуйте ещё раз.',
    'No microphone found. Plug one in and try again.',
  ],
  'video.new': ['Новый ролик', 'New video'],
  'video.fmt.vertical': ['Reels, TikTok, Shorts', 'Reels, TikTok, Shorts'],
  'video.fmt.portrait': ['Лента, 4:5', 'Feed, 4:5'],
  'video.fmt.square': ['Квадрат', 'Square'],
  'video.fmt.wide': ['YouTube, сайт', 'YouTube, website'],
  'video.recipe.sale': ['Распродажа', 'Sale'],
  'video.recipe.saleHint': [
    'Крючок, товар, цена со скидкой, призыв',
    'Hook, product, discounted price, call to action',
  ],
  'video.recipe.launch': ['Новинка', 'Launch'],
  'video.recipe.launchHint': [
    'Крючок, товар, три выгоды, призыв',
    'Hook, product, three benefits, call to action',
  ],
  'video.recipe.review': ['Отзыв', 'Review'],
  'video.recipe.reviewHint': [
    'Цитата покупателя, товар, выгоды, призыв',
    'Customer quote, product, benefits, call to action',
  ],
  'video.recipe.event': ['Анонс', 'Event'],
  'video.recipe.eventHint': [
    'Крючок, дата и место, что будет, призыв',
    'Hook, date and place, what to expect, call to action',
  ],
  'video.scene.hook': ['Крючок', 'Hook'],
  'video.scene.product': ['Товар', 'Product'],
  'video.scene.offer': ['Цена', 'Offer'],
  'video.scene.benefits': ['Выгоды', 'Benefits'],
  'video.scene.quote': ['Отзыв', 'Quote'],
  'video.scene.when': ['Когда и где', 'When and where'],
  'video.scene.cta': ['Призыв', 'Call to action'],
  'video.txt.hook.sale': ['Только 3 дня!', 'Only 3 days!'],
  'video.txt.hook.launch': ['Встречайте новинку', 'Meet the new one'],
  'video.txt.hook.event': ['Не пропустите!', "Don't miss it!"],
  'video.txt.product': ['Название товара', 'Product name'],
  'video.txt.oldPrice': ['5 990 ₽', '$59'],
  'video.txt.price': ['2 990 ₽', '$29'],
  'video.txt.benefit1': ['Бесплатная доставка', 'Free delivery'],
  'video.txt.benefit2': ['Лёгкий возврат', 'Easy returns'],
  'video.txt.benefit3': ['Нас выбрали 10 000+ клиентов', 'Loved by 10,000+ customers'],
  'video.txt.quote': ['«Лучшая покупка года»', '“Best purchase of the year”'],
  'video.txt.author': ['Анна, покупатель', 'Anna, verified buyer'],
  'video.txt.date': ['12 июня · 19:00', 'June 12 · 7 pm'],
  'video.txt.place': ['Онлайн', 'Online'],
  'video.txt.cta.sale': ['Купить со скидкой', 'Shop the sale'],
  'video.txt.cta.launch': ['Узнать больше', 'Learn more'],
  'video.txt.cta.review': ['Попробовать', 'Try it'],
  'video.txt.cta.event': ['Зарегистрироваться', 'Register'],
  'safe.hint': [
    'Безопасные зоны: где приложение закрывает видео кнопками и подписью',
    'Safe zones: where the app covers the video with its buttons and caption',
  ],
  'safe.off': ['Без зон', 'No zones'],
  'safe.zone': ['Зоны {app}', '{app} zones'],
  'sound.title': ['Голос и звуки', 'Voice and sounds'],
  'sound.record': ['Записать голос', 'Record voice'],
  'sound.stop': ['Стоп', 'Stop'],
  'sound.upload': ['Загрузить аудио', 'Upload audio'],
  'sound.hint': [
    'Закадровый голос, эффекты, вторая мелодия. Встают с позиции курсора, музыка приглушается под голос.',
    'Voice-over, effects, a second tune. They start at the playhead; the music dips under the voice.',
  ],
  'sound.recordingHint': [
    'Идёт запись под видео. Лучше в наушниках, чтобы микрофон не ловил музыку.',
    'Recording along with the video. Headphones help keep the music out of the mic.',
  ],
  'sound.micDenied': [
    'Нет доступа к микрофону. Нажмите на значок замка слева от адреса сайта, разрешите микрофон и попробуйте ещё раз.',
    'No access to the microphone. Click the lock icon left of the site address, allow the microphone and try again.',
  ],
  'sound.start': ['Начало', 'Start'],
  'sound.here': ['К курсору', 'At playhead'],
  'sound.toPlayhead': ['Поставить начало на позицию курсора', 'Start it at the playhead'],
  'sound.duck': ['Музыка под голосом', 'Music under voice'],
  'sound.kind.voice': ['Голос', 'Voice'],
  'sound.kind.music': ['Музыка', 'Music'],
  'sound.kind.sfx': ['Эффект', 'Effect'],
  'editor.videoSpeed': ['Скорость', 'Speed'],
  'editor.videoFitScene': ['Сцена по длине клипа ({s} с)', 'Fit the scene to the clip ({s} s)'],
  'story.title': ['Раскадровка', 'Storyboard'],
  'story.emptyHint': [
    'Разбейте ролик на сцены: крючок, товар, выгоды, оффер, призыв.',
    'Split the video into scenes: hook, product, benefits, offer, call to action.',
  ],
  'story.make': ['Разбить на сцены', 'Split into scenes'],
  'story.add': ['Сцена', 'Scene'],
  'story.split': ['Разрезать здесь', 'Cut here'],
  'story.addAfter': ['Новая сцена после этой', 'New scene after this one'],
  'story.moveEarlier': ['Переместить раньше', 'Move earlier'],
  'story.moveLater': ['Переместить позже', 'Move later'],
  'story.cut': ['Склейка', 'Cut'],
  'story.toAll': ['Показывать во всех сценах', 'Show in every scene'],
  'story.toScene': [
    'Во всех сценах. Нажмите, чтобы оставить только в этой',
    'In every scene. Click to keep it in this one only',
  ],
  'err.browserRenderPlan': [
    'Рендер на своём компьютере недоступен на этом тарифе.',
    'Rendering on your computer is not available on this plan.',
  ],
  'billing.fVideo': [
    'Видео: {n} мин в месяц ({m} мин на вашем компьютере)',
    'Video: {n} min per month ({m} min on your computer)',
  ],
  'billing.videoPeriod': ['Видео в текущем периоде', 'Video this period'],
  'billing.videoMin': ['{n} мин', '{n} min'],
  'err.videoLimit': [
    'Месячный лимит видео исчерпан ({used} из {limit} с на тарифе {plan}). Рендер на вашем компьютере расходует лимит в 4 раза медленнее.',
    'You’ve used this month’s video allowance ({used} of {limit} s on the {plan} plan). Rendering on your computer uses it 4× slower.',
  ],
  'browserRender.optionHint': [
    'Видео рисуется и кодируется в вашем браузере. Расходует в 4 раза меньше лимита видео, чем рендер на сервере.',
    'The video is drawn and encoded in your browser. It uses a quarter of the video allowance a server render does.',
  ],
  'preview.deviceFree': [
    'Дешевле: рендер на вашем компьютере расходует в 4 раза меньше лимита видео.',
    'Cheaper: rendering on your computer uses a quarter of the video allowance.',
  ],
  'videoGen.title': ['Ролик из вашего контента', 'Video from your content'],
  'videoGen.hint': [
    'свои тексты, фото и бренд — каждый раз новые ролики',
    'your texts, photos and brand — new videos every time',
  ],
  'videoGen.headline': ['Заголовок', 'Headline'],
  'videoGen.brandName': ['Название бренда или товара', 'Brand or product name'],
  'videoGen.subline': ['Подзаголовок', 'Subline'],
  'videoGen.benefits': ['Преимущества', 'Benefits'],
  'videoGen.perLine': ['По одному в строке, до 5', 'One per line, up to 5'],
  'videoGen.stats': ['Цифры', 'Numbers'],
  'videoGen.statsHint': [
    '«12k — подписчиков», по одной в строке',
    '"12k — subscribers", one per line',
  ],
  'videoGen.more': ['Оффер, цена, отзыв, кнопка', 'Offer, price, review, button'],
  'videoGen.offer': ['Оффер (−30%, 2 по цене 1)', 'Offer (−30%, 2 for 1)'],
  'videoGen.offerNote': ['Подпись к офферу', 'Offer note'],
  'videoGen.price': ['Цена', 'Price'],
  'videoGen.oldPrice': ['Старая цена', 'Old price'],
  'videoGen.quote': ['Отзыв', 'Review'],
  'videoGen.author': ['Автор отзыва', 'Review author'],
  'videoGen.cta': ['Текст кнопки', 'Button text'],
  'videoGen.site': ['Сайт или аккаунт', 'Site or handle'],
  'videoGen.brandKit': ['Брендкит', 'Brand kit'],
  'videoGen.brandKitHint': [
    'Цвета, шрифты и логотип бренда',
    'The brand’s colours, fonts and logo',
  ],
  'videoGen.noBrand': ['Без бренда — случайная палитра', 'No brand — a random palette'],
  'videoGen.logo': ['Логотип', 'Logo'],
  'videoGen.noLogo': ['Без логотипа', 'No logo'],
  'videoGen.logoBrand': ['Из брендкита', 'From the brand kit'],
  'videoGen.photos': ['Фото', 'Photos'],
  'videoGen.photosHint': [
    'выбрано {n} · из медиатеки или загрузите свои',
    '{n} selected · from the media library or upload your own',
  ],
  'videoGen.generate': ['Сгенерировать ролики', 'Generate videos'],
  'videoGen.again': ['Ещё варианты', 'More variants'],
  'videoGen.needHeadline': ['Нужен заголовок', 'A headline is needed'],
  'videoGen.variant': ['вариант {n}', 'variant {n}'],
  'browserRender.option': ['На этом компьютере (бета)', 'On this computer (beta)'],
  'browserRender.title': ['Рендер на этом компьютере', 'Rendering on this computer'],
  'browserRender.prepare': ['Готовлю сцену…', 'Preparing the scene…'],
  'browserRender.sound': ['Свожу звук…', 'Mixing the sound…'],
  'browserRender.frames': ['Кадр {n} из {total}', 'Frame {n} of {total}'],
  'browserRender.paused': [
    'Пауза: вкладка скрыта. Вернитесь на неё, и рендер продолжится.',
    'Paused: the tab is hidden. Come back to it to continue.',
  ],
  'browserRender.finish': ['Сохраняю видео…', 'Saving the video…'],
  'browserRender.keepOpen': [
    'Не закрывайте и не сворачивайте вкладку, пока идёт рендер.',
    "Don't close or minimise this tab while rendering.",
  ],
  'browserRender.speed': [
    'Скорость зависит от вашего компьютера.',
    'Speed depends on your computer.',
  ],
  'browserRender.differs': [
    'Результат может немного отличаться от рендера на сервере.',
    'The result may differ slightly from a server render.',
  ],
  'browserRender.cancelled': ['Рендер отменён', 'Render cancelled'],
  'motion.music': ['Музыка', 'Music'],
  'motion.noMusic': ['Без музыки', 'No music'],
  'motion.musicUpload': [
    'Загрузить трек (MP3, M4A, WAV, OGG, FLAC)',
    'Upload a track (MP3, M4A, WAV, OGG, FLAC)',
  ],
  'motion.musicHint': [
    'Загрузите трек, и мы найдём его темп: «Оживить» поставит движения в такт, а звук попадёт в MP4 и WEBM.',
    'Upload a track and we find its tempo: Animate puts moves on the beat, and the sound goes into MP4 and WEBM.',
  ],
  'motion.musicStart': ['Отступ в треке', 'Song offset'],
  'motion.musicAt': ['Начало', 'Start'],
  'motion.musicAtHint': [
    'Когда музыка начинает играть в ролике',
    'When the music starts playing in the video',
  ],
  'motion.musicLength': ['Длина', 'Length'],
  'motion.musicLengthHint': [
    'Сколько играет музыка. До конца ролика — продлевается вместе с роликом',
    'How long the music plays. Up to the end of the video: it grows with the video',
  ],
  'motion.bpmHint': [
    'Темп трека, ударов в минуту. Найден автоматически, можно поправить; 0 отключает сетку.',
    'Tempo of the track in beats per minute. Found automatically, can be corrected; 0 turns the grid off.',
  ],
  'motion.fadeIn': ['Появление', 'Fade in'],
  'motion.fadeOut': ['Затухание', 'Fade out'],
  'motion.beatSync': ['«Оживить» в такт музыке', 'Animate on the beat'],
  'motion.syncNow': ['Подогнать под бит', 'Snap to the beat'],
  'motion.noBeat': [
    'У трека не нашлось ровного ритма. Укажите BPM вручную, если он есть.',
    'No steady beat found in the track. Enter the BPM by hand if it has one.',
  ],
  'err.audioUnreadable': [
    'Не получилось прочитать аудио: загрузите MP3, M4A, WAV, OGG или FLAC.',
    'Could not read the audio: upload an MP3, M4A, WAV, OGG or FLAC file.',
  ],
  'motion.beats': ['Биты', 'Beats'],
  'motion.keys': ['Ключевые кадры', 'Key frames'],
  'motion.keysHint': [
    'Поставьте плейхед, перетащите слой на сцене, и кадр запишется. Перетащите в другой момент, и слой поедет между ними.',
    'Set the playhead and drag the layer on the stage to record a key. Drag it again at another moment and the layer moves between them.',
  ],
  'motion.keyScale': ['Масштаб', 'Scale'],
  'motion.keyRotate': ['Поворот', 'Rotate'],
  'motion.keyOpacity': ['Видимость', 'Opacity'],
  'motion.keyEasing': ['До следующего', 'To next'],
  'motion.keyDelete': ['Удалить кадр', 'Delete key'],
  'motion.keyAdd': ['Кадр здесь', 'Key here'],
  'motion.keysClear': ['Убрать все', 'Clear all'],
  'motion.openers': ['Опенеры', 'Openers'],
  'motion.styles': ['Стили движения слоёв', 'Layer motion styles'],
  'motion.fx': ['Графика', 'Motion graphics'],
  'motion.fxHint': [
    'Панели, круги, конфетти, титры и фоны поверх или под дизайном. Цвета берутся из шаблона.',
    'Panels, circles, confetti, title cards and backdrops over or under the design. Colours come from the template.',
  ],
  'motion.addFx': ['+ Добавить графику', '+ Add graphics'],
  'motion.camera': ['Камера', 'Camera'],
  'motion.cameraHint': [
    'Движения всей композиции: наезд, отъезд, тряска, панорама.',
    'Moves of the whole composition: push in, pull out, shake, pan.',
  ],
  'motion.addCamera': ['+ Добавить движение камеры', '+ Add a camera move'],
  'motion.start': ['Начало', 'Start'],
  'motion.zLayer': ['Где', 'Where'],
  'motion.zFront': ['Поверх дизайна', 'Over the design'],
  'motion.zBack': ['Под слоями (фон)', 'Under the layers (backdrop)'],
  'motion.auto': ['Автоматически', 'Automatic'],
  'motion.color_accent': ['Акцент шаблона', 'Template accent'],
  'motion.color_accent2': ['Второй акцент', 'Second accent'],
  'motion.color_dark': ['Тёмный', 'Dark'],
  'motion.color_light': ['Светлый', 'Light'],
  'motion.color_ink': ['Контраст к фону', 'Contrast to background'],
  'motion.color_custom': ['Свой цвет', 'Custom colour'],
  'motion.fxcat_text': ['Титры', 'Titles'],
  'motion.fxcat_cover': ['Перекрытия', 'Covers'],
  'motion.fxcat_accent': ['Акценты', 'Accents'],
  'motion.fxcat_ambient': ['Фоны', 'Backdrops'],
  'motion.keyBlur': ['Размытие', 'Blur'],
  'sound.auto': ['Озвучить автоматически', 'Add sound effects automatically'],
  'sound.autoAgain': ['Пересчитать эффекты', 'Re-place effects'],
  'sound.autoClear': ['Убрать автоэффекты', 'Remove automatic effects'],
  'sound.autoHint': [
    'Вжух за 0,4 с до перехода, удар на склейке, тик на каждую приземлившуюся букву, печать для терминала и т. д. Ваши звуки не трогаются.',
    'Whoosh 0.4 s before a transition, a hit on a cut, a tick for each letter landing, typing for terminals and more. Your own sounds stay.',
  ],
  'sound.addSfx': ['Эффект', 'Effect'],
  'sound.generateMusic': ['Сгенерировать музыку', 'Generate music'],
  'sound.listen': ['Послушать вариант', 'Listen to a take'],
  'sound.anotherTake': ['Другой вариант', 'Another take'],
  'sound.useTake': ['В видео', 'Use it'],
  'sound.bpmAuto': ['0 — темп подбирает стиль', '0 — the style picks the tempo'],
  'sound.energy_calm': ['Спокойно', 'Calm'],
  'sound.energy_normal': ['Обычно', 'Normal'],
  'sound.energy_high': ['Мощно', 'High energy'],
  'sound.generateMusicHint': [
    'Каждый вариант — новая пьеса: тональность, грув, бас, мелодия, вступление, дроп и брейк; тарелки ложатся на склейки видео. Без авторских прав.',
    'Every take is a new piece: key, groove, bass, melody, intro, drop and breakdown; crashes land on the video cuts. Royalty-free.',
  ],
  'motion.fontAuto': ['Как у слоя или заголовка', 'As the layer or headline'],
  'motion.fontReset': ['Сбросить шрифт', 'Reset font'],
  'motion.textFx': ['Текстовый эффект', 'Text effect'],
  'motion.textFxHint': [
    'Эффект становится частью этого слоя: тот же текст, шрифт и цвет, слой просто играет по-новому. Полоса эффекта — на строке слоя в ленте.',
    "The effect becomes part of this layer: same text, font and colour, the layer just plays differently. Its bar is on the layer's row in the timeline.",
  ],
  'motion.textFxApply': ['Применить', 'Apply'],
  'motion.poster': ['Обложка (превью и картинка)', 'Cover (thumbnail and image)'],
  'motion.textFxUntilEnd': ['0 — пока слой на экране', '0 — while the layer is on screen'],
  'motion.textFxRemove': ['Убрать эффект', 'Remove the effect'],
  'motion.generator': ['Генератор движения', 'Motion generator'],
  'motion.generatorHint': [
    'Траектории, физика и шум записываются ключами от плейхеда — их можно править по одному.',
    'Paths, physics and noise are written as keys from the playhead, editable one by one.',
  ],
  'motion.genDistance': ['Размах', 'Size'],
  'motion.genAngle': ['Угол', 'Angle'],
  'motion.genGrow': ['Рост, %', 'Grow, %'],
  'motion.genCycles': ['Циклы', 'Cycles'],
  'motion.genLength': ['Длина', 'Length'],
  'motion.genDirection': ['Куда', 'Heading'],
  'motion.genOrient': ['Поворачивать по траектории', 'Turn along the path'],
  'motion.genApply': ['Записать ключи', 'Write keys'],
  'motion.repeater': ['Размножить слой', 'Repeat layer'],
  'motion.repeaterHint': [
    'Копии в сетке, по кругу, линией, спиралью или россыпью, каждая стартует чуть позже.',
    'Copies in a grid, a ring, a line, a spiral or scattered, each starting a little later.',
  ],
  'motion.repeatLayout': ['Раскладка', 'Layout'],
  'motion.repeat_grid': ['Сетка', 'Grid'],
  'motion.repeat_circle': ['Круг', 'Circle'],
  'motion.repeat_line': ['Линия', 'Line'],
  'motion.repeat_spiral': ['Спираль', 'Spiral'],
  'motion.repeat_scatter': ['Россыпь', 'Scatter'],
  'motion.repeatCount': ['Сколько', 'Count'],
  'motion.repeatCols': ['В ряд', 'Per row'],
  'motion.repeatRadius': ['Радиус', 'Radius'],
  'motion.repeatAngle': ['Угол', 'Angle'],
  'motion.repeatGap': ['Зазор', 'Gap'],
  'motion.repeatStagger': ['Шаг', 'Stagger'],
  'motion.repeatRotate': ['Поворот', 'Turn'],
  'motion.repeatScale': ['Размер', 'Size'],
  'motion.repeatOpacity': ['Прозрачн.', 'Opacity'],
  'motion.repeatOrient': ['Поворачивать наружу', 'Face outwards'],
  'motion.repeatApply': ['Создать копии ({n})', 'Create copies ({n})'],
  'motion.fxcat_interface': ['Интерфейс и данные', 'Interface and data'],
  'motion.fxcat_pattern': ['Паттерны и частицы', 'Patterns and particles'],
  'motion.cost': [
    'Видео рендерится дольше картинки, обычно 10–30 секунд.',
    'Videos take longer than images, usually 10–30 seconds.',
  ],
} as const satisfies Record<string, readonly [string, string]>;

export type MessageKey = keyof typeof messages;
